unit View.Aliado.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls,
  UHelperServer, System.StrUtils, UConstantes, WEBLib.Lists, WEBLib.Grids,
  Grid.Plugins, WEBLib.WebCtrls, Web, WEBLib.JSON, View.Main, UUtils,
  UWeb.Enum,
  DateUtils, UExportacoes, DB;

type
  TFViewAliadoEdit = class(TForm)
    DataSource: TDatasource;
    btCancel: TButton;
    lbId: TLabel;
    edId: TDBEdit;
    lbRazao_Social: TLabel;
    edRazao_Social: TDBEdit;
    lbNome_Fantasia: TLabel;
    edNome_Fantasia: TDBEdit;
    lbCNPJ: TLabel;
    edCNPJ: TDBEdit;
    lbCodigo_Interno: TLabel;
    edCodigo_Interno: TDBEdit;
    lbStatus: TLabel;
    edStatus: TDBEdit;
    lbsegmento_nome: TLabel;
    edsegmento_nome: TDBEdit;
    lbTelefone_Principal: TLabel;
    edTelefone_Principal: TDBEdit;
    lbCEP: TLabel;
    edCEP: TDBEdit;
    cidade_nome: TLabel;
    edcidade_nome: TDBEdit;
    lbparceiro_nome: TLabel;
    edparceiro_nome: TDBEdit;
    lbExcluido: TLabel;
    lbInclusao: TLabel;
    edInclusao: TDBEdit;
    lbAlteracao: TLabel;
    edAlteracao: TDBEdit;
    lbExclusao: TLabel;
    edExclusao: TDBEdit;
    lbCadastro: TLabel;
    edCadastro: TDBEdit;
    XDataClientAliadoGet: TXDataWebClient;
    AliadoDataset: TXDataWebDataSet;
    AliadoDatasetId: TIntegerField;
    AliadoDatasetRazao_Social: TStringField;
    AliadoDatasetNome_Fantasia: TStringField;
    AliadoDatasetCNPJ: TStringField;
    AliadoDatasetCodigo_Interno: TIntegerField;
    AliadoDatasetStatus: TIntegerField;
    AliadoDatasetSegmento_ID: TIntegerField;
    AliadoDatasetTelefone_Principal: TStringField;
    AliadoDatasetCEP: TStringField;
    AliadoDatasetEndereco: TStringField;
    AliadoDatasetEndereco_Numero: TStringField;
    AliadoDatasetBairro: TStringField;
    AliadoDatasetCidade_ID: TIntegerField;
    AliadoDatasetComplemento_Endereco: TStringField;
    AliadoDatasetsincronizar_dados: TBooleanField;
    AliadoDatasetparceiro_id: TIntegerField;
    AliadoDatasetExcluido: TBooleanField;
    AliadoDatasetInclusao: TDateTimeField;
    AliadoDatasetAlteracao: TDateTimeField;
    AliadoDatasetExclusao: TDateTimeField;
    AliadoDatasetCadastro: TDateField;
    AliadoDatasetobservacoes: TStringField;
    lbObservacoes: TLabel;
    edObservacoes: TDBEdit;
    lbEnderecoCompleto: TLabel;
    edEnderecoCompleto: TEdit;
    cbxexcluido: TDBCheckBox;
    AliadoDatasetcontrole_interno: TStringField;
    AliadoDatasetMRR: TFloatField;
    AliadoDatasetemail_principal: TStringField;
    AliadoDatasetsegmentoNome: TXDataWebDatasetField;
    AliadoDatasetcidadeNome: TXDataWebDatasetField;
    AliadoDatasetcidadeufSigla: TXDataWebDatasetField;
    pnlDadosAliado: TPanel;
    pnlSincRetServ: TPanel;
    cdsLogs: TXDataWebDataSet;
    cdsLogsid: TIntegerField;
    cdsLogsaliado_id: TIntegerField;
    cdsLogsdata_base_id: TIntegerField;
    cdsLogssincronizacao_service_id: TIntegerField;
    cdsLogsultima_sincronizacao: TDateTimeField;
    cdsLogsinicio_sincronizacao: TDateTimeField;
    cdsLogsfim_sincronizacao: TDateTimeField;
    cdsLogssincronizacao_erro: TStringField;
    cdsLogsinclusao: TDateTimeField;
    cdsLogsalteracao: TDateTimeField;
    cdsLogsultima_verificacao_retaguarda: TDateTimeField;
    cdsLogsversao_client: TStringField;
    tblLogs: TDBTableControl;
    cbPageSizeLogs: TComboBox;
    edSearchLogs: TEdit;
    dtsLogs: TDataSource;
    lbPaginationInfoLogs: TLabel;
    lcPaginatorLogs: TListControl;
    tmrConsultaLogs: TTimer;
    btnLogsTab: TButton;
    div_checkbox_rotas: THTMLDiv;
    btnDadosTab: TButton;
    btnSincronizacaoTab: TButton;
    cdsSincronizacao: TXDataWebDataSet;
    cdsSincronizacaoid: TIntegerField;
    cdsSincronizacaoaliado_id: TIntegerField;
    cdsSincronizacaosincronizacao_servicerota: TXDataWebDatasetField;
    cdsSincronizacaosincronizar_dados: TBooleanField;
    btnSalvarSincronizacao: TButton;
    cdsLogssincronizacao_servicerota: TXDataWebDatasetField;
    edtSincronizacaoErro: TEdit;
    pnlOutros: TPanel;
    pnlCertificado: TPanel;
    btnCertificado: TButton;
    cdsCertificado: TXDataWebDataSet;
    cdsCertificadoid: TIntegerField;
    cdsCertificadonumero_serie: TStringField;
    cdsCertificadodata_vencimento: TDateTimeField;
    cdsCertificadosenha: TStringField;
    cdsCertificadocertificado_s3: TStringField;
    cdsCertificadoinclusao: TDateTimeField;
    cdsCertificadoalteracao: TDateTimeField;
    lbcertificado_id: TLabel;
    edcertificado_id: TDBEdit;
    lbnumero_serie: TLabel;
    ednumero_serie: TDBEdit;
    lbdata_vencimento: TLabel;
    eddata_vencimento: TDBEdit;
    lbsenha: TLabel;
    edsenha: TDBEdit;
    lbcertificado_s3: TLabel;
    edcertificado_s3: TDBEdit;
    lbcertificado_inclusao: TLabel;
    edcertificado_inclusao: TDBEdit;
    lbcertificado_alteracao: TLabel;
    edcertificado_alteracao: TDBEdit;
    dtsCertificado: TDataSource;
    pnlTabelaDataBase: TPanel;
    cbPageSizeDataBase: TComboBox;
    edSearchDataBase: TEdit;
    lbPaginationInfoDataBase: TLabel;
    lcPaginatorDataBase: TListControl;
    tmrConsultaDataBase: TTimer;
    btnDataBaseTab: TButton;
    tblDataBase: TDBTableControl;
    cdsDataBase: TXDataWebDataSet;
    cdsDataBaseid: TIntegerField;
    cdsDataBasetoken: TStringField;
    cdsDataBasefiscal: TBooleanField;
    cdsDataBaseexcluido: TBooleanField;
    cdsDataBaseinclusao: TDateTimeField;
    cdsDataBasealteracao: TDateTimeField;
    cdsDataBaseexclusao: TDateTimeField;
    cdsDataBasenome_fantasia: TStringField;
    cdsDataBasehost: TStringField;
    cdsDataBasepath: TStringField;
    cdsDataBasedata_base_multiempresa: TBooleanField;
    cdsDataBasedata_base_empresa_destino: TBooleanField;
    cdsDataBaseversao_atual: TStringField;
    cdsDataBaseversao_pendente: TStringField;
    dtsDataBase: TDataSource;
    edtSincronizacaoObservacao: TEdit;
    cdsModulosAliado: TXDataWebDataSet;
    cdsModulosAliadoid: TIntegerField;
    cdsModulosAliadodata_base_id: TIntegerField;
    div_checkbox_modulos: THTMLDiv;
    cdsModulosAliadomodulo_id: TIntegerField;
    btnImportarCertificado: TButton;
    wfpCertificado: TFilePicker;
    btnUploadCertificado: TButton;
    lblErroCertificado: TLabel;
    cdsCertificadoaliado_id: TIntegerField;
    edtCertificadoSenha: TEdit;
    pnlRecursos: TPanel;
    btnRecursosTab: TButton;
    div_checkbox_recursos: THTMLDiv;
    cbxSincronizarDados: TCheckBox;
    btnSalvarRecursos: TButton;
    XDataClientRecursos: TXDataWebClient;
    cdsDataBaseregime_contabil: TStringField;
    XDataClientDataBase: TXDataWebClient;
    cdsDataBasedivulgar_promocoes: TBooleanField;
    edtObservacaoEdit: TEdit;
    wfpLogomarca: TFilePicker;
    imgLogoSelecionada: TImageControl;
    AliadoDatasetlogo_base64: TStringField;
    divRemoverImagem: THTMLDiv;
    edtParceiroNome: TEdit;
    btnPesquisarParceiro: TButton;
    AliadoDatasetparceironome: TStringField;
    cdsDataBaseassociar_produtos: TBooleanField;
    edtTelefoneWhatsappEdit: TEdit;
    AliadoDatasettelefone_whatsapp: TStringField;
    XDataWebClientModulosRetaguarda: TXDataWebClient;
    pnlFaturamento: TPanel;
    tblFaturamento: TDBTableControl;
    cdsFaturamento: TXDataWebDataSet;
    cdsFaturamentoid: TIntegerField;
    cdsFaturamentonome_fantasia: TStringField;
    cdsFaturamentocnpj: TStringField;
    cdsFaturamentobanco_fiscal: TIntegerField;
    cdsFaturamentomes_ano: TStringField;
    cdsFaturamentoultima_atualizacao: TDateTimeField;
    dtsFaturamento: TDataSource;
    btnFaturamentoTab: TButton;
    XDataWebClientFaturamento: TXDataWebClient;
    btnConsultarFaturamento: TButton;
    cdsDataBaseFaturamento: TXDataWebDataSet;
    cbbDataBase: TComboBox;
    cbxMovimentaEstoque: TCheckBox;
    cbxGeraFinanceiro: TCheckBox;
    cbxSimplesFaturamento: TCheckBox;
    cbxDevolucao: TCheckBox;
    cbxTransferencia: TCheckBox;
    cbxConciliacaoCupons: TCheckBox;
    edtDataInicial: TDateTimePicker;
    edtDataFinal: TDateTimePicker;
    cdsFaturamentoquantidade: TIntegerField;
    btnExportarExcel: TButton;
    cdsFaturamentovalor_total_faturamento: TFloatField;
    cdsFaturamentocaminho_data_base: TStringField;
    cbbPeriodoFaturamento: TComboBox;
    cbbTipoFaturamento: TComboBox;
    cdsFaturamentotipo_movimento: TStringField;
    lbconfig_windows: TLabel;
    AliadoDatasetconfig_windows: TStringField;
    edconfig_windows: TDBEdit;
    btnConectarAliado: TButton;
    pnlSincServRet: TPanel;
    cbbSincServRet: TComboBox;
    edtSincServRet: TEdit;
    tblSincServRet: TDBTableControl;
    cdsSincServRet: TXDataWebDataSet;
    dtsSincServRet: TDataSource;
    tmrSincServRet: TTimer;
    lbPaginationInfoSincServRet: TLabel;
    lcPaginatorSincServRet: TListControl;
    btnSincRetServidor: TButton;
    btnSincServRetaguarda: TButton;
    cdsSincServRetaliado_id: TIntegerField;
    cdsSincServRetdata_base_id: TIntegerField;
    cdsSincServRetultima_sincronizacao: TDateTimeField;
    cdsSincServRetultima_verificacao_retaguarda: TDateTimeField;
    cdsSincServRetversao_client: TStringField;
    cdsSincServRetsincronizacao_erro: TMemoField;
    cdsSincServRetinclusao: TDateTimeField;
    cdsSincServRetalteracao: TDateTimeField;
    cdsSincServRetsinc_servtabela_servidor: TStringField;
    lblQuantidadeVendas: TLabel;
    lblQuantidadeMeses: TLabel;
    lblFaturamentoTotal: TLabel;
    lblMediaFaturamento: TLabel;
    lblMediaTicketMedio: TLabel;
    cdsFaturamentoticket_medio: TFloatField;
    AliadoDatasetdata_cancelamento: TDateField;
    lbdata_cancelamento: TLabel;
    eddata_cancelamento: TDBEdit;
    lbtempo_contrato: TLabel;
    edtempo_contrato: TDBEdit;
    AliadoDatasettempo_contrato: TStringField;
    cdsDataBasecrt: TIntegerField;
    cdsDataBasecontadornome: TStringField;
    pnlConfiguracoesRet: TPanel;
    btnConfigRetaguarda: TButton;
    cbbDataBaseConfigRetaguarda: TComboBox;
    btnCarregarConfiguracoes: TButton;
    btnExportarExcelConfigRetaguarda: TButton;
    searchConfig: TEdit;
    cdsConfigRetaguarda: TXDataWebDataSet;
    cdsConfigRetaguardaconfiguracoes: TStringField;
    cdsConfigRetaguardaconfiguracao: TStringField;
    cdsConfigNfce: TXDataWebDataSet;
    cdsConfigNfceconfiguracoes: TMemoField;
    searchConfigNfce: TEdit;
    pnlConfiguracoesNfce: TPanel;
    cbbSerieCaixaNfce: TComboBox;
    btnCarregarConfiguracoesNfce: TButton;
    btnExportarExcelConfigNfce: TButton;
    btnConfigNfce: TButton;
    cdsConfigNfcealiado_id: TIntegerField;
    cdsConfigNfceserie: TIntegerField;
    cdsConfigNfcecaixa: TIntegerField;
    lbdata_ping_madrugada: TLabel;
    eddata_ping_madrugada: TDBEdit;
    AliadoDatasetdata_ping_madrugada: TDateTimeField;
    lbqtde_dias_servidor_ligado: TLabel;
    edqtde_dias_servidor_ligado: TDBEdit;
    AliadoDatasetqtde_dias_servidor_ligado: TIntegerField;
    procedure btCancelClick(Sender: TObject);
    procedure XDataClientAliadoGetLoad(Response: TXDataClientResponse);
    procedure XDataClientAliadoDeleteLoad(Response: TXDataClientResponse);
    procedure AliadoDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure btnLogsTabClick(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure btnSincronizacaoTabClick(Sender: TObject);
    procedure cdsSincronizacaoAfterOpen(DataSet: TDataSet);
    procedure btnSalvarSincronizacaoClick(Sender: TObject);
    procedure cdsSincronizacaoAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure tmrConsultaLogsTimer(Sender: TObject);
    procedure edSearchLogsKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchLogsKeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure cbPageSizeLogsChange(Sender: TObject);
    procedure tblLogsGetCellData(Sender: TObject; ACol, ARow: Integer;
      AField: TField; var AValue: string);
    procedure tblLogsGetCellClass(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; var AClassName: string);
    procedure tblLogsGetCellChildren(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure btnCertificadoClick(Sender: TObject);
    procedure cdsCertificadoAfterOpen(DataSet: TDataSet);
    procedure btnDataBaseTabClick(Sender: TObject);
    procedure cbPageSizeDataBaseChange(Sender: TObject);
    procedure edSearchDataBaseKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchDataBaseKeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure tmrConsultaDataBaseTimer(Sender: TObject);
    procedure tblDataBaseGetCellClass(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; var AClassName: string);
    procedure tblDataBaseGetCellData(Sender: TObject; ACol, ARow: Integer;
      AField: TField; var AValue: string);
    procedure tblDataBaseGetCellChildren(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure WebFormShow(Sender: TObject);
    procedure cdsModulosAliadoAfterOpen(DataSet: TDataSet);
    procedure btnImportarCertificadoClick(Sender: TObject);
    [async]
    procedure btnUploadCertificadoClick(Sender: TObject); async;
    procedure wfpCertificadoChange(Sender: TObject);
    procedure wfpCertificadoGetFileAsBase64(Sender: TObject;
      AFileIndex: Integer; ABase64: string);
    procedure cdsCertificadoAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    [async]
    procedure btnSalvarRecursosClick(Sender: TObject); async;
    procedure XDataClientRecursosError(Error: TXDataClientError);
    procedure XDataClientRecursosLoad(Response: TXDataClientResponse);
    procedure btnRecursosTabClick(Sender: TObject);
    procedure XDataClientDataBaseError(Error: TXDataClientError);
    procedure XDataClientDataBaseLoad(Response: TXDataClientResponse);
    procedure divRemoverImagemClick(Sender: TObject);
    procedure wfpLogomarcaChange(Sender: TObject);
    procedure wfpLogomarcaGetFileAsBase64(Sender: TObject; AFileIndex: Integer;
      ABase64: string);
    procedure btnPesquisarParceiroClick(Sender: TObject);
    procedure AliadoDatasetAfterOpen(DataSet: TDataSet);
    procedure AliadoDatasetCNPJGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure AliadoDatasetStatusGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure AliadoDatasetTelefone_PrincipalGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure AliadoDatasetCEPGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure AliadoDatasetparceironomeGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure AliadoDatasetcidadeNomeGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure AliadoDatasetsegmentoNomeGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure XDataWebClientModulosRetaguardaError(Error: TXDataClientError);
    procedure XDataWebClientModulosRetaguardaLoad(
      Response: TXDataClientResponse);
    procedure XDataWebClientFaturamentoError(Error: TXDataClientError);
    procedure XDataWebClientFaturamentoLoad(Response: TXDataClientResponse);
    procedure btnConsultarFaturamentoClick(Sender: TObject);
    procedure tblFaturamentoGetCellClass(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; var AClassName: string);
    procedure cdsFaturamentobanco_fiscalGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure cdsFaturamentocnpjGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure cdsFaturamentomes_anoGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure cdsDataBaseFaturamentoAfterOpen(DataSet: TDataSet);
    procedure btnFaturamentoTabClick(Sender: TObject);
    procedure btnExportarExcelClick(Sender: TObject);
    procedure cdsFaturamentoquantidadeGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure cdsFaturamentoidGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure cbbTipoFaturamentoChange(Sender: TObject);
    procedure cbbPeriodoFaturamentoChange(Sender: TObject);
    procedure AliadoDatasetconfig_windowsGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    [Async]
    procedure btnConectarAliadoClick(Sender: TObject); async;
    procedure btnSincRetServidorClick(Sender: TObject);
    procedure btnSincServRetaguardaClick(Sender: TObject);
    procedure tblSincServRetGetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string;
      AElement: TJSHTMLElementRecord);
    procedure tblSincServRetGetCellClass(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; var AClassName: string);
    procedure cdsSincServRetsincronizacao_erroGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure tmrSincServRetTimer(Sender: TObject);
    procedure edtSincServRetKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edtSincServRetKeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure cbbSincServRetChange(Sender: TObject);
    procedure cdsDataBasecrtGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure btnConfigRetaguardaClick(Sender: TObject);
    procedure btnCarregarConfiguracoesClick(Sender: TObject);
    procedure btnExportarExcelConfigRetaguardaClick(Sender: TObject);
    procedure cdsConfigRetaguardaAfterOpen(DataSet: TDataSet);
    procedure btnConfigNfceClick(Sender: TObject);
    procedure btnCarregarConfiguracoesNfceClick(Sender: TObject);
    procedure btnExportarExcelConfigNfceClick(Sender: TObject);
    procedure cdsConfigNfceAfterOpen(DataSet: TDataSet);
  private
    const
      FPrefixoCheckBoxSincronizacao = 'cbx_sincronizacao_';
      FPrefixoCheckBoxModulos = 'cbx_modulo_';
      FPrefixoCheckBoxRecursos = 'cbx_recurso_';
    var
      FId: JSValue;
      FShowListProc: TListProc;
      FGridPluginLogs,
      FGridPluginDataBase,
      FGridPluginSincServRetaguarda : TGridPlugin;
      FArraySincronizacaoAtualizacao: TJSArray;
      FCertificadoBase64 : string;
      FNovoCertificado : Boolean;
      FListaSerieCaixaNfce: TJSArray;
    procedure InsertEntity;
    procedure LoadEntity;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
    procedure SetDadosPersonalizados;
    procedure SetRecursosAliado;
    procedure CriarCheckBoxSincronizacao;
    procedure SelecionarModulosAliado;
    procedure SetErroCertificado(pErro : string);
    procedure SetDadosCertificado;
    procedure CriarCheckBoxRecursos;
    procedure DesmarcarTodosRecursos;
    procedure SetLogoMarca;
    function AlterouLogoMarca : Boolean;
    function AlterouObservacao : Boolean;
    procedure GetRecursosSelecionados(var pJson : TJSObject);
    function AlterouParceiro : Boolean;
    function AlterouTelefoneWhatsApp : Boolean;
    function ValidarTelefoneWhatsApp : Boolean;
    procedure SetPermissoesIniciais;
    procedure SetConfiguracoesFaturamento;
    function GetValorCheckBox(var pCheckBox : TCheckBox) : Integer;
    function GetJsonFaturamento(pConsulta : Boolean = True) : TJSObject;
    function ValidarConsultaFaturamento : string;
    procedure ExportarDadosExcel(pResponse: TXDataClientResponse);
    function VerificarJsonValido(const pJsonString: string): Boolean;
    procedure TratarVisualizacaoAbaLogs;
    procedure ReiniciarDadosFaturamento;
    procedure SetResumoFaturamento(pJson : TJSObject);
    procedure SetDadosFaturamento(pArray : TJSArray);
    procedure CarregarDataBase;
    procedure CarregarSerieCaixaNfce;
    procedure SetValoresComboNfce;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewAliadoEdit: TFViewAliadoEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewAliadoEdit }

procedure TFViewAliadoEdit.cdsDataBasecrtGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  if not Sender.AsString.IsEmpty then
  begin
    case Sender.AsInteger of
      1 : Text := '1 - SIMPLES NACIONAL';
      2 : Text := '2 - SIMPLES NACIONAL - EXCESSO DE SUBLIMITE DA RECEITA BRUTA';
      3 : Text := '3 - REGIME NORMAL';
      4 : Text := '4 - SIMPLES NACIONAL - MEI';
    end;
  end;
end;

procedure TFViewAliadoEdit.cdsSincServRetsincronizacao_erroGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := THelperServer.GetTextoMax100Caracteres(Sender.AsString);
end;

class function TFViewAliadoEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewAliadoEdit.CriarCheckBoxRecursos;
var
  lDivCriadaHtml,
  lIdCheckBox,
  lIdLabel : string;
  lIndice : Integer;
begin
  if TUtils.IsPerfilParceiro(TUtils.FUsuario) then
    cbxSincronizarDados.Enabled := False;

  for lIndice := Low(FRecursosDisponiveis) to High(FRecursosDisponiveis) do
  begin
    lIdCheckBox := FPrefixoCheckBoxRecursos + IntToStr(lIndice + 1);
    lIdLabel := 'lbl_recurso_' + IntToStr(lIndice + 1);
    lDivCriadaHtml := '<div class="form-check"><input class="form-check-input" '+
    'type="checkbox" value="'+IntToStr(lIndice + 1)+'" id="'+lIdCheckBox+'"/><label class="form-check-label" id="'+
      lIdLabel+'" for="'+lIdCheckBox+'">'+ FRecursosDisponiveis[lIndice]+'</label></div>';

    div_checkbox_recursos.HTML.Add(lDivCriadaHtml);
  end;
end;

procedure TFViewAliadoEdit.CriarCheckBoxSincronizacao;
var
  lIdCheckBox,
  lIdLabel,
  lDivCriadaHtml,
  lTextoCheck,
  lMarcado : string;
begin
  try
    TUtils.ChamarDivLoading;
    btnSalvarSincronizacao.Visible := False;
    div_checkbox_rotas.Visible := False;
    div_checkbox_rotas.HTML.Clear;
    cdsSincronizacao.DisableControls;
    cdsSincronizacao.First;

    while not cdsSincronizacao.Eof do
    begin
      lMarcado := '';

      if cdsSincronizacao.FieldByName('sincronizar_dados').AsBoolean then
        lMarcado := 'checked';

      lTextoCheck := cdsSincronizacao.FieldByName('sincronizacao_service.rota').AsString.Replace('_', ' ');
      lTextoCheck := AnsiProperCase(lTextoCheck, [' ']);
      lIdCheckBox := FPrefixoCheckBoxSincronizacao + cdsSincronizacao.FieldByName('id').AsString;
      lIdLabel := 'lbl_recurso_' + cdsSincronizacao.FieldByName('id').AsString;
      lDivCriadaHtml := '<div class="form-check col-md-3 col-xl-2 col-sm-6 d-flex"><input class="form-check-input" '+
      'type="checkbox" '+lMarcado+' id="'+lIdCheckBox+'"/><label class="form-check-label" id="'+
        lIdLabel+'" for="'+lIdCheckBox+'">'+lTextoCheck +'</label></div>';

      div_checkbox_rotas.HTML.Add(lDivCriadaHtml);

      cdsSincronizacao.Next;
    end;
  finally
    cdsSincronizacao.EnableControls;

    if cdsSincronizacao.RecordCount > 0 then
      btnSalvarSincronizacao.Visible := True;

    div_checkbox_rotas.Visible := True;
    TUtils.OcultarDivLoading;
  end;
end;

procedure TFViewAliadoEdit.DesmarcarTodosRecursos;
var
  lIdCheckBox : string;
  lIndice : Integer;
  lElement: TJSHTMLInputElement;
begin
  for lIndice := Low(FRecursosDisponiveis) to High(FRecursosDisponiveis) do
  begin
    lIdCheckBox := FPrefixoCheckBoxRecursos + IntToStr(lIndice + 1);

    lElement := TJSHTMLInputElement(document.getElementById(lIdCheckBox));

    if Assigned(lElement) then
      lElement.checked := False;
  end;
end;

procedure TFViewAliadoEdit.divRemoverImagemClick(Sender: TObject);
begin
  TUtils.OcultarElemento('divLogomarcaSelecionada');
  imgLogoSelecionada.URL := '';
  wfpLogomarca.Files.Clear;
end;

procedure TFViewAliadoEdit.edSearchDataBaseKeyDown(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsultaDataBase.Enabled := False;

  if Key = 13 then
  begin
    FGridPluginDataBase.SetFilterText(edSearchDataBase.Text, True);
  end;
end;

procedure TFViewAliadoEdit.edSearchDataBaseKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsultaDataBase.Interval := FTimerConsulta;
  tmrConsultaDataBase.Enabled := True;
end;

procedure TFViewAliadoEdit.edSearchLogsKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsultaLogs.Enabled := False;

  if Key = 13 then
  begin
    FGridPluginLogs.SetFilterText(edSearchLogs.Text, True);
  end;
end;

procedure TFViewAliadoEdit.edSearchLogsKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsultaLogs.Interval := FTimerConsulta;
  tmrConsultaLogs.Enabled := True;
end;

procedure TFViewAliadoEdit.edtSincServRetKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrSincServRet.Enabled := False;

  if Key = 13 then
  begin
    FGridPluginSincServRetaguarda.SetFilterText(edtSincServRet.Text, True);
  end;
end;

procedure TFViewAliadoEdit.edtSincServRetKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrSincServRet.Interval := FTimerConsulta;
  tmrSincServRet.Enabled := True;
end;

procedure TFViewAliadoEdit.ExportarDadosExcel(pResponse: TXDataClientResponse);
var
  lExportacoes : TExportacoes;
begin
  lExportacoes := TExportacoes.Create(cdsFaturamento, tblFaturamento);
  lExportacoes.ExportarExcelFaturamento(pResponse, TJSJSON.stringify(GetJsonFaturamento));
end;

function TFViewAliadoEdit.GetJsonFaturamento(pConsulta : Boolean): TJSObject;
begin
  Result := TJSObject.New;

  Result['cnpj'] := edcnpj.Text;
  Result['data_inicial'] := FormatDateTime('dd/mm/yyyy', edtDataInicial.Date);
  Result['data_final'] := FormatDateTime('dd/mm/yyyy', edtDataFinal.Date);

  if cbbDataBase.ItemIndex > 0 then
  begin
    cdsDataBaseFaturamento.RecNo := cbbDataBase.ItemIndex;
    Result['codigo_data_base'] := cdsDataBaseFaturamento.FieldByName('id').AsInteger;
  end;

  Result['movimenta_estoque'] := GetValorCheckBox(cbxMovimentaEstoque);
  Result['gera_financeiro'] := GetValorCheckBox(cbxGeraFinanceiro);
  Result['simples_faturamento'] := GetValorCheckBox(cbxSimplesFaturamento);
  Result['devolucao'] := GetValorCheckBox(cbxDevolucao);
  Result['transferencia'] := GetValorCheckBox(cbxTransferencia);
  Result['conciliacao_cupons'] := GetValorCheckBox(cbxConciliacaoCupons);
  Result['tipo_movimento'] := cbbTipoFaturamento.Text;

  if not pConsulta then
    Result['exportar_excel'] := True;
end;

procedure TFViewAliadoEdit.GetRecursosSelecionados(var pJson: TJSObject);
var
  lRecursosAliado,
  lIdCheckBox : string;
  lIndice : Integer;
  lElement: TJSHTMLInputElement;
begin
  lRecursosAliado := '';

  for lIndice := Low(FRecursosDisponiveis) to High(FRecursosDisponiveis) do
  begin
    lIdCheckBox := FPrefixoCheckBoxRecursos + IntToStr(lIndice + 1);

    lElement := TJSHTMLInputElement(document.getElementById(lIdCheckBox));

    if Assigned(lElement) and lElement.checked then
      lRecursosAliado := lRecursosAliado + lElement.value + '|';
  end;

  if lRecursosAliado = '' then
    pJson['controle_interno'] := JSValue(null)
  else
    pJson['controle_interno'] := Copy(lRecursosAliado, 1, Length(lRecursosAliado) - 1);
end;

function TFViewAliadoEdit.GetValorCheckBox(var pCheckBox: TCheckBox): Integer;
begin
  Result := 0;

  if pCheckBox.Checked then
    Result := 1;
end;

procedure TFViewAliadoEdit.SetRecursosAliado;
var
  lRecursosAliado : TArray<string>;
  lIndice : Integer;
  lIdCheckBox : string;
  lElement: TJSHTMLInputElement;
begin
  cbxSincronizarDados.Checked := AliadoDataset.FieldByName('sincronizar_dados').AsBoolean;

  lRecursosAliado := SplitString(AliadoDataset.FieldByName('controle_interno').AsString, '|');

  for lIndice := Low(lRecursosAliado) to High(lRecursosAliado) do
  begin
    lIdCheckBox := FPrefixoCheckBoxRecursos + lRecursosAliado[lIndice];
    lElement := TJSHTMLInputElement(document.getElementById(lIdCheckBox));

    if Assigned(lElement) then
      lElement.checked := True;
  end;
end;

procedure TFViewAliadoEdit.SetResumoFaturamento(pJson: TJSObject);
begin
  lblQuantidadeVendas.Caption := TUtils.FormatarNumeroInteiro(Integer(pJson['quantidade_vendas']));
  lblQuantidadeMeses.Caption := TUtils.FormatarNumeroInteiro(Integer(pJson['quantidade_meses']));
  lblFaturamentoTotal.Caption := string(pJson['faturamento_total']);
  lblMediaFaturamento.Caption := string(pJson['media_faturamento']);
  lblMediaTicketMedio.Caption := string(pJson['media_ticket_medio']);
end;

procedure TFViewAliadoEdit.SetValoresComboNfce;
var
  lNome : string;
  lPar: TJSObject;
begin
  cbbSerieCaixaNfce.Items.Clear;
  FListaSerieCaixaNfce := TJSArray.New;
  cdsConfigNfce.First;

  while not cdsConfigNfce.Eof do
  begin
    lNome := 'SÉRIE: ' + cdsConfigNfce.FieldByName('serie').AsString + ' - CAIXA: ' +
      cdsConfigNfce.FieldByName('caixa').AsString;

    cbbSerieCaixaNfce.Items.Add(lNome);

    lPar := TJSObject.New;
    lPar['serie'] := cdsConfigNfce.FieldByName('serie').AsInteger;
    lPar['caixa'] := cdsConfigNfce.FieldByName('caixa').AsInteger;
    FListaSerieCaixaNfce.push(lPar);

    cdsConfigNfce.Next;
  end;

  cbbSerieCaixaNfce.ItemIndex := -1;
end;

procedure TFViewAliadoEdit.tblSincServRetGetCellClass(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(tblSincServRet.Columns[ACol].DataField, ['sincronizacao_erro', 'versao_client',
      'sinc_serv.tabela_servidor']) of
      0, 1, 2: AClassName := 'text-start';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewAliadoEdit.InsertEntity;
begin
  AliadoDataset.Close;
  AliadoDataset.SetJsonData('{}');
  AliadoDataset.Open;
  AliadoDataset.Insert;
end;

class function TFViewAliadoEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewAliadoEdit(AForm).FInserting := AInserting;
    TFViewAliadoEdit(AForm).FId := AId;
    TFViewAliadoEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewAliadoEdit(AForm).InsertEntity
    else
      TFViewAliadoEdit(AForm).LoadEntity;
  end;

begin
  Application.CreateForm(TFViewAliadoEdit, AElementID, Result, @AfterCreate);
end;

function TFViewAliadoEdit.VerificarJsonValido(const pJsonString: string): Boolean;
begin
   asm
    try {
      JSON.parse(pJsonString);
      return true;
    } catch (e) {
      return false;
    }
  end;
end;

procedure TFViewAliadoEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    AliadoDataset.Connection.Model.DefaultSchema.FindEntityType(
      AliadoDataset.EntitySetName
    )
  );
  XDataClientAliadoGet.Get(AliadoDataset.EntitySetName, QueryString + ',cidade/uf', FId);
end;

procedure TFViewAliadoEdit.ReiniciarDadosFaturamento;
begin
  cdsFaturamento.Close;
  cdsFaturamento.Open;

  lblQuantidadeVendas.Caption := '-';
  lblQuantidadeMeses.Caption := '-';
  lblFaturamentoTotal.Caption := '-';
  lblMediaFaturamento.Caption := '-';
  lblMediaTicketMedio.Caption := '-';
end;

procedure TFViewAliadoEdit.SelecionarModulosAliado;
var
  lIdCheckBox : string;
  lDiv: TJSHTMLElement;
  lInput: TJSHTMLInputElement;
  lIndice : Integer;
  lInputs: TJSNodeList;
begin
  try
    lDiv := TJSHTMLElement(Document.getElementById('div_checkbox_modulos'));

    lInputs := lDiv.querySelectorAll('input[type=checkbox]');

    for lIndice := 0 to lInputs.length - 1 do
    begin
      lInput := TJSHTMLInputElement(lInputs.item(lIndice));
      lIdCheckBox := lInput.id.Replace(FPrefixoCheckBoxModulos, '');
      lInput.checked := cdsModulosAliado.Locate('modulo_id', lIdCheckBox, []);
      lInput.disabled := True;
    end;
  finally
    TUtils.OcultarDivLoading;

      asm
        $('#modal_modulos_aliado').modal('show');
      end;
  end;
end;

procedure TFViewAliadoEdit.SetConfiguracoesFaturamento;
begin
  cbbPeriodoFaturamento.Items.Clear;
  cbbPeriodoFaturamento.Items.Add('Mês Atual');
  cbbPeriodoFaturamento.Items.Add('Últimos 3 Meses');
  cbbPeriodoFaturamento.Items.Add('Últimos 6 Meses');
  cbbPeriodoFaturamento.Items.Add('Últimos 12 Meses');
  cbbPeriodoFaturamento.Items.Add('Este Ano');
  cbbPeriodoFaturamento.Items.Add('Personalizado');

  cbbPeriodoFaturamento.ItemIndex := 3;

  edtDataFinal.Max := EndOfTheYear(Date);
  edtDataInicial.Min := StartOfTheMonth(IncMonth(Date, -13));

  cbbPeriodoFaturamentoChange(cbbPeriodoFaturamento);
  cdsFaturamento.Open;
end;

procedure TFViewAliadoEdit.SetDadosCertificado;
begin
  if FNovoCertificado then
  begin
    cdsCertificado.Append;
    cdsCertificado.FieldByName('aliado_id').AsInteger := StrToInt(edId.Text);
  end
  else
    cdsCertificado.Edit;

  cdsCertificado.FieldByName('numero_serie').Value := null;
  cdsCertificado.FieldByName('data_vencimento').Value := null;
  cdsCertificado.FieldByName('senha').AsString := edtCertificadoSenha.Text;
  cdsCertificado.FieldByName('certificado_s3').AsString := FCertificadoBase64;

  cdsCertificado.Post;
  cdsCertificado.ApplyUpdates;
end;

procedure TFViewAliadoEdit.SetDadosFaturamento(pArray: TJSArray);
var
  lIndice : Integer;
  lJsonObject: TJSObject;
  lValor : string;
begin
  for lIndice := 0 to pArray.Length - 1 do
  begin
    lJsonObject := TJSObject(pArray[lIndice]);

    cdsFaturamento.Append;
    cdsFaturamento.FieldByName('id').AsInteger := Integer(lJsonObject['id']);
    cdsFaturamento.FieldByName('nome_fantasia').AsString := String(lJsonObject['nome_fantasia']);
    cdsFaturamento.FieldByName('cnpj').AsString := String(lJsonObject['cnpj']);
    cdsFaturamento.FieldByName('banco_fiscal').AsInteger := Integer(lJsonObject['banco_fiscal']);
    cdsFaturamento.FieldByName('mes_ano').AsString := String(lJsonObject['mes_ano']);
    lValor := String(lJsonObject['valor_total_faturamento']);
    cdsFaturamento.FieldByName('valor_total_faturamento').AsFloat := StrToFloat(lValor);
    cdsFaturamento.FieldByName('ultima_atualizacao').AsDateTime := StrToDateTime(String(lJsonObject['ultima_atualizacao']));
    cdsFaturamento.FieldByName('quantidade').AsInteger := Integer(lJsonObject['quantidade']);
    cdsFaturamento.FieldByName('caminho_data_base').AsString := String(lJsonObject['caminho_data_base']);
    cdsFaturamento.FieldByName('tipo_movimento').AsString := String(lJsonObject['tipo_movimento']);
    lValor := String(lJsonObject['ticket_medio']);
    cdsFaturamento.FieldByName('ticket_medio').AsFloat := StrToFloat(lValor);
    cdsFaturamento.Post;
  end;
end;

procedure TFViewAliadoEdit.SetDadosPersonalizados;
var
  lEndereco : string;
begin
  lEndereco := 'Rua: ' + AliadoDataset.FieldByName('Endereco').AsString + ', ' + 'N°: ' + AliadoDataset.FieldByName('Endereco_Numero').AsString +
    sLineBreak + 'Bairro: ' + AliadoDataset.FieldByName('Bairro').AsString + sLineBreak + 'Complemento: ' +
      AliadoDataset.FieldByName('Complemento_Endereco').AsString;

  edEnderecoCompleto.Text := lEndereco;
end;

procedure TFViewAliadoEdit.SetErroCertificado(pErro: string);
begin
  lblErroCertificado.Caption := pErro;
  lblErroCertificado.Visible := True;
end;

procedure TFViewAliadoEdit.SetLogoMarca;
begin
  TUtils.OcultarElemento('lblErroLogomarca');

  wfpLogomarca.Files.Clear;

  if AliadoDataset.FieldByName('logo_base64').AsString = '' then
  begin
    TUtils.OcultarElemento('divLogomarcaSelecionada');
    imgLogoSelecionada.URL := '';
  end
  else
  begin
    imgLogoSelecionada.URL := 'data:image/png;base64,' + AliadoDataset.FieldByName('logo_base64').AsString;
    TUtils.MostrarElemento('divLogomarcaSelecionada');
  end;
end;

procedure TFViewAliadoEdit.SetPermissoesIniciais;
begin
  if not TUtils.PossuiPermissao('aliado', TTipoPermissao.ALTERAR) then
  begin
    TUtils.RemoverElementoPorId(btnSalvarRecursos.ElementID);
    TUtils.BloquearCamposDiv('divCamposRecursos', True);
    divRemoverImagem.Enabled := False;
  end;

  if not TUtils.PossuiPermissao('data_base', TTipoPermissao.VISUALIZAR) then
  begin
    TUtils.RemoverElementoPorId('line-data_base-tab');
    TUtils.RemoverElementoPorId('line-data_base');
  end
  else
  begin
    if TUtils.PossuiPermissao('modulos_data_base', TTipoPermissao.VISUALIZAR) then
      XDataWebClientModulosRetaguarda.RawInvoke('IService.GetModulosRetaguarda', [])
    else
      TUtils.RemoverElementoPorId('modal_modulos_aliado');
  end;

  if not TUtils.PossuiPermissao('certificados', TTipoPermissao.VISUALIZAR) then
  begin
    TUtils.RemoverElementoPorId('line-certificado-tab');
    TUtils.RemoverElementoPorId('line-certificado');
    TUtils.RemoverElementoPorId('modal_importar_certificado');
  end
  else if not TUtils.PossuiPermissao('certificados', TTipoPermissao.INSERIR) then
  begin
    btnImportarCertificado.Enabled := False;
    TUtils.RemoverElementoPorId('modal_importar_certificado');
  end;

  if not TUtils.PossuiPermissao('sincronizacao_aliados', TTipoPermissao.VISUALIZAR) then
  begin
    TUtils.RemoverElementoPorId('line-sincronizacao-tab');
    TUtils.RemoverElementoPorId('line-sincronizacao');
  end
  else if not TUtils.PossuiPermissao('sincronizacao_aliados', TTipoPermissao.ALTERAR) then
    TUtils.RemoverElementoPorId('btnSalvarSincronizacao');

  TratarVisualizacaoAbaLogs;

  if TUtils.IsPerfilAliado(TUtils.FUsuario) then
    TUtils.RemoverElementoPorId('btnConectarAliado');

  if not TUtils.PossuiPermissao('config_retaguarda', TTipoPermissao.VISUALIZAR) then
  begin
    TUtils.RemoverElementoPorId('line-config_retaguarda-tab');
    TUtils.RemoverElementoPorId('line-config_retaguarda');
  end
end;

procedure TFViewAliadoEdit.tblDataBaseGetCellChildren(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordDataBaseId : string;
  RecordExcluido : Boolean;

procedure ModulosButtonClick(Sender: TObject);
begin
  TUtils.ChamarDivLoading;
  cdsModulosAliado.Close;
  cdsModulosAliado.QueryString := '$filter=(data_base_id eq ' + RecordDataBaseId +')';
  cdsModulosAliado.Load;
end;

[async]
procedure BancoOfertasButtonClick(Sender: TObject); async;
begin
  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, 'Tem certeza que deseja '+
    'definir o banco selecionado como o utilizado no painel de ofertas?')) then
  begin
    TUtils.ChamarDivLoading;
    XDataClientDataBase.RawInvoke('IService.DefinirBancoOfertas', [RecordDataBaseId]);
  end;
end;
[async]
procedure GerenciarAssociacaoProdutosButtonClick(Sender: TObject); async;
var
  lMensagem : string;
  lJson : TJSObject;
begin
  if TButton(Sender).Tag = 1 then
    lMensagem := 'Tem certeza que deseja associar os produtos do banco selecionado?'
  else
    lMensagem := 'Tem certeza que deseja remover o banco selecionado da associação de produtos?';


  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, lMensagem)) then
  begin
    lJson := TJSObject.New;
    lJson['codigo_banco'] := RecordDataBaseId;
    lJson['associar_produtos'] := TButton(Sender).Tag = 1;

    TUtils.ChamarDivLoading;
    XDataClientDataBase.RawInvoke('IService.GerenciarBancoAssociacaoProdutos', [lJson]);
  end;
end;

[async]
procedure ExcluirBancoButtonClick(Sender: TObject); async;
begin
  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO,
    '<b>Todos os dados serão excluídos, sendo essa operação irreversível!</b>' +
      sLineBreak + 'Tem certeza que deseja continuar?')) then
  begin
    TUtils.ChamarDivLoading;
    XDataClientDataBase.RawInvoke('IService.MarcarBancoExcluido', [RecordDataBaseId]);
  end;
end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if tblDataBase.Columns[ACol].Title = 'Ações' then
  begin
    RecordDataBaseId := cdsDataBase.FieldByName('id').AsString;
    RecordExcluido := cdsDataBase.FieldByName('excluido').AsBoolean;

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-desktop"></i>';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-test', 'btn_ver_modulos');

    if TUtils.PossuiPermissao('modulos_data_base', TTipoPermissao.VISUALIZAR) then
    begin
      Button.OnClick := @ModulosButtonClick;
      Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
      Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
      Button.ElementHandle.setAttribute('title', 'Ver Módulos');
      Button.ElementHandle.setAttribute('data-bs-toggle', 'modal');
      Button.ElementHandle.setAttribute('data-bs-target', '#modal_modulos_aliado');
    end
    else
    begin
      Button.ElementClassName := 'btn btn-link text-muted btn-lg';
      Button.ElementHandle.style.setProperty('cursor', 'not-allowed');
    end;


    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-file-invoice-dollar"></i>';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-test', 'btn_banco_ofertas');

    if TUtils.PossuiPermissao('data_base', TTipoPermissao.ALTERAR) then
    begin
      Button.OnClick := @BancoOfertasButtonClick;
      Button.ElementClassName := 'btn btn-link btn-secondary btn-lg';
      Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
      Button.ElementHandle.setAttribute('title', 'Definir como banco painel ofertas.');
    end
    else
    begin
      Button.ElementClassName := 'btn btn-link text-muted btn-lg';
      Button.ElementHandle.style.setProperty('cursor', 'not-allowed');
    end;

    if not TUtils.IsPerfilFacilSistemas(TUtils.FUsuario, True) then
      Exit;

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-boxes"></i>';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-test', 'btn_associar_produtos_banco');

    if TUtils.PossuiPermissao('data_base', TTipoPermissao.ALTERAR) then
    begin
      Button.OnClick := @GerenciarAssociacaoProdutosButtonClick;
      Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');

      if cdsDataBase.FieldByName('associar_produtos').AsBoolean then
      begin
        Button.ElementClassName := 'btn btn-link btn-danger btn-lg';
        Button.ElementHandle.setAttribute('title', 'Remover banco associação produtos.');
        Button.Tag := 0;
      end
      else
      begin
        Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
        Button.ElementHandle.setAttribute('title', 'Associar produtos banco.');
        Button.Tag := 1;
      end;
    end
    else
    begin
      Button.ElementClassName := 'btn btn-link text-muted btn-lg';
      Button.ElementHandle.style.setProperty('cursor', 'not-allowed');
    end;

    if TUtils.IsPerfilFacilSistemas(TUtils.FUsuario) then
    begin
      Button := TButton.Create(nil);
      Button.Caption := '<i class="fas fa-trash-alt"></i>';
      Button.ParentElement := AElement.element;
      Button.WidthStyle := TSizeStyle.ssAuto;
      Button.HeightStyle := TSizeStyle.ssAuto;
      Button.ElementHandle.style.setProperty('padding', '10px');
      Button.ElementHandle.setAttribute('data-test', 'btn_excluir_data_base');

      if TUtils.PossuiPermissao('data_base', TTipoPermissao.ALTERAR) and not RecordExcluido then
      begin
        Button.OnClick := @ExcluirBancoButtonClick;
        Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
        Button.ElementClassName := 'btn btn-link btn-danger btn-lg';
        Button.ElementHandle.setAttribute('title', 'Excluir banco');
      end
      else
      begin
        Button.ElementClassName := 'btn btn-link text-muted btn-lg';
        Button.ElementHandle.style.setProperty('cursor', 'not-allowed');
      end;
    end;
  end;
end;

procedure TFViewAliadoEdit.tblDataBaseGetCellClass(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(tblDataBase.Columns[ACol].DataField, ['token', 'nome_fantasia',
      'host', 'path', 'regime_contabil', 'crt', 'contador.nome']) of
      0, 1, 2, 3, 4, 5, 6 : AClassName := 'text-start';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewAliadoEdit.tblDataBaseGetCellData(Sender: TObject; ACol,
  ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow = 0 then
    Exit;


  case IndexStr(tblDataBase.Columns[ACol].DataField, ['fiscal', 'excluido', 'data_base_multiempresa',
    'data_base_empresa_destino', 'divulgar_promocoes', 'associar_produtos']) of
    0, 1, 2, 3, 4, 5:
    begin
      if AValue = 'True' then
        AValue := '<i class="fas fa-check text-success"><i>'
      else if AValue = 'False' then
        AValue := '<i class="fas fa-times text-danger"><i>';
    end;
  end;
end;

procedure TFViewAliadoEdit.tblFaturamentoGetCellClass(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(tblFaturamento.Columns[ACol].DataField, ['nome_fantasia', 'valor_total_faturamento',
      'quantidade', 'id', 'caminho_data_base', 'tipo', 'ticket_medio']) of
      0, 4, 5: AClassName := 'text-start';
      1, 2, 3, 6: AClassName := 'text-end';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewAliadoEdit.tblLogsGetCellChildren(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordSincronizacaoErro : string;

  procedure ExibirErroSincronizacao(Sender: TObject);
  var
    JSONObj: JSValue;
  begin
    if VerificarJsonValido(RecordSincronizacaoErro) then
    begin
      JSONObj := TJSJSON.parse(RecordSincronizacaoErro);
      edtSincronizacaoErro.Text := TJSJSON.stringify(JSONObj, nil, 2);
    end
    else
      edtSincronizacaoErro.Text := RecordSincronizacaoErro;  
  
    edtSincronizacaoObservacao.Text := edObservacoes.Text;
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if tblLogs.Columns[ACol].Title = 'Ação' then
  begin
    RecordSincronizacaoErro := cdsLogs.FieldByName('sincronizacao_erro').AsString;

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-exclamation-triangle"></i>';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.setAttribute('data-test', 'btn_erro_sincronizacao');


    if RecordSincronizacaoErro <> '' then
    begin
      Button.OnClick := @ExibirErroSincronizacao;
      Button.ElementClassName := 'btn btn-link btn-danger btn-lg';
      Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
      Button.ElementHandle.setAttribute('title', 'Ver erro sincronização');
      Button.ElementHandle.setAttribute('data-bs-toggle', 'modal');
      Button.ElementHandle.setAttribute('data-bs-target', '#modal_erro_sincronizacao');
    end
    else
    begin
      Button.ElementClassName := 'btn btn-link text-muted btn-lg';
      Button.ElementHandle.style.setProperty('cursor', 'not-allowed');
    end;
  end;
end;

procedure TFViewAliadoEdit.tblLogsGetCellClass(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(tblLogs.Columns[ACol].DataField, ['sincronizacao_service.rota', 'sincronizacao_erro',
      'versao_client']) of
      0, 1, 2: AClassName := 'text-start';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewAliadoEdit.tblLogsGetCellData(Sender: TObject; ACol,
  ARow: Integer; AField: TField; var AValue: string);
var
  lRota : string;
begin
  if ARow = 0 then
    Exit;

  if tblLogs.Columns[ACol].Title = 'Tempo Sinc.' then
  begin
    AValue := THelperServer.GetTempoSincronizacao(cdsLogs.FieldByName('inicio_sincronizacao').AsString,
      cdsLogs.FieldByName('fim_sincronizacao').AsString);
  end
  else
  begin
    case IndexStr(tblLogs.Columns[ACol].DataField, ['sincronizacao_erro', 'sincronizacao_service.rota']) of
      0:
      begin
        if Length(AValue) > 100 then
          AValue := Copy(AValue, 1, 100) + '...';
      end;
      1:
      begin
        lRota := AValue.Replace('_', ' ');
        lRota := AnsiProperCase(lRota, [' ']);
        AValue := lRota;
      end;
    end;
  end;
end;

procedure TFViewAliadoEdit.tblSincServRetGetCellChildren(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordSincronizacaoErro : string;

  procedure ExibirErroSincronizacaoServRet(Sender: TObject);
  var
    JSONObj: JSValue;
  begin
    if VerificarJsonValido(RecordSincronizacaoErro) then
    begin
      JSONObj := TJSJSON.parse(RecordSincronizacaoErro);
      edtSincronizacaoErro.Text := TJSJSON.stringify(JSONObj, nil, 2);
    end
    else
      edtSincronizacaoErro.Text := RecordSincronizacaoErro;

    edtSincronizacaoObservacao.Text := edObservacoes.Text;
  end;
var
  Button: TButton; 
begin
  if ARow = 0 then
    Exit;

  if tblLogs.Columns[ACol].Title = 'Ação' then
  begin
    RecordSincronizacaoErro := cdsSincServRet.FieldByName('sincronizacao_erro').AsString;

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-exclamation-triangle"></i>';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.setAttribute('data-test', 'btn_erro_sincronizacao_serv_retaguarda');


    if RecordSincronizacaoErro <> '' then
    begin
      Button.OnClick := @ExibirErroSincronizacaoServRet;
      Button.ElementClassName := 'btn btn-link btn-danger btn-lg';
      Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
      Button.ElementHandle.setAttribute('title', 'Ver erro sincronização');
      Button.ElementHandle.setAttribute('data-bs-toggle', 'modal');
      Button.ElementHandle.setAttribute('data-bs-target', '#modal_erro_sincronizacao');
    end
    else
    begin
      Button.ElementClassName := 'btn btn-link text-muted btn-lg';
      Button.ElementHandle.style.setProperty('cursor', 'not-allowed');
    end;
  end;
end;

procedure TFViewAliadoEdit.tmrConsultaDataBaseTimer(Sender: TObject);
begin
  FGridPluginDataBase.SetFilterText(edSearchDataBase.Text, True);

  tmrConsultaDataBase.Enabled := False;
  tmrConsultaDataBase.Interval := FTimerConsulta;
end;


procedure TFViewAliadoEdit.tmrConsultaLogsTimer(Sender: TObject);
begin
  FGridPluginLogs.SetFilterText(edSearchLogs.Text, True);

  tmrConsultaLogs.Enabled := False;
  tmrConsultaLogs.Interval := FTimerConsulta;
end;

procedure TFViewAliadoEdit.tmrSincServRetTimer(Sender: TObject);
begin
  FGridPluginSincServRetaguarda.SetFilterText(edtSincServRet.Text, True);

  tmrSincServRet.Enabled := False;
  tmrSincServRet.Interval := FTimerConsulta;
end;

procedure TFViewAliadoEdit.TratarVisualizacaoAbaLogs;
begin
  if not(TUtils.IsPerfilFacilSistemas(TUtils.FUsuario)) or
    (not TUtils.PossuiPermissao('sincronizacao_logs', TTipoPermissao.VISUALIZAR) and
      not TUtils.PossuiPermissao('sincronizacao_servidor_logs', TTipoPermissao.VISUALIZAR)) then
  begin
    TUtils.RemoverElementoPorId('line-logs-tab');
    TUtils.RemoverElementoPorId('line-logs');
    TUtils.RemoverElementoPorId('modal_erro_sincronizacao');
  end
  else if not TUtils.PossuiPermissao('sincronizacao_logs', TTipoPermissao.VISUALIZAR) then
  begin     
    TUtils.RemoverElementoPorId('line-retaguarda_servidor-tab');
    TUtils.RemoverElementoPorId('line-retaguarda_servidor');
  end
  else if not TUtils.PossuiPermissao('sincronizacao_servidor_logs', TTipoPermissao.VISUALIZAR) then
  begin
    TUtils.RemoverElementoPorId('line-servidor_retaguarda-tab');
    TUtils.RemoverElementoPorId('line-servidor_retaguarda');
  end;
end;

function TFViewAliadoEdit.ValidarConsultaFaturamento: string;
begin
  Result := EmptyStr;

  if (Trim(edtDataInicial.Text) = '') or (Trim(edtDataFinal.Text) = '') then
  begin
    Result := 'Data inicial e final são obrigatórias!';
    Exit;
  end;

  if edtDataInicial.Date > edtDataFinal.Date then
  begin
    Result := 'A data inicial deve ser menor que a final!';
    Exit;
  end;

  if MonthsBetween(StartOfTheMonth(edtDataFinal.Date), StartOfTheMonth(edtDataInicial.Date)) > 13 then
  begin
    Result := 'O intervalo entre as datas deve ser menor ou igual a 13 meses!';
    Exit;
  end;
end;

function TFViewAliadoEdit.ValidarTelefoneWhatsApp: Boolean;
var
  lNumeroFormatado : string;
begin
  Result := True;

  if AlterouTelefoneWhatsApp then
  begin
    lNumeroFormatado := TUtils.SomenteNumeros(edtTelefoneWhatsappEdit.Text);

    if not Trim(lNumeroFormatado).IsEmpty then
      Result := (Length(lNumeroFormatado) = 10) or (Length(lNumeroFormatado) = 11);
  end;
end;

procedure TFViewAliadoEdit.WebFormCreate(Sender: TObject);
begin
  FCertificadoBase64 := '';

  if not(TUtils.IsPerfilFacilSistemas(TUtils.FUsuario)) then
  begin
    THelperServer.RemoverElementoPorId('line-sincronizacao-tab');
    btnSincronizacaoTab.Visible := False;
    THelperServer.RemoverElementoPorId('btnSalvarSincronizacao');
    btnSalvarSincronizacao.Visible := False;
    THelperServer.RemoverElementoPorId('divParceirosEdit');
  end
  else
    FArraySincronizacaoAtualizacao := TJSArray.new;

  case TUtils.FUsuario.Perfil  of
    Ord(TPerfil.FACIL_SISTEMAS): CriarCheckBoxRecursos;
    Ord(TPerfil.PARCEIRO):
    begin
      CriarCheckBoxRecursos;
      edtObservacaoEdit.Enabled := False;
    end;
    Ord(TPerfil.ALIADO):
    begin
      THelperServer.RemoverElementoPorId('div_observacoes');
      THelperServer.RemoverElementoPorId('divSincronizarDados');
      THelperServer.RemoverElementoPorId('divRecursos');
      THelperServer.RemoverElementoPorId('divObservacoesEdit');
    end;
  end;

  if TUtils.IsPerfilFacilSistemas(TUtils.FUsuario, True) then
    tblDataBase.Columns[0].Width := 150
  else
    tblDataBase.Columns[0].Width := 100;

  SetConfiguracoesFaturamento;
end;

procedure TFViewAliadoEdit.WebFormShow(Sender: TObject);
begin
  SetPermissoesIniciais;
end;

procedure TFViewAliadoEdit.wfpCertificadoChange(Sender: TObject);
begin
  lblErroCertificado.Visible := False;
  if wfpCertificado.Files.Count > 0 then
  begin
    if not wfpCertificado.Files[0].Name.ToLower.EndsWith('.pfx')  then
    begin
      SetErroCertificado('Formato de arquivo inválido');
      wfpCertificado.Files.Clear;
      FCertificadoBase64 := '';
    end
    else
      wfpCertificado.Files[0].GetFileAsBase64;
  end;
end;

procedure TFViewAliadoEdit.wfpCertificadoGetFileAsBase64(Sender: TObject;
  AFileIndex: Integer; ABase64: string);
begin
  FCertificadoBase64 := ABase64;
end;

procedure TFViewAliadoEdit.wfpLogomarcaChange(Sender: TObject);
begin
  TUtils.OcultarElemento('lblErroLogomarca');

  if wfpLogomarca.Files.Count > 0 then
  begin
    if not wfpLogomarca.Files[0].Name.ToLower.EndsWith('.png')  then
    begin
      TUtils.MostrarElemento('lblErroLogomarca');
      wfpLogomarca.Files.Clear;
    end
    else
      wfpLogomarca.Files[0].GetFileAsBase64;
  end;
end;

procedure TFViewAliadoEdit.wfpLogomarcaGetFileAsBase64(Sender: TObject;
  AFileIndex: Integer; ABase64: string);
begin
  imgLogoSelecionada.URL := 'data:image/png;base64,' + ABase64;
  TUtils.MostrarElemento('divLogomarcaSelecionada');
end;

procedure TFViewAliadoEdit.XDataClientAliadoGetLoad(Response: TXDataClientResponse);
begin
  AliadoDataset.Close;
  AliadoDataset.SetJsonData(Response.Result);
  AliadoDataset.Open;
end;

procedure TFViewAliadoEdit.XDataClientDataBaseError(Error: TXDataClientError);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, 'Erro ao realizar operação!' + sLineBreak +
    Error.ErrorMessage);
end;

procedure TFViewAliadoEdit.XDataClientDataBaseLoad(
  Response: TXDataClientResponse);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Operação realizada com sucesso!');
  FGridPluginDataBase.Load;
end;

procedure TFViewAliadoEdit.XDataClientRecursosError(Error: TXDataClientError);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, 'Erro ao atualizar recursos!' + sLineBreak +
    Error.ErrorMessage);
end;

procedure TFViewAliadoEdit.XDataClientRecursosLoad(
  Response: TXDataClientResponse);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Recursos atualizados com sucesso!');
  AliadoDataset.QueryString := '$filter=Id eq ' + edId.Text + '&$expand=cidade, segmento, parceiro, cidade/uf';
  AliadoDataset.Close;
  AliadoDataset.Load;
end;

procedure TFViewAliadoEdit.XDataWebClientFaturamentoError(
  Error: TXDataClientError);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, 'Erro ao consultar faturamento!' + sLineBreak +
    Error.ErrorMessage);
end;

procedure TFViewAliadoEdit.XDataWebClientFaturamentoLoad(
  Response: TXDataClientResponse);
var
  lJsonArray: TJSArray;
begin
  if Response.RequestId = 'CONSULTA' then
    ReiniciarDadosFaturamento;

  if Response.ResponseText = '{}' then
  begin
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Não foram encontrados registros para os filtros selecionados!');
    Exit;
  end;

  if Response.RequestId = 'CONSULTA' then
  begin
    lJsonArray := TJSArray(Response.ResultAsObject['dados_faturamento']);

    SetDadosFaturamento(lJsonArray);
    SetResumoFaturamento(TJSObject(Response.ResultAsObject['resumo_faturamento']));
    TUtils.OcultarDivLoading;
  end
  else
    ExportarDadosExcel(Response);
end;

procedure TFViewAliadoEdit.XDataWebClientModulosRetaguardaError(
  Error: TXDataClientError);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, 'Erro ao buscar módulos!' + sLineBreak +
    Error.ErrorMessage);
end;

procedure TFViewAliadoEdit.XDataWebClientModulosRetaguardaLoad(
  Response: TXDataClientResponse);
var
  lIndice : Integer;
  lJsonArray: TJSArray;
  lJsonObject: TJSObject;
  lModuloId,
  lModuloNome,
  lIdCheckBox,
  lIdLabel,
  lDivCriadaHtml : string;
begin
  lJsonArray := Response.ResultAsArray;
  div_checkbox_modulos.HTML.Clear;

  for lIndice := 0 to lJsonArray.Length - 1 do
  begin
    lJsonObject := TJSObject(lJsonArray[lIndice]);
    lModuloId := string(lJsonObject['id']);
    lModuloNome := string(lJsonObject['nome']);

    lIdCheckBox := FPrefixoCheckBoxModulos + lModuloId;
    lIdLabel := 'lbl_modulo_' + lModuloId;
    lDivCriadaHtml := '<div class="form-check col-md-3  col-sm-6 d-flex"><input class="form-check-input" '+
      'type="checkbox" id="'+lIdCheckBox+'"/><label class="form-check-label" id="'+
        lIdLabel+'" for="'+lIdCheckBox+'">'+lModuloNome +'</label></div>';

    div_checkbox_modulos.HTML.Add(lDivCriadaHtml);
  end;
end;

procedure TFViewAliadoEdit.XDataClientAliadoDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewAliadoEdit.AliadoDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      Exit;
    end;
  end;
  FShowListProc;
end;

function TFViewAliadoEdit.AlterouObservacao: Boolean;
begin
  Result := Trim(edtObservacaoEdit.Text) <> Trim(edObservacoes.Text);
end;

function TFViewAliadoEdit.AlterouParceiro: Boolean;
begin
  Result := edtParceiroNome.tag <> AliadoDataset.FieldByName('parceiro_id').AsInteger;
end;

function TFViewAliadoEdit.AlterouTelefoneWhatsApp: Boolean;
begin
  Result := TUtils.SomenteNumeros(edtTelefoneWhatsappEdit.Text) <>
    TUtils.SomenteNumeros(AliadoDataset.FieldByName('telefone_whatsapp').AsString);
end;

procedure TFViewAliadoEdit.AliadoDatasetAfterOpen(DataSet: TDataSet);
begin
  SetDadosPersonalizados;
end;

procedure TFViewAliadoEdit.AliadoDatasetCEPGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarCEP(Sender.AsString);
end;

procedure TFViewAliadoEdit.AliadoDatasetcidadeNomeGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
var
  lUf : string;
begin
  lUf := AliadoDataset.FieldByName('cidade.uf.Sigla').AsString;

  Text := THelperServer.GetValueOrEmpty(Sender.AsString);

  if not(Text.IsEmpty) and not lUf.IsEmpty then
    Text := Text + ' - ' + lUf;
end;

procedure TFViewAliadoEdit.AliadoDatasetCNPJGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarCnpj_Cpf(Sender.AsString);
end;

procedure TFViewAliadoEdit.AliadoDatasetconfig_windowsGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
var
  lJSONObj: JSValue;
begin
  if Sender.AsString.IsEmpty then
    Exit;

  lJSONObj := TJSJSON.parse(Sender.AsString);
  Text := TJSJSON.stringify(lJSONObj, nil, 2);
end;

procedure TFViewAliadoEdit.AliadoDatasetparceironomeGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  if Sender.AsString.ToLower = 'null' then
    Text := '';
end;

procedure TFViewAliadoEdit.AliadoDatasetsegmentoNomeGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := THelperServer.GetValueOrEmpty(Sender.AsString);
end;

procedure TFViewAliadoEdit.AliadoDatasetStatusGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  case Sender.AsInteger of
    1 : Text := 'Ativo';
    2 : Text := 'Inativo';
    else Text := 'Suspenso/Congelado';
  end;
end;

procedure TFViewAliadoEdit.AliadoDatasetTelefone_PrincipalGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarTelefone(Sender.AsString);
end;

function TFViewAliadoEdit.AlterouLogoMarca: Boolean;
begin
  Result := imgLogoSelecionada.URL.Replace('data:image/png;base64,', '') <> AliadoDataset.FieldByName('logo_base64').AsString;
end;

procedure TFViewAliadoEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewAliadoEdit.btnCarregarConfiguracoesClick(Sender: TObject);
begin
  if Trim(cbbDataBaseConfigRetaguarda.Text).IsEmpty then
  begin
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Selecione o banco de dados!');
    Exit;
  end;

  TUtils.ChamarDivLoading;

  cdsDataBaseFaturamento.RecNo := cbbDataBaseConfigRetaguarda.ItemIndex + 1;

  cdsConfigRetaguarda.Close;
  cdsConfigRetaguarda.QueryString := '$filter=(data_base_id eq ' + cdsDataBaseFaturamento.FieldByName('id').AsString +')';
  cdsConfigRetaguarda.Load;
end;

procedure TFViewAliadoEdit.btnExportarExcelConfigRetaguardaClick(Sender: TObject);
var
  lExportacoes: TExportacoes;
begin
  if cdsConfigRetaguarda.RecordCount = 0 then
  begin
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Não há dados para exportar!');
    Exit;
  end;

  TUtils.ChamarDivLoading;

  lExportacoes := TExportacoes.Create(cdsConfigRetaguarda, nil);
  lExportacoes.ExportarExcelConfigRetaguarda(
    cdsConfigRetaguarda.FieldByName('configuracoes').AsString,
    cdsConfigRetaguarda.FieldByName('configuracao').AsString
  );
end;

procedure TFViewAliadoEdit.btnCertificadoClick(Sender: TObject);
begin
  TUtils.ChamarDivLoading;
  cdsCertificado.QueryString := '$filter=(aliado_id eq ' + edId.Text +')';
  cdsCertificado.Close;
  cdsCertificado.Load;
end;

procedure TFViewAliadoEdit.btnConectarAliadoClick(Sender: TObject);
begin
  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO,
    'Tem certeza que deseja conectar no aliado <b>'+edNome_Fantasia.Text+'</b>?')) then
  begin
    TUtils.ChamarDivLoading;
    FViewMain.cdsUsuarios.Edit;
    FViewMain.cdsUsuarios.FieldByName('data_base_id').Value := null;
    FViewMain.cdsUsuarios.FieldByName('aliado_id').AsInteger := StrToInt(edId.Text);
    FViewMain.cdsUsuarios.Post;
    FViewMain.cdsUsuarios.ApplyUpdates;
  end;
end;

procedure TFViewAliadoEdit.btnConfigNfceClick(Sender: TObject);
begin
  CarregarSerieCaixaNfce;
end;

procedure TFViewAliadoEdit.btnConfigRetaguardaClick(Sender: TObject);
begin
  CarregarDataBase;
end;

procedure TFViewAliadoEdit.btnConsultarFaturamentoClick(Sender: TObject);
var
  lErro : string;
begin
  lErro := ValidarConsultaFaturamento;

  if not lErro.IsEmpty then
  begin
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, lErro);
    Exit;
  end;

  TUtils.ChamarDivLoading;
  XDataWebClientFaturamento.RawInvoke('IService.ConsultarFaturamentoAliado', [GetJsonFaturamento], 'CONSULTA');
end;

procedure TFViewAliadoEdit.btnDataBaseTabClick(Sender: TObject);
begin
  if not Assigned(FGridPluginDataBase) then
  begin
    FGridPluginDataBase := TGridPlugin.Create(tblDataBase, cdsDataBase, lcPaginatorDataBase, lbPaginationInfoDataBase);
    FGridPluginDataBase.FDatasetPlugin.FFilterPadrao := '(aliado_id eq ' + edid.Text + ') and excluido eq 0';
    FGridPluginDataBase.SetPageSize(StrToInt(cbPageSizeDataBase.Text));
    FGridPluginDataBase.SetFilterText(edSearchDataBase.Text);
  end;

  FGridPluginDataBase.Load;
end;

procedure TFViewAliadoEdit.btnExportarExcelClick(Sender: TObject);
var
  lErro : string;
begin
  lErro := ValidarConsultaFaturamento;

  if not lErro.IsEmpty then
  begin
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, lErro);
    Exit;
  end;

  TUtils.ChamarDivLoading;
  XDataWebClientFaturamento.RawInvoke('IService.ConsultarFaturamentoAliado', [GetJsonFaturamento(False)]);
end;

procedure TFViewAliadoEdit.btnFaturamentoTabClick(Sender: TObject);
begin
  CarregarDataBase;
end;

procedure TFViewAliadoEdit.btnImportarCertificadoClick(Sender: TObject);
begin
  lblErroCertificado.Visible := False;
  FCertificadoBase64 := '';
  edtCertificadoSenha.Text := '';
  wfpCertificado.Files.Clear;
end;

procedure TFViewAliadoEdit.btnLogsTabClick(Sender: TObject);
begin
  if TUtils.PossuiPermissao('sincronizacao_logs', TTipoPermissao.VISUALIZAR) then
  begin
    if not Assigned(FGridPluginLogs) then
    begin
      FGridPluginLogs := TGridPlugin.Create(tblLogs, cdsLogs, lcPaginatorLogs, lbPaginationInfoLogs);
      FGridPluginLogs.FDatasetPlugin.FFilterPadrao := 'aliado_id eq ' + edid.Text;
      FGridPluginLogs.FDatasetPlugin.FOrderByPadrao := 'sincronizacao_erro desc, ultima_sincronizacao desc';
      FGridPluginLogs.SetPageSize(StrToInt(cbPageSizeLogs.Text));
      FGridPluginLogs.SetFilterText(edSearchLogs.Text);
      FGridPluginLogs.Load;
    end;
  end
  else
  begin
    TUtils.SelecionarTab('#line-servidor_retaguarda-tab');
    if not Assigned(FGridPluginSincServRetaguarda) then
    begin
      FGridPluginSincServRetaguarda := TGridPlugin.Create(tblSincServRet, cdsSincServRet,
        lcPaginatorSincServRet, lbPaginationInfoSincServRet);
      FGridPluginSincServRetaguarda.FDatasetPlugin.FFilterPadrao := 'aliado_id eq ' + edid.Text;
      FGridPluginSincServRetaguarda.FDatasetPlugin.FOrderByPadrao := 'sincronizacao_erro desc, ultima_sincronizacao desc';
      FGridPluginSincServRetaguarda.SetPageSize(StrToInt(cbbSincServRet.Text));
      FGridPluginSincServRetaguarda.SetFilterText(edtSincServRet.Text);
    end;
    
    FGridPluginSincServRetaguarda.Load;   
  end;
end;

procedure TFViewAliadoEdit.btnPesquisarParceiroClick(Sender: TObject);
begin
  THelperServer.ChamarConsulta('Parceiros', 'Parceiros', edtParceiroNome, True);
end;

procedure TFViewAliadoEdit.btnRecursosTabClick(Sender: TObject);
begin
  DesmarcarTodosRecursos;
  SetRecursosAliado;
  edtObservacaoEdit.Text := edObservacoes.Text;
  SetLogoMarca;
  edtParceiroNome.Text := edparceiro_nome.Text;
  edtParceiroNome.tag := AliadoDataset.FieldByName('parceiro_id').AsInteger;
  edtTelefoneWhatsappEdit.Text := TUtils.FormatarTelefone(AliadoDataset.FieldByName('telefone_whatsapp').AsString);
end;

procedure TFViewAliadoEdit.btnSalvarRecursosClick(Sender: TObject);
var
  lLogo,
  lObservacao,
  lNumeroFormatado: string;
  lJson : TJSObject;
begin
  if not ValidarTelefoneWhatsApp then
  begin
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Insira um número de telefone válido!');
    Exit;
  end;

  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, 'Tem certeza que deseja '+
    'atualizar os recursos do aliado <b>' + edNome_Fantasia.Text + '</b>?')) then
  begin
    TUtils.ChamarDivLoading;
    lJson := TJSObject.New;

    case TUtils.FUsuario.Perfil of
      Ord(TPerfil.FACIL_SISTEMAS):
      begin
        GetRecursosSelecionados(lJson);

        lJson['sincronizar_dados'] := cbxSincronizarDados.Checked;

        if AlterouObservacao then
        begin
          lObservacao := Trim(edtObservacaoEdit.Text);

          if lObservacao = '' then
            lJson['observacao'] := JSValue(null)
          else
            lJson['observacao'] := lObservacao;
        end;

        if AlterouParceiro then
          lJson['parceiro_id'] := edtParceiroNome.Tag;
      end;
      Ord(TPerfil.PARCEIRO) : GetRecursosSelecionados(lJson);
    end;

    if AlterouLogoMarca then
    begin
      lLogo := imgLogoSelecionada.URL.Replace('data:image/png;base64,', '');

      if lLogo = '' then
        lJson['logomarca'] := JSValue(null)
      else
        lJson['logomarca'] := lLogo;
    end;

    if AlterouTelefoneWhatsApp then
    begin
      lNumeroFormatado := TUtils.SomenteNumeros(edtTelefoneWhatsappEdit.Text);

      if Trim(lNumeroFormatado).IsEmpty then
        lJson['telefone_whatsapp'] := JSValue(null)
      else
        lJson['telefone_whatsapp'] := lNumeroFormatado;
    end;

    XDataClientRecursos.RawInvoke('IService.HabilitarRecursosAliado', [edId.Text, lJson]);
  end;
end;

procedure TFViewAliadoEdit.btnSalvarSincronizacaoClick(Sender: TObject);
var
  lIdCheckBox : string;
  lElement: TJSHTMLInputElement;
  lJsObject: TJSObject;
begin
  try
    TUtils.ChamarDivLoading;
    cdsSincronizacao.DisableControls;
    cdsSincronizacao.First;
    FArraySincronizacaoAtualizacao.length := 0;

    while not cdsSincronizacao.Eof do
    begin
      lIdCheckBox := FPrefixoCheckBoxSincronizacao + cdsSincronizacao.FieldByName('id').AsString;

      lElement := TJSHTMLInputElement(document.getElementById(lIdCheckBox));

      if Assigned(lElement) then
      begin
        cdsSincronizacao.Edit;
        cdsSincronizacao.FieldByName('sincronizar_dados').AsBoolean := lElement.checked;
        cdsSincronizacao.Post;
      end;

      lJsObject := TJSObject.New;
      lJsObject.Properties['id'] := cdsSincronizacao.FieldByName('id').AsInteger;
      lJsObject.Properties['rota'] := cdsSincronizacao.FieldByName('sincronizacao_service.rota').AsString;
      lJsObject.Properties['sincronizar_dados'] := cdsSincronizacao.FieldByName('sincronizar_dados').AsBoolean;

      FArraySincronizacaoAtualizacao.push(lJsObject);

      cdsSincronizacao.Next;
    end;
  finally
    cdsSincronizacao.EnableControls;
    cdsSincronizacao.ApplyUpdates;
  end;
end;

procedure TFViewAliadoEdit.btnSincRetServidorClick(Sender: TObject);
begin
  FGridPluginLogs.Load;
end;

procedure TFViewAliadoEdit.btnSincronizacaoTabClick(Sender: TObject);
begin
  cdsSincronizacao.QueryString := '$filter=(aliado_id eq ' + edId.Text +
    ')&$expand=sincronizacao_service&$orderby=sincronizacao_service/rota';
  cdsSincronizacao.Close;
  cdsSincronizacao.Load;
end;

procedure TFViewAliadoEdit.btnSincServRetaguardaClick(Sender: TObject);
begin
  if not Assigned(FGridPluginSincServRetaguarda) then
  begin
    FGridPluginSincServRetaguarda := TGridPlugin.Create(tblSincServRet, cdsSincServRet,
      lcPaginatorSincServRet, lbPaginationInfoSincServRet);
    FGridPluginSincServRetaguarda.FDatasetPlugin.FFilterPadrao := 'aliado_id eq ' + edid.Text;
    FGridPluginSincServRetaguarda.FDatasetPlugin.FOrderByPadrao := 'sincronizacao_erro desc, ultima_sincronizacao desc';
    FGridPluginSincServRetaguarda.SetPageSize(StrToInt(cbbSincServRet.Text));
    FGridPluginSincServRetaguarda.SetFilterText(edtSincServRet.Text);
  end;

  FGridPluginSincServRetaguarda.Load;
end;

procedure TFViewAliadoEdit.btnUploadCertificadoClick(Sender: TObject);
begin
  lblErroCertificado.Visible := False;
  if (wfpCertificado.Files.Count <= 0)  then
  begin
    SetErroCertificado('Nenhum certificado selecionado');

    Exit;
  end
  else if edtCertificadoSenha.Text = '' then
  begin
    SetErroCertificado('Insira a senha do certificado');

    Exit;
  end;

  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, 'Tem certeza que deseja '+
    'cadastrar este certificado?')) then
  begin
    TUtils.ChamarDivLoading;
    SetDadosCertificado;
  end;
end;

procedure TFViewAliadoEdit.CarregarDataBase;
begin
  if cbbDataBase.Tag = 0 then
  begin
    if TUtils.PossuiPermissao('data_base', TTipoPermissao.VISUALIZAR)  then
    begin
      cdsDataBaseFaturamento.QueryString := '$filter=(aliado_id eq ' + edid.Text + ')';
      cdsDataBaseFaturamento.QueryTop := 100;
      cdsDataBaseFaturamento.Load;
    end
    else
      cbbDataBase.Items.Add('TODOS');

    cdsDataBase.Tag := 1;
  end;
end;

procedure TFViewAliadoEdit.CarregarSerieCaixaNfce;
begin
  if cdsConfigNfce.Tag = 0 then
  begin
    if TUtils.PossuiPermissao('config_pdvs', TTipoPermissao.VISUALIZAR)  then
    begin
      TUtils.ChamarDivLoading;
      cdsConfigNfce.QueryString := '$filter=(aliado_id eq ' + edid.Text + ')';
      cdsConfigNfce.QueryTop := 100;
      cdsConfigNfce.Load;
    end;
  end;
end;

procedure TFViewAliadoEdit.btnCarregarConfiguracoesNfceClick(Sender: TObject);
var
  lPar: TJSObject;
  lSerie, lCaixa: string;
begin
  if Trim(cbbSerieCaixaNfce.Text).IsEmpty then
  begin
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Selecione a Série/Caixa!');
    Exit;
  end;

  lPar := TJSObject(FListaSerieCaixaNfce[cbbSerieCaixaNfce.ItemIndex]);
  lSerie := IntToStr(Integer(lPar['serie']));
  lCaixa := IntToStr(Integer(lPar['caixa']));

  TUtils.ChamarDivLoading;

  cdsConfigNfce.Close;
  cdsConfigNfce.QueryString := '$filter=(aliado_id eq ' + edid.Text +
    ' and serie eq ' + lSerie + ' and caixa eq ' + lCaixa + ')';
  cdsConfigNfce.Load;
end;

procedure TFViewAliadoEdit.btnExportarExcelConfigNfceClick(Sender: TObject);
var
  lExportacoes: TExportacoes;
begin
  if cdsConfigNfce.FieldByName('configuracoes').AsString.IsEmpty then
  begin
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Não há dados para exportar!');
    Exit;
  end;

  TUtils.ChamarDivLoading;

  lExportacoes := TExportacoes.Create(cdsConfigNfce, nil);
  lExportacoes.ExportarExcelConfigNfce(
    cdsConfigNfce.FieldByName('configuracoes').AsString
  );
end;

procedure TFViewAliadoEdit.cbbSincServRetChange(Sender: TObject);
begin
  FGridPluginSincServRetaguarda.SetPageSize(StrToInt(cbbSincServRet.Text), True);
end;

procedure TFViewAliadoEdit.cbbTipoFaturamentoChange(Sender: TObject);
begin
  cbxMovimentaEstoque.Enabled := cbbTipoFaturamento.ItemIndex in [0, 1];
  cbxGeraFinanceiro.Enabled := cbbTipoFaturamento.ItemIndex in [0, 1];
  cbxSimplesFaturamento.Enabled := cbbTipoFaturamento.ItemIndex in [0, 1];
  cbxDevolucao.Enabled := cbbTipoFaturamento.ItemIndex in [0, 1];
  cbxTransferencia.Enabled := cbbTipoFaturamento.ItemIndex in [0, 1];
  cbxConciliacaoCupons.Enabled := cbbTipoFaturamento.ItemIndex in [0, 1];
end;

procedure TFViewAliadoEdit.cbbPeriodoFaturamentoChange(Sender: TObject);
var
  lDataInicial,
  lDataFinal: TDate;
begin
  lDataFinal := EndOfTheMonth(Date);
  lDataInicial := edtDataInicial.Date;

  case cbbPeriodoFaturamento.ItemIndex of
    0: lDataInicial := StartOfTheMonth(lDataFinal);
    1: lDataInicial := StartOfTheMonth(IncMonth(lDataFinal, -3));
    2: lDataInicial := StartOfTheMonth(IncMonth(lDataFinal, -6));
    3: lDataInicial := StartOfTheMonth(IncMonth(lDataFinal, -12));
    4:
    begin
      lDataInicial := EncodeDate(YearOf(lDataFinal), 1, 1);
      lDataFinal := EndOfTheYear(lDataFinal);
    end;
    5:
    begin
      edtDataInicial.Enabled := True;
      edtDataFinal.Enabled := True;
      Exit;
    end;
  end;

  edtDataInicial.Enabled := False;
  edtDataFinal.Enabled := False;
  edtDataInicial.Date := lDataInicial;
  edtDataFinal.Date := lDataFinal;
end;

procedure TFViewAliadoEdit.cbPageSizeDataBaseChange(Sender: TObject);
begin
  FGridPluginDataBase.SetPageSize(StrToInt(cbPageSizeDataBase.Text), True);
end;

procedure TFViewAliadoEdit.cbPageSizeLogsChange(Sender: TObject);
begin
  FGridPluginLogs.SetPageSize(StrToInt(cbPageSizeLogs.Text), True);
end;

procedure TFViewAliadoEdit.cdsCertificadoAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin

  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
    if ResolveInfo.Error <> '' then
    begin
      TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, ResolveInfo.Error);
      btnCertificado.Click;
      Exit;
    end;
  end;

  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Operação realizada com sucesso!');
  asm
    $('#modal_importar_certificado').modal('hide');
  end;

  btnCertificado.Click;
end;

procedure TFViewAliadoEdit.cdsCertificadoAfterOpen(DataSet: TDataSet);
begin
  TUtils.OcultarDivLoading;

  FNovoCertificado := edcertificado_id.Text = '';
end;

procedure TFViewAliadoEdit.cdsConfigNfceAfterOpen(DataSet: TDataSet);
var
  lArrayConfiguracoes: TJSArray;
begin
  if cdsConfigNfce.Tag = 0 then
  begin
    cdsConfigNfce.Tag := 1;
    SetValoresComboNfce;
    TUtils.OcultarDivLoading;
    Exit;
  end;

  searchConfigNfce.Enabled := cdsConfigNfce.RecordCount > 0;
  btnExportarExcelConfigNfce.Enabled := cdsConfigNfce.RecordCount > 0;

  if cdsConfigNfce.RecordCount > 0 then
  begin
    lArrayConfiguracoes := TJSArray(TJSJSON.parse(cdsConfigNfce.FieldByName('configuracoes').AsString));
    asm
      const dados = lArrayConfiguracoes;
      loadFormsNfce(dados);
    end;
  end
  else
  begin
    asm clearFormsNfce(); end;
  end;

  TUtils.OcultarDivLoading;
end;

procedure TFViewAliadoEdit.cdsConfigRetaguardaAfterOpen(DataSet: TDataSet);
var
  lArrayConfiguracoes,
  lArrayConfiguracao: TJSArray;
begin
  searchConfig.Enabled := cdsConfigRetaguarda.RecordCount > 0;
  btnExportarExcelConfigRetaguarda.Enabled := cdsConfigRetaguarda.RecordCount > 0;

  if cdsConfigRetaguarda.RecordCount > 0 then
  begin
    lArrayConfiguracoes := TJSArray(TJSJSON.parse(cdsConfigRetaguarda.FieldByName('configuracoes').AsString));
    lArrayConfiguracao := TJSArray(TJSJSON.parse(cdsConfigRetaguarda.FieldByName('configuracao').AsString));

    asm
      const dados1 = lArrayConfiguracoes;
      const dados2 = lArrayConfiguracao;

      loadForms(dados1, dados2);
    end;
  end
  else
  begin
    asm
      clearForms();
    end;
  end;

  TUtils.OcultarDivLoading;
end;

procedure TFViewAliadoEdit.cdsDataBaseFaturamentoAfterOpen(DataSet: TDataSet);
var
  lTipo : string;
  lIndiceCombo,
  lIndiceGerencial: Integer;
begin
  cbbDataBase.Items.Clear;
  cdsDataBaseFaturamento.First;
  cbbDataBaseConfigRetaguarda.Items.Clear;
  cbbDataBase.Items.Add('TODOS');
  lIndiceCombo := 0;
  lIndiceGerencial := -1;

  while not cdsDataBaseFaturamento.Eof do
  begin
    if cdsDataBaseFaturamento.FieldByName('fiscal').AsInteger = 1 then
      lTipo := ' (FISCAL)'
    else
      lTipo := ' (GERENCIAL)';

    Inc(lIndiceCombo);

    cbbDataBase.Items.Add(cdsDataBaseFaturamento.FieldByName('nome_fantasia').AsString.ToUpper + lTipo);
    cbbDataBaseConfigRetaguarda.Items.Add(cdsDataBaseFaturamento.FieldByName('nome_fantasia').AsString.ToUpper + lTipo);

    if (cdsDataBaseFaturamento.FieldByName('fiscal').AsInteger = 0) and (lIndiceGerencial = -1) then
      lIndiceGerencial := lIndiceCombo;

    cdsDataBaseFaturamento.Next;
  end;

  if cbbDataBase.Items.Count = 1 then
    cbbDataBase.ItemIndex := 0
  else if cbbDataBase.Items.Count = 2 then
    cbbDataBase.ItemIndex := 1
  else if lIndiceGerencial > 0 then
    cbbDataBase.ItemIndex := lIndiceGerencial
  else
    cbbDataBase.ItemIndex := 1;

  cbbDataBaseConfigRetaguarda.ItemIndex := -1;
end;

procedure TFViewAliadoEdit.cdsFaturamentobanco_fiscalGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  if Sender.AsInteger = 1 then
    Text := '<i class="fas fa-check text-success"><i>'
  else
    Text := '<i class="fas fa-times text-danger"><i>';
end;

procedure TFViewAliadoEdit.cdsFaturamentocnpjGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarCnpj_Cpf(Sender.AsString);
end;

procedure TFViewAliadoEdit.cdsFaturamentoidGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarNumeroInteiro(Sender.AsInteger);
end;

procedure TFViewAliadoEdit.cdsFaturamentomes_anoGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarMesAno(Sender.AsString);
end;


procedure TFViewAliadoEdit.cdsFaturamentoquantidadeGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarNumeroInteiro(Sender.AsInteger);
end;

procedure TFViewAliadoEdit.cdsModulosAliadoAfterOpen(DataSet: TDataSet);
begin
  SelecionarModulosAliado;
end;

procedure TFViewAliadoEdit.cdsSincronizacaoAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  lIndice : integer;
  ResolveInfo: TResolveInfo;
begin
  for lIndice := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[lIndice];

    if ResolveInfo.Error <> '' then
    begin
      TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, ResolveInfo.Error);
      Exit;
    end
  end;

  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Rotas de sincronização atualizadas com sucesso!');
  FViewMain.GerarLog(StrToInt(edId.Text), 'sincronizacao_aliados', 'Alteração rotas de sincronização',
    TJSJSON.stringify(FArraySincronizacaoAtualizacao));

end;

procedure TFViewAliadoEdit.cdsSincronizacaoAfterOpen(DataSet: TDataSet);
begin
  CriarCheckBoxSincronizacao;

  if not TUtils.PossuiPermissao('sincronizacao_aliados', TTipoPermissao.ALTERAR) then
    TUtils.BloquearCamposDiv('div_checkbox_rotas');
end;

procedure TFViewAliadoEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbId := TLabel.Create('view.aliado.form.lbId');
  lbRazao_Social := TLabel.Create('view.aliado.form.lbRazao_Social');
  lbNome_Fantasia := TLabel.Create('view.aliado.form.lbNome_Fantasia');
  lbCNPJ := TLabel.Create('view.aliado.form.lbCNPJ');
  lbCodigo_Interno := TLabel.Create('view.aliado.form.lbCodigo_Interno');
  lbStatus := TLabel.Create('view.aliado.form.lbStatus');
  lbsegmento_nome := TLabel.Create('view.aliado.form.lbsegmento_nome');
  lbTelefone_Principal := TLabel.Create('view.aliado.form.lbTelefone_Principal');
  lbCEP := TLabel.Create('view.aliado.form.lbCEP');
  cidade_nome := TLabel.Create('view.aliado.form.lbcidade_nome');
  lbparceiro_nome := TLabel.Create('view.aliado.form.lbparceiro_nome');
  lbExcluido := TLabel.Create('view.aliado.form.lbExcluido');
  lbInclusao := TLabel.Create('view.aliado.form.lbInclusao');
  lbAlteracao := TLabel.Create('view.aliado.form.lbAlteracao');
  lbExclusao := TLabel.Create('view.aliado.form.lbExclusao');
  lbCadastro := TLabel.Create('view.aliado.form.lbCadastro');
  lbObservacoes := TLabel.Create('view.aliado.form.lbObservacoes');
  lbEnderecoCompleto := TLabel.Create('view.aliado.form.lbEnderecoCompleto');
  lbPaginationInfoLogs := TLabel.Create('lbPaginationInfoLogs');
  lbcertificado_id := TLabel.Create('lbcertificado_id');
  lbnumero_serie := TLabel.Create('lbnumero_serie');
  lbdata_vencimento := TLabel.Create('lbdata_vencimento');
  lbsenha := TLabel.Create('lbsenha');
  lbcertificado_s3 := TLabel.Create('lbcertificado_s3');
  lbcertificado_inclusao := TLabel.Create('lbcertificado_inclusao');
  lbcertificado_alteracao := TLabel.Create('lbcertificado_alteracao');
  lbPaginationInfoDataBase := TLabel.Create('lbPaginationInfoDataBase');
  lblErroCertificado := TLabel.Create('lblErroCertificado');
  imgLogoSelecionada := TImageControl.Create('imgLogoSelecionada');
  lbconfig_windows := TLabel.Create('view.aliado.form.lbconfig_windows');
  lbPaginationInfoSincServRet := TLabel.Create('lbPaginationInfoSincServRet');
  lblQuantidadeVendas := TLabel.Create('lblQuantidadeVendas');
  lblQuantidadeMeses := TLabel.Create('lblQuantidadeMeses');
  lblFaturamentoTotal := TLabel.Create('lblFaturamentoTotal');
  lblMediaFaturamento := TLabel.Create('lblMediaFaturamento');
  lblMediaTicketMedio := TLabel.Create('lblMediaTicketMedio');
  lbdata_cancelamento := TLabel.Create('view.aliado.form.lbdata_cancelamento');
  lbtempo_contrato := TLabel.Create('view.aliado.form.lbtempo_contrato');
  lbdata_ping_madrugada := TLabel.Create('view.aliado.form.lbdata_ping_madrugada');
  lbqtde_dias_servidor_ligado := TLabel.Create('view.aliado.form.lbqtde_dias_servidor_ligado');
  btCancel := TButton.Create('view.aliado.form.btBack');
  edId := TDBEdit.Create('view.aliado.form.edId');
  edRazao_Social := TDBEdit.Create('view.aliado.form.edRazao_Social');
  edNome_Fantasia := TDBEdit.Create('view.aliado.form.edNome_Fantasia');
  edCNPJ := TDBEdit.Create('view.aliado.form.edCNPJ');
  edCodigo_Interno := TDBEdit.Create('view.aliado.form.edCodigo_Interno');
  edStatus := TDBEdit.Create('view.aliado.form.edStatus');
  edsegmento_nome := TDBEdit.Create('view.aliado.form.edsegmento_nome');
  edTelefone_Principal := TDBEdit.Create('view.aliado.form.edTelefone_Principal');
  edCEP := TDBEdit.Create('view.aliado.form.edCEP');
  edcidade_nome := TDBEdit.Create('view.aliado.form.edcidade_nome');
  edparceiro_nome := TDBEdit.Create('view.aliado.form.edparceiro_nome');
  edInclusao := TDBEdit.Create('view.aliado.form.edInclusao');
  edAlteracao := TDBEdit.Create('view.aliado.form.edAlteracao');
  edExclusao := TDBEdit.Create('view.aliado.form.edExclusao');
  edCadastro := TDBEdit.Create('view.aliado.form.edCadastro');
  edObservacoes := TDBEdit.Create('view.aliado.form.edObservacoes');
  edEnderecoCompleto := TEdit.Create('view.aliado.form.edEnderecoCompleto');
  cbxexcluido := TDBCheckBox.Create('view.aliado.form.cbxexcluido');
  pnlDadosAliado := TPanel.Create(Self);
  pnlSincRetServ := TPanel.Create(Self);
  tblLogs := TDBTableControl.Create('tblLogs');
  cbPageSizeLogs := TComboBox.Create('cbPageSizeLogs');
  edSearchLogs := TEdit.Create('edSearchLogs');
  lcPaginatorLogs := TListControl.Create('lcPaginatorLogs');
  btnLogsTab := TButton.Create('line-logs-tab');
  div_checkbox_rotas := THTMLDiv.Create('div_checkbox_rotas');
  btnDadosTab := TButton.Create('line-dados-tab');
  btnSincronizacaoTab := TButton.Create('line-sincronizacao-tab');
  btnSalvarSincronizacao := TButton.Create('btnSalvarSincronizacao');
  edtSincronizacaoErro := TEdit.Create('edtSincronizacaoErro');
  pnlOutros := TPanel.Create(Self);
  pnlCertificado := TPanel.Create(Self);
  btnCertificado := TButton.Create('line-certificado-tab');
  edcertificado_id := TDBEdit.Create('edcertificado_id');
  ednumero_serie := TDBEdit.Create('ednumero_serie');
  eddata_vencimento := TDBEdit.Create('eddata_vencimento');
  edsenha := TDBEdit.Create('edsenha');
  edcertificado_s3 := TDBEdit.Create('edcertificado_s3');
  edcertificado_inclusao := TDBEdit.Create('edcertificado_inclusao');
  edcertificado_alteracao := TDBEdit.Create('edcertificado_alteracao');
  pnlTabelaDataBase := TPanel.Create(Self);
  cbPageSizeDataBase := TComboBox.Create('cbPageSizeDataBase');
  edSearchDataBase := TEdit.Create('edSearchDataBase');
  lcPaginatorDataBase := TListControl.Create('lcPaginatorDataBase');
  btnDataBaseTab := TButton.Create('line-data_base-tab');
  tblDataBase := TDBTableControl.Create('tblDataBase');
  edtSincronizacaoObservacao := TEdit.Create('edtSincronizacaoObservacao');
  div_checkbox_modulos := THTMLDiv.Create('div_checkbox_modulos');
  btnImportarCertificado := TButton.Create('btnImportarCertificado');
  wfpCertificado := TFilePicker.Create('wfpCertificado');
  btnUploadCertificado := TButton.Create('btnUploadCertificado');
  edtCertificadoSenha := TEdit.Create('edtCertificadoSenha');
  pnlRecursos := TPanel.Create(Self);
  btnRecursosTab := TButton.Create('line-recursos-tab');
  div_checkbox_recursos := THTMLDiv.Create('div_checkbox_recursos');
  cbxSincronizarDados := TCheckBox.Create('cbx_sincronizar_dados');
  btnSalvarRecursos := TButton.Create('btn_salvar_recursos');
  edtObservacaoEdit := TEdit.Create('edtObservacaoEdit');
  wfpLogomarca := TFilePicker.Create('wfpLogomarca');
  divRemoverImagem := THTMLDiv.Create('divRemoverImagem');
  edtParceiroNome := TEdit.Create('edtParceiroNome');
  btnPesquisarParceiro := TButton.Create('btnPesquisarParceiro');
  edtTelefoneWhatsappEdit := TEdit.Create('edtTelefoneWhatsappEdit');
  pnlFaturamento := TPanel.Create(Self);
  tblFaturamento := TDBTableControl.Create('tblFaturamento');
  btnFaturamentoTab := TButton.Create('line-faturamento-tab');
  btnConsultarFaturamento := TButton.Create('btnConsultarFaturamento');
  cbbDataBase := TComboBox.Create('cbbDataBase');
  cbxMovimentaEstoque := TCheckBox.Create('cbxMovimentaEstoque');
  cbxGeraFinanceiro := TCheckBox.Create('cbxGeraFinanceiro');
  cbxSimplesFaturamento := TCheckBox.Create('cbxSimplesFaturamento');
  cbxDevolucao := TCheckBox.Create('cbxDevolucao');
  cbxTransferencia := TCheckBox.Create('cbxTransferencia');
  cbxConciliacaoCupons := TCheckBox.Create('cbxConciliacaoCupons');
  cbbPeriodoFaturamento := TComboBox.Create('cbbPeriodoFaturamento');
  edtDataInicial := TDateTimePicker.Create('edtDataInicial');
  edtDataFinal := TDateTimePicker.Create('edtDataFinal');
  btnExportarExcel := TButton.Create('btnExportarExcel');
  cbbTipoFaturamento := TComboBox.Create('cbbTipoFaturamento');
  edconfig_windows := TDBEdit.Create('view.aliado.form.edconfig_windows');
  btnConectarAliado := TButton.Create('btnConectarAliado');
  pnlSincServRet := TPanel.Create(Self);
  cbbSincServRet := TComboBox.Create('cbbSincServRet');
  edtSincServRet := TEdit.Create('edtSincServRet');
  tblSincServRet := TDBTableControl.Create('tblSincServRet');
  lcPaginatorSincServRet := TListControl.Create('lcPaginatorSincServRet');
  btnSincRetServidor := TButton.Create('line-retaguarda_servidor-tab');
  btnSincServRetaguarda := TButton.Create('line-servidor_retaguarda-tab');
  eddata_cancelamento := TDBEdit.Create('view.aliado.form.eddata_cancelamento');
  edtempo_contrato := TDBEdit.Create('view.aliado.form.edtempo_contrato');
  pnlConfiguracoesRet := TPanel.Create(Self);
  btnConfigRetaguarda := TButton.Create('line-config_retaguarda-tab');
  cbbDataBaseConfigRetaguarda := TComboBox.Create('cbbDataBaseConfigRetaguarda');
  btnCarregarConfiguracoes := TButton.Create('btnCarregarConfiguracoes');
  btnExportarExcelConfigRetaguarda := TButton.Create('btnExportarExcelConfigRetaguarda');
  searchConfig := TEdit.Create('searchConfig');
  searchConfigNfce := TEdit.Create('searchConfigNfce');
  pnlConfiguracoesNfce := TPanel.Create(Self);
  cbbSerieCaixaNfce := TComboBox.Create('cbbSerieCaixaNfce');
  btnCarregarConfiguracoesNfce := TButton.Create('btnCarregarConfiguracoesNfce');
  btnExportarExcelConfigNfce := TButton.Create('btnExportarExcelConfigNfce');
  btnConfigNfce := TButton.Create('line-configuracoes_modulo_nfce-tab');
  eddata_ping_madrugada := TDBEdit.Create('view.aliado.form.eddata_ping_madrugada');
  edqtde_dias_servidor_ligado := TDBEdit.Create('view.aliado.form.edqtde_dias_servidor_ligado');
  DataSource := TDataSource.Create(Self);
  AliadoDataset := TXDataWebDataSet.Create(Self);
  AliadoDatasetId := TIntegerField.Create(Self);
  AliadoDatasetRazao_Social := TStringField.Create(Self);
  AliadoDatasetNome_Fantasia := TStringField.Create(Self);
  AliadoDatasetCNPJ := TStringField.Create(Self);
  AliadoDatasetCodigo_Interno := TIntegerField.Create(Self);
  AliadoDatasetStatus := TIntegerField.Create(Self);
  AliadoDatasetSegmento_ID := TIntegerField.Create(Self);
  AliadoDatasetTelefone_Principal := TStringField.Create(Self);
  AliadoDatasetCEP := TStringField.Create(Self);
  AliadoDatasetEndereco := TStringField.Create(Self);
  AliadoDatasetEndereco_Numero := TStringField.Create(Self);
  AliadoDatasetBairro := TStringField.Create(Self);
  AliadoDatasetCidade_ID := TIntegerField.Create(Self);
  AliadoDatasetComplemento_Endereco := TStringField.Create(Self);
  AliadoDatasetsincronizar_dados := TBooleanField.Create(Self);
  AliadoDatasetparceiro_id := TIntegerField.Create(Self);
  AliadoDatasetExcluido := TBooleanField.Create(Self);
  AliadoDatasetInclusao := TDateTimeField.Create(Self);
  AliadoDatasetAlteracao := TDateTimeField.Create(Self);
  AliadoDatasetExclusao := TDateTimeField.Create(Self);
  AliadoDatasetCadastro := TDateField.Create(Self);
  AliadoDatasetobservacoes := TStringField.Create(Self);
  AliadoDatasetcontrole_interno := TStringField.Create(Self);
  AliadoDatasetMRR := TFloatField.Create(Self);
  AliadoDatasetemail_principal := TStringField.Create(Self);
  AliadoDatasetsegmentoNome := TXDataWebDatasetField.Create(Self);
  AliadoDatasetcidadeNome := TXDataWebDatasetField.Create(Self);
  AliadoDatasetcidadeufSigla := TXDataWebDatasetField.Create(Self);
  AliadoDatasetparceironome := TStringField.Create(Self);
  AliadoDatasetlogo_base64 := TStringField.Create(Self);
  AliadoDatasettelefone_whatsapp := TStringField.Create(Self);
  AliadoDatasetconfig_windows := TStringField.Create(Self);
  AliadoDatasetdata_cancelamento := TDateField.Create(Self);
  AliadoDatasettempo_contrato := TStringField.Create(Self);
  AliadoDatasetdata_ping_madrugada := TDateTimeField.Create(Self);
  AliadoDatasetqtde_dias_servidor_ligado := TIntegerField.Create(Self);
  XDataClientAliadoGet := TXDataWebClient.Create(Self);
  cdsLogs := TXDataWebDataSet.Create(Self);
  cdsLogsid := TIntegerField.Create(Self);
  cdsLogsaliado_id := TIntegerField.Create(Self);
  cdsLogsdata_base_id := TIntegerField.Create(Self);
  cdsLogssincronizacao_service_id := TIntegerField.Create(Self);
  cdsLogsultima_sincronizacao := TDateTimeField.Create(Self);
  cdsLogsinicio_sincronizacao := TDateTimeField.Create(Self);
  cdsLogsfim_sincronizacao := TDateTimeField.Create(Self);
  cdsLogssincronizacao_erro := TStringField.Create(Self);
  cdsLogsinclusao := TDateTimeField.Create(Self);
  cdsLogsalteracao := TDateTimeField.Create(Self);
  cdsLogsultima_verificacao_retaguarda := TDateTimeField.Create(Self);
  cdsLogsversao_client := TStringField.Create(Self);
  cdsLogssincronizacao_servicerota := TXDataWebDatasetField.Create(Self);
  dtsLogs := TDataSource.Create(Self);
  tmrConsultaLogs := TTimer.Create(Self);
  cdsSincronizacao := TXDataWebDataSet.Create(Self);
  cdsSincronizacaoid := TIntegerField.Create(Self);
  cdsSincronizacaoaliado_id := TIntegerField.Create(Self);
  cdsSincronizacaosincronizacao_servicerota := TXDataWebDatasetField.Create(Self);
  cdsSincronizacaosincronizar_dados := TBooleanField.Create(Self);
  cdsCertificado := TXDataWebDataSet.Create(Self);
  cdsCertificadoid := TIntegerField.Create(Self);
  cdsCertificadonumero_serie := TStringField.Create(Self);
  cdsCertificadodata_vencimento := TDateTimeField.Create(Self);
  cdsCertificadosenha := TStringField.Create(Self);
  cdsCertificadocertificado_s3 := TStringField.Create(Self);
  cdsCertificadoinclusao := TDateTimeField.Create(Self);
  cdsCertificadoalteracao := TDateTimeField.Create(Self);
  cdsCertificadoaliado_id := TIntegerField.Create(Self);
  dtsCertificado := TDataSource.Create(Self);
  tmrConsultaDataBase := TTimer.Create(Self);
  cdsDataBase := TXDataWebDataSet.Create(Self);
  cdsDataBaseid := TIntegerField.Create(Self);
  cdsDataBasetoken := TStringField.Create(Self);
  cdsDataBasefiscal := TBooleanField.Create(Self);
  cdsDataBaseexcluido := TBooleanField.Create(Self);
  cdsDataBaseinclusao := TDateTimeField.Create(Self);
  cdsDataBasealteracao := TDateTimeField.Create(Self);
  cdsDataBaseexclusao := TDateTimeField.Create(Self);
  cdsDataBasenome_fantasia := TStringField.Create(Self);
  cdsDataBasehost := TStringField.Create(Self);
  cdsDataBasepath := TStringField.Create(Self);
  cdsDataBasedata_base_multiempresa := TBooleanField.Create(Self);
  cdsDataBasedata_base_empresa_destino := TBooleanField.Create(Self);
  cdsDataBaseversao_atual := TStringField.Create(Self);
  cdsDataBaseversao_pendente := TStringField.Create(Self);
  cdsDataBaseregime_contabil := TStringField.Create(Self);
  cdsDataBasedivulgar_promocoes := TBooleanField.Create(Self);
  cdsDataBaseassociar_produtos := TBooleanField.Create(Self);
  cdsDataBasecrt := TIntegerField.Create(Self);
  cdsDataBasecontadornome := TStringField.Create(Self);
  dtsDataBase := TDataSource.Create(Self);
  cdsModulosAliado := TXDataWebDataSet.Create(Self);
  cdsModulosAliadoid := TIntegerField.Create(Self);
  cdsModulosAliadodata_base_id := TIntegerField.Create(Self);
  cdsModulosAliadomodulo_id := TIntegerField.Create(Self);
  XDataClientRecursos := TXDataWebClient.Create(Self);
  XDataClientDataBase := TXDataWebClient.Create(Self);
  XDataWebClientModulosRetaguarda := TXDataWebClient.Create(Self);
  cdsFaturamento := TXDataWebDataSet.Create(Self);
  cdsFaturamentoid := TIntegerField.Create(Self);
  cdsFaturamentonome_fantasia := TStringField.Create(Self);
  cdsFaturamentocnpj := TStringField.Create(Self);
  cdsFaturamentobanco_fiscal := TIntegerField.Create(Self);
  cdsFaturamentomes_ano := TStringField.Create(Self);
  cdsFaturamentovalor_total_faturamento := TFloatField.Create(Self);
  cdsFaturamentoquantidade := TIntegerField.Create(Self);
  cdsFaturamentoticket_medio := TFloatField.Create(Self);
  cdsFaturamentotipo_movimento := TStringField.Create(Self);
  cdsFaturamentoultima_atualizacao := TDateTimeField.Create(Self);
  cdsFaturamentocaminho_data_base := TStringField.Create(Self);
  dtsFaturamento := TDataSource.Create(Self);
  XDataWebClientFaturamento := TXDataWebClient.Create(Self);
  cdsDataBaseFaturamento := TXDataWebDataSet.Create(Self);
  cdsSincServRet := TXDataWebDataSet.Create(Self);
  cdsSincServRetaliado_id := TIntegerField.Create(Self);
  cdsSincServRetdata_base_id := TIntegerField.Create(Self);
  cdsSincServRetultima_sincronizacao := TDateTimeField.Create(Self);
  cdsSincServRetultima_verificacao_retaguarda := TDateTimeField.Create(Self);
  cdsSincServRetversao_client := TStringField.Create(Self);
  cdsSincServRetsincronizacao_erro := TMemoField.Create(Self);
  cdsSincServRetinclusao := TDateTimeField.Create(Self);
  cdsSincServRetalteracao := TDateTimeField.Create(Self);
  cdsSincServRetsinc_servtabela_servidor := TStringField.Create(Self);
  dtsSincServRet := TDataSource.Create(Self);
  tmrSincServRet := TTimer.Create(Self);
  cdsConfigRetaguarda := TXDataWebDataSet.Create(Self);
  cdsConfigRetaguardaconfiguracoes := TStringField.Create(Self);
  cdsConfigRetaguardaconfiguracao := TStringField.Create(Self);
  cdsConfigNfce := TXDataWebDataSet.Create(Self);
  cdsConfigNfceconfiguracoes := TMemoField.Create(Self);
  cdsConfigNfcealiado_id := TIntegerField.Create(Self);
  cdsConfigNfceserie := TIntegerField.Create(Self);
  cdsConfigNfcecaixa := TIntegerField.Create(Self);

  lbId.BeforeLoadDFMValues;
  lbRazao_Social.BeforeLoadDFMValues;
  lbNome_Fantasia.BeforeLoadDFMValues;
  lbCNPJ.BeforeLoadDFMValues;
  lbCodigo_Interno.BeforeLoadDFMValues;
  lbStatus.BeforeLoadDFMValues;
  lbsegmento_nome.BeforeLoadDFMValues;
  lbTelefone_Principal.BeforeLoadDFMValues;
  lbCEP.BeforeLoadDFMValues;
  cidade_nome.BeforeLoadDFMValues;
  lbparceiro_nome.BeforeLoadDFMValues;
  lbExcluido.BeforeLoadDFMValues;
  lbInclusao.BeforeLoadDFMValues;
  lbAlteracao.BeforeLoadDFMValues;
  lbExclusao.BeforeLoadDFMValues;
  lbCadastro.BeforeLoadDFMValues;
  lbObservacoes.BeforeLoadDFMValues;
  lbEnderecoCompleto.BeforeLoadDFMValues;
  lbPaginationInfoLogs.BeforeLoadDFMValues;
  lbcertificado_id.BeforeLoadDFMValues;
  lbnumero_serie.BeforeLoadDFMValues;
  lbdata_vencimento.BeforeLoadDFMValues;
  lbsenha.BeforeLoadDFMValues;
  lbcertificado_s3.BeforeLoadDFMValues;
  lbcertificado_inclusao.BeforeLoadDFMValues;
  lbcertificado_alteracao.BeforeLoadDFMValues;
  lbPaginationInfoDataBase.BeforeLoadDFMValues;
  lblErroCertificado.BeforeLoadDFMValues;
  imgLogoSelecionada.BeforeLoadDFMValues;
  lbconfig_windows.BeforeLoadDFMValues;
  lbPaginationInfoSincServRet.BeforeLoadDFMValues;
  lblQuantidadeVendas.BeforeLoadDFMValues;
  lblQuantidadeMeses.BeforeLoadDFMValues;
  lblFaturamentoTotal.BeforeLoadDFMValues;
  lblMediaFaturamento.BeforeLoadDFMValues;
  lblMediaTicketMedio.BeforeLoadDFMValues;
  lbdata_cancelamento.BeforeLoadDFMValues;
  lbtempo_contrato.BeforeLoadDFMValues;
  lbdata_ping_madrugada.BeforeLoadDFMValues;
  lbqtde_dias_servidor_ligado.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  edId.BeforeLoadDFMValues;
  edRazao_Social.BeforeLoadDFMValues;
  edNome_Fantasia.BeforeLoadDFMValues;
  edCNPJ.BeforeLoadDFMValues;
  edCodigo_Interno.BeforeLoadDFMValues;
  edStatus.BeforeLoadDFMValues;
  edsegmento_nome.BeforeLoadDFMValues;
  edTelefone_Principal.BeforeLoadDFMValues;
  edCEP.BeforeLoadDFMValues;
  edcidade_nome.BeforeLoadDFMValues;
  edparceiro_nome.BeforeLoadDFMValues;
  edInclusao.BeforeLoadDFMValues;
  edAlteracao.BeforeLoadDFMValues;
  edExclusao.BeforeLoadDFMValues;
  edCadastro.BeforeLoadDFMValues;
  edObservacoes.BeforeLoadDFMValues;
  edEnderecoCompleto.BeforeLoadDFMValues;
  cbxexcluido.BeforeLoadDFMValues;
  pnlDadosAliado.BeforeLoadDFMValues;
  pnlSincRetServ.BeforeLoadDFMValues;
  tblLogs.BeforeLoadDFMValues;
  cbPageSizeLogs.BeforeLoadDFMValues;
  edSearchLogs.BeforeLoadDFMValues;
  lcPaginatorLogs.BeforeLoadDFMValues;
  btnLogsTab.BeforeLoadDFMValues;
  div_checkbox_rotas.BeforeLoadDFMValues;
  btnDadosTab.BeforeLoadDFMValues;
  btnSincronizacaoTab.BeforeLoadDFMValues;
  btnSalvarSincronizacao.BeforeLoadDFMValues;
  edtSincronizacaoErro.BeforeLoadDFMValues;
  pnlOutros.BeforeLoadDFMValues;
  pnlCertificado.BeforeLoadDFMValues;
  btnCertificado.BeforeLoadDFMValues;
  edcertificado_id.BeforeLoadDFMValues;
  ednumero_serie.BeforeLoadDFMValues;
  eddata_vencimento.BeforeLoadDFMValues;
  edsenha.BeforeLoadDFMValues;
  edcertificado_s3.BeforeLoadDFMValues;
  edcertificado_inclusao.BeforeLoadDFMValues;
  edcertificado_alteracao.BeforeLoadDFMValues;
  pnlTabelaDataBase.BeforeLoadDFMValues;
  cbPageSizeDataBase.BeforeLoadDFMValues;
  edSearchDataBase.BeforeLoadDFMValues;
  lcPaginatorDataBase.BeforeLoadDFMValues;
  btnDataBaseTab.BeforeLoadDFMValues;
  tblDataBase.BeforeLoadDFMValues;
  edtSincronizacaoObservacao.BeforeLoadDFMValues;
  div_checkbox_modulos.BeforeLoadDFMValues;
  btnImportarCertificado.BeforeLoadDFMValues;
  wfpCertificado.BeforeLoadDFMValues;
  btnUploadCertificado.BeforeLoadDFMValues;
  edtCertificadoSenha.BeforeLoadDFMValues;
  pnlRecursos.BeforeLoadDFMValues;
  btnRecursosTab.BeforeLoadDFMValues;
  div_checkbox_recursos.BeforeLoadDFMValues;
  cbxSincronizarDados.BeforeLoadDFMValues;
  btnSalvarRecursos.BeforeLoadDFMValues;
  edtObservacaoEdit.BeforeLoadDFMValues;
  wfpLogomarca.BeforeLoadDFMValues;
  divRemoverImagem.BeforeLoadDFMValues;
  edtParceiroNome.BeforeLoadDFMValues;
  btnPesquisarParceiro.BeforeLoadDFMValues;
  edtTelefoneWhatsappEdit.BeforeLoadDFMValues;
  pnlFaturamento.BeforeLoadDFMValues;
  tblFaturamento.BeforeLoadDFMValues;
  btnFaturamentoTab.BeforeLoadDFMValues;
  btnConsultarFaturamento.BeforeLoadDFMValues;
  cbbDataBase.BeforeLoadDFMValues;
  cbxMovimentaEstoque.BeforeLoadDFMValues;
  cbxGeraFinanceiro.BeforeLoadDFMValues;
  cbxSimplesFaturamento.BeforeLoadDFMValues;
  cbxDevolucao.BeforeLoadDFMValues;
  cbxTransferencia.BeforeLoadDFMValues;
  cbxConciliacaoCupons.BeforeLoadDFMValues;
  cbbPeriodoFaturamento.BeforeLoadDFMValues;
  edtDataInicial.BeforeLoadDFMValues;
  edtDataFinal.BeforeLoadDFMValues;
  btnExportarExcel.BeforeLoadDFMValues;
  cbbTipoFaturamento.BeforeLoadDFMValues;
  edconfig_windows.BeforeLoadDFMValues;
  btnConectarAliado.BeforeLoadDFMValues;
  pnlSincServRet.BeforeLoadDFMValues;
  cbbSincServRet.BeforeLoadDFMValues;
  edtSincServRet.BeforeLoadDFMValues;
  tblSincServRet.BeforeLoadDFMValues;
  lcPaginatorSincServRet.BeforeLoadDFMValues;
  btnSincRetServidor.BeforeLoadDFMValues;
  btnSincServRetaguarda.BeforeLoadDFMValues;
  eddata_cancelamento.BeforeLoadDFMValues;
  edtempo_contrato.BeforeLoadDFMValues;
  pnlConfiguracoesRet.BeforeLoadDFMValues;
  btnConfigRetaguarda.BeforeLoadDFMValues;
  cbbDataBaseConfigRetaguarda.BeforeLoadDFMValues;
  btnCarregarConfiguracoes.BeforeLoadDFMValues;
  btnExportarExcelConfigRetaguarda.BeforeLoadDFMValues;
  searchConfig.BeforeLoadDFMValues;
  searchConfigNfce.BeforeLoadDFMValues;
  pnlConfiguracoesNfce.BeforeLoadDFMValues;
  cbbSerieCaixaNfce.BeforeLoadDFMValues;
  btnCarregarConfiguracoesNfce.BeforeLoadDFMValues;
  btnExportarExcelConfigNfce.BeforeLoadDFMValues;
  btnConfigNfce.BeforeLoadDFMValues;
  eddata_ping_madrugada.BeforeLoadDFMValues;
  edqtde_dias_servidor_ligado.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  AliadoDataset.BeforeLoadDFMValues;
  AliadoDatasetId.BeforeLoadDFMValues;
  AliadoDatasetRazao_Social.BeforeLoadDFMValues;
  AliadoDatasetNome_Fantasia.BeforeLoadDFMValues;
  AliadoDatasetCNPJ.BeforeLoadDFMValues;
  AliadoDatasetCodigo_Interno.BeforeLoadDFMValues;
  AliadoDatasetStatus.BeforeLoadDFMValues;
  AliadoDatasetSegmento_ID.BeforeLoadDFMValues;
  AliadoDatasetTelefone_Principal.BeforeLoadDFMValues;
  AliadoDatasetCEP.BeforeLoadDFMValues;
  AliadoDatasetEndereco.BeforeLoadDFMValues;
  AliadoDatasetEndereco_Numero.BeforeLoadDFMValues;
  AliadoDatasetBairro.BeforeLoadDFMValues;
  AliadoDatasetCidade_ID.BeforeLoadDFMValues;
  AliadoDatasetComplemento_Endereco.BeforeLoadDFMValues;
  AliadoDatasetsincronizar_dados.BeforeLoadDFMValues;
  AliadoDatasetparceiro_id.BeforeLoadDFMValues;
  AliadoDatasetExcluido.BeforeLoadDFMValues;
  AliadoDatasetInclusao.BeforeLoadDFMValues;
  AliadoDatasetAlteracao.BeforeLoadDFMValues;
  AliadoDatasetExclusao.BeforeLoadDFMValues;
  AliadoDatasetCadastro.BeforeLoadDFMValues;
  AliadoDatasetobservacoes.BeforeLoadDFMValues;
  AliadoDatasetcontrole_interno.BeforeLoadDFMValues;
  AliadoDatasetMRR.BeforeLoadDFMValues;
  AliadoDatasetemail_principal.BeforeLoadDFMValues;
  AliadoDatasetsegmentoNome.BeforeLoadDFMValues;
  AliadoDatasetcidadeNome.BeforeLoadDFMValues;
  AliadoDatasetcidadeufSigla.BeforeLoadDFMValues;
  AliadoDatasetparceironome.BeforeLoadDFMValues;
  AliadoDatasetlogo_base64.BeforeLoadDFMValues;
  AliadoDatasettelefone_whatsapp.BeforeLoadDFMValues;
  AliadoDatasetconfig_windows.BeforeLoadDFMValues;
  AliadoDatasetdata_cancelamento.BeforeLoadDFMValues;
  AliadoDatasettempo_contrato.BeforeLoadDFMValues;
  AliadoDatasetdata_ping_madrugada.BeforeLoadDFMValues;
  AliadoDatasetqtde_dias_servidor_ligado.BeforeLoadDFMValues;
  XDataClientAliadoGet.BeforeLoadDFMValues;
  cdsLogs.BeforeLoadDFMValues;
  cdsLogsid.BeforeLoadDFMValues;
  cdsLogsaliado_id.BeforeLoadDFMValues;
  cdsLogsdata_base_id.BeforeLoadDFMValues;
  cdsLogssincronizacao_service_id.BeforeLoadDFMValues;
  cdsLogsultima_sincronizacao.BeforeLoadDFMValues;
  cdsLogsinicio_sincronizacao.BeforeLoadDFMValues;
  cdsLogsfim_sincronizacao.BeforeLoadDFMValues;
  cdsLogssincronizacao_erro.BeforeLoadDFMValues;
  cdsLogsinclusao.BeforeLoadDFMValues;
  cdsLogsalteracao.BeforeLoadDFMValues;
  cdsLogsultima_verificacao_retaguarda.BeforeLoadDFMValues;
  cdsLogsversao_client.BeforeLoadDFMValues;
  cdsLogssincronizacao_servicerota.BeforeLoadDFMValues;
  dtsLogs.BeforeLoadDFMValues;
  tmrConsultaLogs.BeforeLoadDFMValues;
  cdsSincronizacao.BeforeLoadDFMValues;
  cdsSincronizacaoid.BeforeLoadDFMValues;
  cdsSincronizacaoaliado_id.BeforeLoadDFMValues;
  cdsSincronizacaosincronizacao_servicerota.BeforeLoadDFMValues;
  cdsSincronizacaosincronizar_dados.BeforeLoadDFMValues;
  cdsCertificado.BeforeLoadDFMValues;
  cdsCertificadoid.BeforeLoadDFMValues;
  cdsCertificadonumero_serie.BeforeLoadDFMValues;
  cdsCertificadodata_vencimento.BeforeLoadDFMValues;
  cdsCertificadosenha.BeforeLoadDFMValues;
  cdsCertificadocertificado_s3.BeforeLoadDFMValues;
  cdsCertificadoinclusao.BeforeLoadDFMValues;
  cdsCertificadoalteracao.BeforeLoadDFMValues;
  cdsCertificadoaliado_id.BeforeLoadDFMValues;
  dtsCertificado.BeforeLoadDFMValues;
  tmrConsultaDataBase.BeforeLoadDFMValues;
  cdsDataBase.BeforeLoadDFMValues;
  cdsDataBaseid.BeforeLoadDFMValues;
  cdsDataBasetoken.BeforeLoadDFMValues;
  cdsDataBasefiscal.BeforeLoadDFMValues;
  cdsDataBaseexcluido.BeforeLoadDFMValues;
  cdsDataBaseinclusao.BeforeLoadDFMValues;
  cdsDataBasealteracao.BeforeLoadDFMValues;
  cdsDataBaseexclusao.BeforeLoadDFMValues;
  cdsDataBasenome_fantasia.BeforeLoadDFMValues;
  cdsDataBasehost.BeforeLoadDFMValues;
  cdsDataBasepath.BeforeLoadDFMValues;
  cdsDataBasedata_base_multiempresa.BeforeLoadDFMValues;
  cdsDataBasedata_base_empresa_destino.BeforeLoadDFMValues;
  cdsDataBaseversao_atual.BeforeLoadDFMValues;
  cdsDataBaseversao_pendente.BeforeLoadDFMValues;
  cdsDataBaseregime_contabil.BeforeLoadDFMValues;
  cdsDataBasedivulgar_promocoes.BeforeLoadDFMValues;
  cdsDataBaseassociar_produtos.BeforeLoadDFMValues;
  cdsDataBasecrt.BeforeLoadDFMValues;
  cdsDataBasecontadornome.BeforeLoadDFMValues;
  dtsDataBase.BeforeLoadDFMValues;
  cdsModulosAliado.BeforeLoadDFMValues;
  cdsModulosAliadoid.BeforeLoadDFMValues;
  cdsModulosAliadodata_base_id.BeforeLoadDFMValues;
  cdsModulosAliadomodulo_id.BeforeLoadDFMValues;
  XDataClientRecursos.BeforeLoadDFMValues;
  XDataClientDataBase.BeforeLoadDFMValues;
  XDataWebClientModulosRetaguarda.BeforeLoadDFMValues;
  cdsFaturamento.BeforeLoadDFMValues;
  cdsFaturamentoid.BeforeLoadDFMValues;
  cdsFaturamentonome_fantasia.BeforeLoadDFMValues;
  cdsFaturamentocnpj.BeforeLoadDFMValues;
  cdsFaturamentobanco_fiscal.BeforeLoadDFMValues;
  cdsFaturamentomes_ano.BeforeLoadDFMValues;
  cdsFaturamentovalor_total_faturamento.BeforeLoadDFMValues;
  cdsFaturamentoquantidade.BeforeLoadDFMValues;
  cdsFaturamentoticket_medio.BeforeLoadDFMValues;
  cdsFaturamentotipo_movimento.BeforeLoadDFMValues;
  cdsFaturamentoultima_atualizacao.BeforeLoadDFMValues;
  cdsFaturamentocaminho_data_base.BeforeLoadDFMValues;
  dtsFaturamento.BeforeLoadDFMValues;
  XDataWebClientFaturamento.BeforeLoadDFMValues;
  cdsDataBaseFaturamento.BeforeLoadDFMValues;
  cdsSincServRet.BeforeLoadDFMValues;
  cdsSincServRetaliado_id.BeforeLoadDFMValues;
  cdsSincServRetdata_base_id.BeforeLoadDFMValues;
  cdsSincServRetultima_sincronizacao.BeforeLoadDFMValues;
  cdsSincServRetultima_verificacao_retaguarda.BeforeLoadDFMValues;
  cdsSincServRetversao_client.BeforeLoadDFMValues;
  cdsSincServRetsincronizacao_erro.BeforeLoadDFMValues;
  cdsSincServRetinclusao.BeforeLoadDFMValues;
  cdsSincServRetalteracao.BeforeLoadDFMValues;
  cdsSincServRetsinc_servtabela_servidor.BeforeLoadDFMValues;
  dtsSincServRet.BeforeLoadDFMValues;
  tmrSincServRet.BeforeLoadDFMValues;
  cdsConfigRetaguarda.BeforeLoadDFMValues;
  cdsConfigRetaguardaconfiguracoes.BeforeLoadDFMValues;
  cdsConfigRetaguardaconfiguracao.BeforeLoadDFMValues;
  cdsConfigNfce.BeforeLoadDFMValues;
  cdsConfigNfceconfiguracoes.BeforeLoadDFMValues;
  cdsConfigNfcealiado_id.BeforeLoadDFMValues;
  cdsConfigNfceserie.BeforeLoadDFMValues;
  cdsConfigNfcecaixa.BeforeLoadDFMValues;
  try
    Name := 'FViewAliadoEdit';
    Width := 1089;
    Height := 809;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbId.SetParentComponent(Self);
    lbId.Name := 'lbId';
    lbId.Left := 8;
    lbId.Top := 24;
    lbId.Width := 23;
    lbId.Height := 13;
    lbId.Caption := 'C'#243'd:';
    lbId.HeightPercent := 100.000000000000000000;
    lbId.WidthPercent := 100.000000000000000000;
    lbRazao_Social.SetParentComponent(Self);
    lbRazao_Social.Name := 'lbRazao_Social';
    lbRazao_Social.Left := 7;
    lbRazao_Social.Top := 131;
    lbRazao_Social.Width := 64;
    lbRazao_Social.Height := 13;
    lbRazao_Social.Caption := 'Raz'#227'o Social:';
    lbRazao_Social.HeightPercent := 100.000000000000000000;
    lbRazao_Social.WidthPercent := 100.000000000000000000;
    lbNome_Fantasia.SetParentComponent(Self);
    lbNome_Fantasia.Name := 'lbNome_Fantasia';
    lbNome_Fantasia.Left := 7;
    lbNome_Fantasia.Top := 105;
    lbNome_Fantasia.Width := 75;
    lbNome_Fantasia.Height := 13;
    lbNome_Fantasia.Caption := 'Nome Fantasia:';
    lbNome_Fantasia.HeightPercent := 100.000000000000000000;
    lbNome_Fantasia.WidthPercent := 100.000000000000000000;
    lbCNPJ.SetParentComponent(Self);
    lbCNPJ.Name := 'lbCNPJ';
    lbCNPJ.Left := 8;
    lbCNPJ.Top := 184;
    lbCNPJ.Width := 26;
    lbCNPJ.Height := 13;
    lbCNPJ.Caption := 'Cnpj:';
    lbCNPJ.HeightPercent := 100.000000000000000000;
    lbCNPJ.WidthPercent := 100.000000000000000000;
    lbCodigo_Interno.SetParentComponent(Self);
    lbCodigo_Interno.Name := 'lbCodigo_Interno';
    lbCodigo_Interno.Left := 8;
    lbCodigo_Interno.Top := 211;
    lbCodigo_Interno.Width := 66;
    lbCodigo_Interno.Height := 13;
    lbCodigo_Interno.Caption := 'C'#243'd. Interno:';
    lbCodigo_Interno.HeightPercent := 100.000000000000000000;
    lbCodigo_Interno.WidthPercent := 100.000000000000000000;
    lbStatus.SetParentComponent(Self);
    lbStatus.Name := 'lbStatus';
    lbStatus.Left := 8;
    lbStatus.Top := 52;
    lbStatus.Width := 35;
    lbStatus.Height := 13;
    lbStatus.Caption := 'Status:';
    lbStatus.HeightPercent := 100.000000000000000000;
    lbStatus.WidthPercent := 100.000000000000000000;
    lbsegmento_nome.SetParentComponent(Self);
    lbsegmento_nome.Name := 'lbsegmento_nome';
    lbsegmento_nome.Left := 7;
    lbsegmento_nome.Top := 157;
    lbsegmento_nome.Width := 52;
    lbsegmento_nome.Height := 13;
    lbsegmento_nome.Caption := 'Segmento:';
    lbsegmento_nome.HeightPercent := 100.000000000000000000;
    lbsegmento_nome.WidthPercent := 100.000000000000000000;
    lbTelefone_Principal.SetParentComponent(Self);
    lbTelefone_Principal.Name := 'lbTelefone_Principal';
    lbTelefone_Principal.Left := 195;
    lbTelefone_Principal.Top := 24;
    lbTelefone_Principal.Width := 88;
    lbTelefone_Principal.Height := 13;
    lbTelefone_Principal.Caption := 'Telefone Principal:';
    lbTelefone_Principal.HeightPercent := 100.000000000000000000;
    lbTelefone_Principal.WidthPercent := 100.000000000000000000;
    lbCEP.SetParentComponent(Self);
    lbCEP.Name := 'lbCEP';
    lbCEP.Left := 195;
    lbCEP.Top := 79;
    lbCEP.Width := 23;
    lbCEP.Height := 13;
    lbCEP.Caption := 'Cep:';
    lbCEP.HeightPercent := 100.000000000000000000;
    lbCEP.WidthPercent := 100.000000000000000000;
    cidade_nome.SetParentComponent(Self);
    cidade_nome.Name := 'cidade_nome';
    cidade_nome.Left := 195;
    cidade_nome.Top := 52;
    cidade_nome.Width := 37;
    cidade_nome.Height := 13;
    cidade_nome.Caption := 'Cidade:';
    cidade_nome.HeightPercent := 100.000000000000000000;
    cidade_nome.WidthPercent := 100.000000000000000000;
    lbparceiro_nome.SetParentComponent(Self);
    lbparceiro_nome.Name := 'lbparceiro_nome';
    lbparceiro_nome.Left := 195;
    lbparceiro_nome.Top := 131;
    lbparceiro_nome.Width := 43;
    lbparceiro_nome.Height := 13;
    lbparceiro_nome.Caption := 'Parceiro:';
    lbparceiro_nome.HeightPercent := 100.000000000000000000;
    lbparceiro_nome.WidthPercent := 100.000000000000000000;
    lbExcluido.SetParentComponent(Self);
    lbExcluido.Name := 'lbExcluido';
    lbExcluido.Left := 195;
    lbExcluido.Top := 267;
    lbExcluido.Width := 44;
    lbExcluido.Height := 13;
    lbExcluido.Caption := 'Exclu'#237'do?';
    lbExcluido.HeightPercent := 100.000000000000000000;
    lbExcluido.WidthPercent := 100.000000000000000000;
    lbInclusao.SetParentComponent(Self);
    lbInclusao.Name := 'lbInclusao';
    lbInclusao.Left := 195;
    lbInclusao.Top := 211;
    lbInclusao.Width := 44;
    lbInclusao.Height := 13;
    lbInclusao.Caption := 'Inclus'#227'o:';
    lbInclusao.HeightPercent := 100.000000000000000000;
    lbInclusao.WidthPercent := 100.000000000000000000;
    lbAlteracao.SetParentComponent(Self);
    lbAlteracao.Name := 'lbAlteracao';
    lbAlteracao.Left := 195;
    lbAlteracao.Top := 239;
    lbAlteracao.Width := 50;
    lbAlteracao.Height := 13;
    lbAlteracao.Caption := 'Alterac'#227'o:';
    lbAlteracao.HeightPercent := 100.000000000000000000;
    lbAlteracao.WidthPercent := 100.000000000000000000;
    lbExclusao.SetParentComponent(Self);
    lbExclusao.Name := 'lbExclusao';
    lbExclusao.Left := 8;
    lbExclusao.Top := 267;
    lbExclusao.Width := 46;
    lbExclusao.Height := 13;
    lbExclusao.Caption := 'Exclus'#227'o:';
    lbExclusao.HeightPercent := 100.000000000000000000;
    lbExclusao.WidthPercent := 100.000000000000000000;
    lbCadastro.SetParentComponent(Self);
    lbCadastro.Name := 'lbCadastro';
    lbCadastro.Left := 195;
    lbCadastro.Top := 157;
    lbCadastro.Width := 48;
    lbCadastro.Height := 13;
    lbCadastro.Caption := 'Cadastro:';
    lbCadastro.HeightPercent := 100.000000000000000000;
    lbCadastro.WidthPercent := 100.000000000000000000;
    lbObservacoes.SetParentComponent(Self);
    lbObservacoes.Name := 'lbObservacoes';
    lbObservacoes.Left := 7;
    lbObservacoes.Top := 79;
    lbObservacoes.Width := 67;
    lbObservacoes.Height := 13;
    lbObservacoes.Caption := 'Observa'#231#245'es:';
    lbObservacoes.HeightPercent := 100.000000000000000000;
    lbObservacoes.WidthPercent := 100.000000000000000000;
    lbEnderecoCompleto.SetParentComponent(Self);
    lbEnderecoCompleto.Name := 'lbEnderecoCompleto';
    lbEnderecoCompleto.Left := 8;
    lbEnderecoCompleto.Top := 239;
    lbEnderecoCompleto.Width := 49;
    lbEnderecoCompleto.Height := 13;
    lbEnderecoCompleto.Caption := 'Endere'#231'o:';
    lbEnderecoCompleto.HeightPercent := 100.000000000000000000;
    lbEnderecoCompleto.WidthPercent := 100.000000000000000000;
    lbPaginationInfoLogs.SetParentComponent(Self);
    lbPaginationInfoLogs.Name := 'lbPaginationInfoLogs';
    lbPaginationInfoLogs.Left := 662;
    lbPaginationInfoLogs.Top := 564;
    lbPaginationInfoLogs.Width := 141;
    lbPaginationInfoLogs.Height := 13;
    lbPaginationInfoLogs.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfoLogs.HeightPercent := 100.000000000000000000;
    lbPaginationInfoLogs.WidthPercent := 100.000000000000000000;
    lbcertificado_id.SetParentComponent(Self);
    lbcertificado_id.Name := 'lbcertificado_id';
    lbcertificado_id.Left := 717;
    lbcertificado_id.Top := 24;
    lbcertificado_id.Width := 23;
    lbcertificado_id.Height := 13;
    lbcertificado_id.Caption := 'C'#243'd:';
    lbcertificado_id.HeightPercent := 100.000000000000000000;
    lbcertificado_id.WidthPercent := 100.000000000000000000;
    lbnumero_serie.SetParentComponent(Self);
    lbnumero_serie.Name := 'lbnumero_serie';
    lbnumero_serie.Left := 717;
    lbnumero_serie.Top := 52;
    lbnumero_serie.Width := 68;
    lbnumero_serie.Height := 13;
    lbnumero_serie.Caption := 'N'#250'mero S'#233'rie:';
    lbnumero_serie.HeightPercent := 100.000000000000000000;
    lbnumero_serie.WidthPercent := 100.000000000000000000;
    lbdata_vencimento.SetParentComponent(Self);
    lbdata_vencimento.Name := 'lbdata_vencimento';
    lbdata_vencimento.Left := 717;
    lbdata_vencimento.Top := 79;
    lbdata_vencimento.Width := 85;
    lbdata_vencimento.Height := 13;
    lbdata_vencimento.Caption := 'Data Vencimento:';
    lbdata_vencimento.HeightPercent := 100.000000000000000000;
    lbdata_vencimento.WidthPercent := 100.000000000000000000;
    lbsenha.SetParentComponent(Self);
    lbsenha.Name := 'lbsenha';
    lbsenha.Left := 717;
    lbsenha.Top := 106;
    lbsenha.Width := 34;
    lbsenha.Height := 13;
    lbsenha.Caption := 'Senha:';
    lbsenha.HeightPercent := 100.000000000000000000;
    lbsenha.WidthPercent := 100.000000000000000000;
    lbcertificado_s3.SetParentComponent(Self);
    lbcertificado_s3.Name := 'lbcertificado_s3';
    lbcertificado_s3.Left := 901;
    lbcertificado_s3.Top := 24;
    lbcertificado_s3.Width := 60;
    lbcertificado_s3.Height := 13;
    lbcertificado_s3.Caption := 'Caminho S3:';
    lbcertificado_s3.HeightPercent := 100.000000000000000000;
    lbcertificado_s3.WidthPercent := 100.000000000000000000;
    lbcertificado_inclusao.SetParentComponent(Self);
    lbcertificado_inclusao.Name := 'lbcertificado_inclusao';
    lbcertificado_inclusao.Left := 901;
    lbcertificado_inclusao.Top := 51;
    lbcertificado_inclusao.Width := 44;
    lbcertificado_inclusao.Height := 13;
    lbcertificado_inclusao.Caption := 'Inclus'#227'o:';
    lbcertificado_inclusao.HeightPercent := 100.000000000000000000;
    lbcertificado_inclusao.WidthPercent := 100.000000000000000000;
    lbcertificado_alteracao.SetParentComponent(Self);
    lbcertificado_alteracao.Name := 'lbcertificado_alteracao';
    lbcertificado_alteracao.Left := 901;
    lbcertificado_alteracao.Top := 78;
    lbcertificado_alteracao.Width := 50;
    lbcertificado_alteracao.Height := 13;
    lbcertificado_alteracao.Caption := 'Altera'#231#227'o:';
    lbcertificado_alteracao.HeightPercent := 100.000000000000000000;
    lbcertificado_alteracao.WidthPercent := 100.000000000000000000;
    lbPaginationInfoDataBase.SetParentComponent(Self);
    lbPaginationInfoDataBase.Name := 'lbPaginationInfoDataBase';
    lbPaginationInfoDataBase.Left := 8;
    lbPaginationInfoDataBase.Top := 540;
    lbPaginationInfoDataBase.Width := 141;
    lbPaginationInfoDataBase.Height := 13;
    lbPaginationInfoDataBase.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfoDataBase.HeightPercent := 100.000000000000000000;
    lbPaginationInfoDataBase.WidthPercent := 100.000000000000000000;
    lblErroCertificado.SetParentComponent(Self);
    lblErroCertificado.Name := 'lblErroCertificado';
    lblErroCertificado.Left := 819;
    lblErroCertificado.Top := 185;
    lblErroCertificado.Width := 24;
    lblErroCertificado.Height := 13;
    lblErroCertificado.Caption := 'Erro:';
    lblErroCertificado.HeightPercent := 100.000000000000000000;
    lblErroCertificado.Visible := False;
    lblErroCertificado.WidthPercent := 100.000000000000000000;
    imgLogoSelecionada.SetParentComponent(Self);
    imgLogoSelecionada.Name := 'imgLogoSelecionada';
    imgLogoSelecionada.Left := 452;
    imgLogoSelecionada.Top := 112;
    imgLogoSelecionada.Width := 100;
    imgLogoSelecionada.Height := 41;
    imgLogoSelecionada.HeightPercent := 100.000000000000000000;
    imgLogoSelecionada.WidthPercent := 100.000000000000000000;
    imgLogoSelecionada.ChildOrder := 91;
    lbconfig_windows.SetParentComponent(Self);
    lbconfig_windows.Name := 'lbconfig_windows';
    lbconfig_windows.Left := 195;
    lbconfig_windows.Top := 183;
    lbconfig_windows.Width := 119;
    lbconfig_windows.Height := 13;
    lbconfig_windows.Caption := 'Configura'#231#245'es Windows:';
    lbconfig_windows.HeightPercent := 100.000000000000000000;
    lbconfig_windows.WidthPercent := 100.000000000000000000;
    lbPaginationInfoSincServRet.SetParentComponent(Self);
    lbPaginationInfoSincServRet.Name := 'lbPaginationInfoSincServRet';
    lbPaginationInfoSincServRet.Left := 881;
    lbPaginationInfoSincServRet.Top := 564;
    lbPaginationInfoSincServRet.Width := 141;
    lbPaginationInfoSincServRet.Height := 13;
    lbPaginationInfoSincServRet.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfoSincServRet.HeightPercent := 100.000000000000000000;
    lbPaginationInfoSincServRet.WidthPercent := 100.000000000000000000;
    lblQuantidadeVendas.SetParentComponent(Self);
    lblQuantidadeVendas.Name := 'lblQuantidadeVendas';
    lblQuantidadeVendas.Left := 280;
    lblQuantidadeVendas.Top := 665;
    lblQuantidadeVendas.Width := 4;
    lblQuantidadeVendas.Height := 13;
    lblQuantidadeVendas.Caption := '-';
    lblQuantidadeVendas.Color := clBtnFace;
    lblQuantidadeVendas.HeightPercent := 100.000000000000000000;
    lblQuantidadeVendas.WidthPercent := 100.000000000000000000;
    lblQuantidadeMeses.SetParentComponent(Self);
    lblQuantidadeMeses.Name := 'lblQuantidadeMeses';
    lblQuantidadeMeses.Left := 280;
    lblQuantidadeMeses.Top := 685;
    lblQuantidadeMeses.Width := 4;
    lblQuantidadeMeses.Height := 13;
    lblQuantidadeMeses.Caption := '-';
    lblQuantidadeMeses.Color := clBtnFace;
    lblQuantidadeMeses.HeightPercent := 100.000000000000000000;
    lblQuantidadeMeses.WidthPercent := 100.000000000000000000;
    lblFaturamentoTotal.SetParentComponent(Self);
    lblFaturamentoTotal.Name := 'lblFaturamentoTotal';
    lblFaturamentoTotal.Left := 280;
    lblFaturamentoTotal.Top := 706;
    lblFaturamentoTotal.Width := 4;
    lblFaturamentoTotal.Height := 13;
    lblFaturamentoTotal.Caption := '-';
    lblFaturamentoTotal.Color := clBtnFace;
    lblFaturamentoTotal.HeightPercent := 100.000000000000000000;
    lblFaturamentoTotal.WidthPercent := 100.000000000000000000;
    lblMediaFaturamento.SetParentComponent(Self);
    lblMediaFaturamento.Name := 'lblMediaFaturamento';
    lblMediaFaturamento.Left := 408;
    lblMediaFaturamento.Top := 665;
    lblMediaFaturamento.Width := 4;
    lblMediaFaturamento.Height := 13;
    lblMediaFaturamento.Caption := '-';
    lblMediaFaturamento.Color := clBtnFace;
    lblMediaFaturamento.HeightPercent := 100.000000000000000000;
    lblMediaFaturamento.WidthPercent := 100.000000000000000000;
    lblMediaTicketMedio.SetParentComponent(Self);
    lblMediaTicketMedio.Name := 'lblMediaTicketMedio';
    lblMediaTicketMedio.Left := 408;
    lblMediaTicketMedio.Top := 686;
    lblMediaTicketMedio.Width := 4;
    lblMediaTicketMedio.Height := 13;
    lblMediaTicketMedio.Caption := '-';
    lblMediaTicketMedio.Color := clBtnFace;
    lblMediaTicketMedio.HeightPercent := 100.000000000000000000;
    lblMediaTicketMedio.WidthPercent := 100.000000000000000000;
    lbdata_cancelamento.SetParentComponent(Self);
    lbdata_cancelamento.Name := 'lbdata_cancelamento';
    lbdata_cancelamento.Left := 8;
    lbdata_cancelamento.Top := 292;
    lbdata_cancelamento.Width := 66;
    lbdata_cancelamento.Height := 13;
    lbdata_cancelamento.Caption := 'Data Cancel.:';
    lbdata_cancelamento.HeightPercent := 100.000000000000000000;
    lbdata_cancelamento.WidthPercent := 100.000000000000000000;
    lbtempo_contrato.SetParentComponent(Self);
    lbtempo_contrato.Name := 'lbtempo_contrato';
    lbtempo_contrato.Left := 8;
    lbtempo_contrato.Top := 316;
    lbtempo_contrato.Width := 82;
    lbtempo_contrato.Height := 13;
    lbtempo_contrato.Caption := 'Tempo Contrato:';
    lbtempo_contrato.HeightPercent := 100.000000000000000000;
    lbtempo_contrato.WidthPercent := 100.000000000000000000;
    lbdata_ping_madrugada.SetParentComponent(Self);
    lbdata_ping_madrugada.Name := 'lbdata_ping_madrugada';
    lbdata_ping_madrugada.Left := 195;
    lbdata_ping_madrugada.Top := 104;
    lbdata_ping_madrugada.Width := 110;
    lbdata_ping_madrugada.Height := 13;
    lbdata_ping_madrugada.Caption := 'Ping Serv. Madrugada:';
    lbdata_ping_madrugada.HeightPercent := 100.000000000000000000;
    lbdata_ping_madrugada.WidthPercent := 100.000000000000000000;
    lbqtde_dias_servidor_ligado.SetParentComponent(Self);
    lbqtde_dias_servidor_ligado.Name := 'lbqtde_dias_servidor_ligado';
    lbqtde_dias_servidor_ligado.Left := 195;
    lbqtde_dias_servidor_ligado.Top := 293;
    lbqtde_dias_servidor_ligado.Width := 87;
    lbqtde_dias_servidor_ligado.Height := 13;
    lbqtde_dias_servidor_ligado.Caption := 'Dias Serv. Ligado:';
    lbqtde_dias_servidor_ligado.HeightPercent := 100.000000000000000000;
    lbqtde_dias_servidor_ligado.WidthPercent := 100.000000000000000000;
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 274;
    btCancel.Top := 316;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Voltar';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    edId.SetParentComponent(Self);
    edId.Name := 'edId';
    edId.Left := 85;
    edId.Top := 21;
    edId.Width := 100;
    edId.Height := 21;
    edId.Enabled := False;
    edId.HeightPercent := 100.000000000000000000;
    edId.TabOrder := 6;
    edId.Text := 'edId';
    edId.WidthPercent := 100.000000000000000000;
    edId.DataField := 'Id';
    edId.DataSource := DataSource;
    edRazao_Social.SetParentComponent(Self);
    edRazao_Social.Name := 'edRazao_Social';
    edRazao_Social.Left := 85;
    edRazao_Social.Top := 128;
    edRazao_Social.Width := 100;
    edRazao_Social.Height := 20;
    edRazao_Social.Enabled := False;
    edRazao_Social.HeightPercent := 100.000000000000000000;
    edRazao_Social.TabOrder := 7;
    edRazao_Social.Text := 'edRazao_Social';
    edRazao_Social.WidthPercent := 100.000000000000000000;
    edRazao_Social.DataField := 'Razao_Social';
    edRazao_Social.DataSource := DataSource;
    edNome_Fantasia.SetParentComponent(Self);
    edNome_Fantasia.Name := 'edNome_Fantasia';
    edNome_Fantasia.Left := 86;
    edNome_Fantasia.Top := 102;
    edNome_Fantasia.Width := 100;
    edNome_Fantasia.Height := 21;
    edNome_Fantasia.Enabled := False;
    edNome_Fantasia.HeightPercent := 100.000000000000000000;
    edNome_Fantasia.TabOrder := 8;
    edNome_Fantasia.Text := 'edNome_Fantasia';
    edNome_Fantasia.WidthPercent := 100.000000000000000000;
    edNome_Fantasia.DataField := 'Nome_Fantasia';
    edNome_Fantasia.DataSource := DataSource;
    edCNPJ.SetParentComponent(Self);
    edCNPJ.Name := 'edCNPJ';
    edCNPJ.Left := 85;
    edCNPJ.Top := 181;
    edCNPJ.Width := 100;
    edCNPJ.Height := 21;
    edCNPJ.Enabled := False;
    edCNPJ.HeightPercent := 100.000000000000000000;
    edCNPJ.TabOrder := 9;
    edCNPJ.Text := 'edCNPJ';
    edCNPJ.WidthPercent := 100.000000000000000000;
    edCNPJ.DataField := 'CNPJ';
    edCNPJ.DataSource := DataSource;
    edCodigo_Interno.SetParentComponent(Self);
    edCodigo_Interno.Name := 'edCodigo_Interno';
    edCodigo_Interno.Left := 85;
    edCodigo_Interno.Top := 208;
    edCodigo_Interno.Width := 100;
    edCodigo_Interno.Height := 21;
    edCodigo_Interno.Enabled := False;
    edCodigo_Interno.HeightPercent := 100.000000000000000000;
    edCodigo_Interno.TabOrder := 10;
    edCodigo_Interno.Text := 'edCodigo_Interno';
    edCodigo_Interno.WidthPercent := 100.000000000000000000;
    edCodigo_Interno.DataField := 'Codigo_Interno';
    edCodigo_Interno.DataSource := DataSource;
    edStatus.SetParentComponent(Self);
    edStatus.Name := 'edStatus';
    edStatus.Left := 85;
    edStatus.Top := 49;
    edStatus.Width := 100;
    edStatus.Height := 21;
    edStatus.Enabled := False;
    edStatus.HeightPercent := 100.000000000000000000;
    edStatus.TabOrder := 11;
    edStatus.Text := 'edStatus';
    edStatus.WidthPercent := 100.000000000000000000;
    edStatus.DataField := 'Status';
    edStatus.DataSource := DataSource;
    edsegmento_nome.SetParentComponent(Self);
    edsegmento_nome.Name := 'edsegmento_nome';
    edsegmento_nome.Left := 85;
    edsegmento_nome.Top := 154;
    edsegmento_nome.Width := 100;
    edsegmento_nome.Height := 20;
    edsegmento_nome.Enabled := False;
    edsegmento_nome.HeightPercent := 100.000000000000000000;
    edsegmento_nome.TabOrder := 12;
    edsegmento_nome.Text := 'edsegmento_nome';
    edsegmento_nome.WidthPercent := 100.000000000000000000;
    edsegmento_nome.DataField := 'segmento.Nome';
    edsegmento_nome.DataSource := DataSource;
    edTelefone_Principal.SetParentComponent(Self);
    edTelefone_Principal.Name := 'edTelefone_Principal';
    edTelefone_Principal.Left := 316;
    edTelefone_Principal.Top := 21;
    edTelefone_Principal.Width := 100;
    edTelefone_Principal.Height := 21;
    edTelefone_Principal.Enabled := False;
    edTelefone_Principal.HeightPercent := 100.000000000000000000;
    edTelefone_Principal.TabOrder := 13;
    edTelefone_Principal.Text := 'edTelefone_Principal';
    edTelefone_Principal.WidthPercent := 100.000000000000000000;
    edTelefone_Principal.DataField := 'Telefone_Principal';
    edTelefone_Principal.DataSource := DataSource;
    edCEP.SetParentComponent(Self);
    edCEP.Name := 'edCEP';
    edCEP.Left := 316;
    edCEP.Top := 76;
    edCEP.Width := 100;
    edCEP.Height := 21;
    edCEP.Enabled := False;
    edCEP.HeightPercent := 100.000000000000000000;
    edCEP.TabOrder := 14;
    edCEP.Text := 'edCEP';
    edCEP.WidthPercent := 100.000000000000000000;
    edCEP.DataField := 'CEP';
    edCEP.DataSource := DataSource;
    edcidade_nome.SetParentComponent(Self);
    edcidade_nome.Name := 'edcidade_nome';
    edcidade_nome.Left := 316;
    edcidade_nome.Top := 49;
    edcidade_nome.Width := 100;
    edcidade_nome.Height := 21;
    edcidade_nome.Enabled := False;
    edcidade_nome.HeightPercent := 100.000000000000000000;
    edcidade_nome.TabOrder := 22;
    edcidade_nome.Text := 'edcidade_nome';
    edcidade_nome.WidthPercent := 100.000000000000000000;
    edcidade_nome.DataField := 'cidade.Nome';
    edcidade_nome.DataSource := DataSource;
    edparceiro_nome.SetParentComponent(Self);
    edparceiro_nome.Name := 'edparceiro_nome';
    edparceiro_nome.Left := 316;
    edparceiro_nome.Top := 128;
    edparceiro_nome.Width := 100;
    edparceiro_nome.Height := 21;
    edparceiro_nome.Enabled := False;
    edparceiro_nome.HeightPercent := 100.000000000000000000;
    edparceiro_nome.TabOrder := 24;
    edparceiro_nome.Text := 'edparceiro_nome';
    edparceiro_nome.WidthPercent := 100.000000000000000000;
    edparceiro_nome.DataField := 'parceiro.nome';
    edparceiro_nome.DataSource := DataSource;
    edInclusao.SetParentComponent(Self);
    edInclusao.Name := 'edInclusao';
    edInclusao.Left := 314;
    edInclusao.Top := 208;
    edInclusao.Width := 100;
    edInclusao.Height := 21;
    edInclusao.Enabled := False;
    edInclusao.HeightPercent := 100.000000000000000000;
    edInclusao.TabOrder := 26;
    edInclusao.Text := 'edInclusao';
    edInclusao.WidthPercent := 100.000000000000000000;
    edInclusao.DataField := 'Inclusao';
    edInclusao.DataSource := DataSource;
    edAlteracao.SetParentComponent(Self);
    edAlteracao.Name := 'edAlteracao';
    edAlteracao.Left := 316;
    edAlteracao.Top := 236;
    edAlteracao.Width := 100;
    edAlteracao.Height := 21;
    edAlteracao.Enabled := False;
    edAlteracao.HeightPercent := 100.000000000000000000;
    edAlteracao.TabOrder := 27;
    edAlteracao.Text := 'edAlteracao';
    edAlteracao.WidthPercent := 100.000000000000000000;
    edAlteracao.DataField := 'Alteracao';
    edAlteracao.DataSource := DataSource;
    edExclusao.SetParentComponent(Self);
    edExclusao.Name := 'edExclusao';
    edExclusao.Left := 86;
    edExclusao.Top := 264;
    edExclusao.Width := 100;
    edExclusao.Height := 21;
    edExclusao.Enabled := False;
    edExclusao.HeightPercent := 100.000000000000000000;
    edExclusao.TabOrder := 28;
    edExclusao.Text := 'edExclusao';
    edExclusao.WidthPercent := 100.000000000000000000;
    edExclusao.DataField := 'Exclusao';
    edExclusao.DataSource := DataSource;
    edCadastro.SetParentComponent(Self);
    edCadastro.Name := 'edCadastro';
    edCadastro.Left := 316;
    edCadastro.Top := 154;
    edCadastro.Width := 100;
    edCadastro.Height := 21;
    edCadastro.Enabled := False;
    edCadastro.HeightPercent := 100.000000000000000000;
    edCadastro.TabOrder := 29;
    edCadastro.Text := 'edCadastro';
    edCadastro.WidthPercent := 100.000000000000000000;
    edCadastro.DataField := 'Cadastro';
    edCadastro.DataSource := DataSource;
    edObservacoes.SetParentComponent(Self);
    edObservacoes.Name := 'edObservacoes';
    edObservacoes.Left := 85;
    edObservacoes.Top := 76;
    edObservacoes.Width := 100;
    edObservacoes.Height := 21;
    edObservacoes.ChildOrder := 53;
    edObservacoes.Enabled := False;
    edObservacoes.HeightPercent := 100.000000000000000000;
    edObservacoes.TabOrder := 6;
    edObservacoes.Text := 'edObservacoes';
    edObservacoes.WidthPercent := 100.000000000000000000;
    edObservacoes.DataField := 'observacoes';
    edObservacoes.DataSource := DataSource;
    edEnderecoCompleto.SetParentComponent(Self);
    edEnderecoCompleto.Name := 'edEnderecoCompleto';
    edEnderecoCompleto.Left := 85;
    edEnderecoCompleto.Top := 236;
    edEnderecoCompleto.Width := 100;
    edEnderecoCompleto.Height := 22;
    edEnderecoCompleto.ChildOrder := 52;
    edEnderecoCompleto.Enabled := False;
    edEnderecoCompleto.HeightPercent := 100.000000000000000000;
    edEnderecoCompleto.Text := 'edEnderecoCompleto';
    edEnderecoCompleto.WidthPercent := 100.000000000000000000;
    cbxexcluido.SetParentComponent(Self);
    cbxexcluido.Name := 'cbxexcluido';
    cbxexcluido.Left := 316;
    cbxexcluido.Top := 264;
    cbxexcluido.Width := 100;
    cbxexcluido.Height := 22;
    cbxexcluido.Caption := 'cbxexcluido';
    cbxexcluido.ChildOrder := 33;
    cbxexcluido.Enabled := False;
    cbxexcluido.HeightPercent := 100.000000000000000000;
    cbxexcluido.WidthPercent := 100.000000000000000000;
    cbxexcluido.DataField := 'Excluido';
    cbxexcluido.DataSource := DataSource;
    pnlDadosAliado.SetParentComponent(Self);
    pnlDadosAliado.Name := 'pnlDadosAliado';
    pnlDadosAliado.Left := 8;
    pnlDadosAliado.Top := 0;
    pnlDadosAliado.Width := 419;
    pnlDadosAliado.Height := 17;
    pnlDadosAliado.Caption := 'Espa'#231'o form dados';
    pnlDadosAliado.ChildOrder := 23;
    pnlDadosAliado.Color := clInfoText;
    pnlDadosAliado.Font.Charset := DEFAULT_CHARSET;
    pnlDadosAliado.Font.Color := clWhite;
    pnlDadosAliado.Font.Height := -11;
    pnlDadosAliado.Font.Name := 'Tahoma';
    pnlDadosAliado.Font.Style := [fsBold];
    pnlDadosAliado.ParentFont := False;
    pnlDadosAliado.TabOrder := 19;
    pnlDadosAliado.Visible := False;
    pnlSincRetServ.SetParentComponent(Self);
    pnlSincRetServ.Name := 'pnlSincRetServ';
    pnlSincRetServ.Left := 662;
    pnlSincRetServ.Top := 345;
    pnlSincRetServ.Width := 193;
    pnlSincRetServ.Height := 17;
    pnlSincRetServ.Caption := 'Espa'#231'o Sinc. Ret. Serv';
    pnlSincRetServ.ChildOrder := 23;
    pnlSincRetServ.Color := clInfoText;
    pnlSincRetServ.Font.Charset := DEFAULT_CHARSET;
    pnlSincRetServ.Font.Color := clWhite;
    pnlSincRetServ.Font.Height := -11;
    pnlSincRetServ.Font.Name := 'Tahoma';
    pnlSincRetServ.Font.Style := [fsBold];
    pnlSincRetServ.ParentFont := False;
    pnlSincRetServ.TabOrder := 20;
    pnlSincRetServ.Visible := False;
    tblLogs.SetParentComponent(Self);
    tblLogs.Name := 'tblLogs';
    tblLogs.Left := 662;
    tblLogs.Top := 395;
    tblLogs.Width := 193;
    tblLogs.Height := 163;
    tblLogs.ElementClassName := 'table-responsive';
    tblLogs.BorderColor := clSilver;
    tblLogs.ChildOrder := 47;
    tblLogs.ColHeader := False;
    tblLogs.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblLogs, Self, 'OnGetCellData', 'tblLogsGetCellData');
    SetEvent(tblLogs, Self, 'OnGetCellChildren', 'tblLogsGetCellChildren');
    SetEvent(tblLogs, Self, 'OnGetCellClass', 'tblLogsGetCellClass');
    tblLogs.Columns.Clear;
    with tblLogs.Columns.Add do
    begin
      Title := 'A'#231#227'o';
    end;
    with tblLogs.Columns.Add do
    begin
      DataField := 'data_base_id';
      Title := 'C'#243'd. Banco';
    end;
    with tblLogs.Columns.Add do
    begin
      DataField := 'sincronizacao_service.rota';
      Title := 'Rota';
    end;
    with tblLogs.Columns.Add do
    begin
      DataField := 'versao_client';
      Title := 'Vers'#227'o Utilit'#225'rios';
    end;
    with tblLogs.Columns.Add do
    begin
      DataField := 'ultima_verificacao_retaguarda';
      Title := 'Verifica'#231#227'o Retaguarda';
    end;
    with tblLogs.Columns.Add do
    begin
      DataField := 'ultima_sincronizacao';
      Title := #218'lt. Sincroniza'#231#227'o';
    end;
    with tblLogs.Columns.Add do
    begin
      DataField := 'inicio_sincronizacao';
      Title := 'In'#237'cio Sinc.';
    end;
    with tblLogs.Columns.Add do
    begin
      DataField := 'fim_sincronizacao';
      Title := 'Fim Sinc.';
    end;
    with tblLogs.Columns.Add do
    begin
      Title := 'Tempo Sinc.';
    end;
    with tblLogs.Columns.Add do
    begin
      DataField := 'sincronizacao_erro';
      Title := 'Erro';
    end;
    with tblLogs.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with tblLogs.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    tblLogs.DataSource := dtsLogs;
    cbPageSizeLogs.SetParentComponent(Self);
    cbPageSizeLogs.Name := 'cbPageSizeLogs';
    cbPageSizeLogs.Left := 662;
    cbPageSizeLogs.Top := 368;
    cbPageSizeLogs.Width := 81;
    cbPageSizeLogs.Height := 21;
    cbPageSizeLogs.HeightPercent := 100.000000000000000000;
    cbPageSizeLogs.TabOrder := 2;
    cbPageSizeLogs.Text := '10';
    cbPageSizeLogs.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSizeLogs, Self, 'OnChange', 'cbPageSizeLogsChange');
    cbPageSizeLogs.ItemIndex := 0;
    cbPageSizeLogs.Items.BeginUpdate;
    try
      cbPageSizeLogs.Items.Clear;
      cbPageSizeLogs.Items.Add('10');
      cbPageSizeLogs.Items.Add('25');
      cbPageSizeLogs.Items.Add('50');
      cbPageSizeLogs.Items.Add('100');
    finally
      cbPageSizeLogs.Items.EndUpdate;
    end;
    edSearchLogs.SetParentComponent(Self);
    edSearchLogs.Name := 'edSearchLogs';
    edSearchLogs.Left := 805;
    edSearchLogs.Top := 368;
    edSearchLogs.Width := 50;
    edSearchLogs.Height := 21;
    edSearchLogs.ChildOrder := 49;
    edSearchLogs.HeightPercent := 100.000000000000000000;
    edSearchLogs.TabOrder := 3;
    edSearchLogs.WidthPercent := 100.000000000000000000;
    SetEvent(edSearchLogs, Self, 'OnKeyDown', 'edSearchLogsKeyDown');
    SetEvent(edSearchLogs, Self, 'OnKeyUp', 'edSearchLogsKeyUp');
    lcPaginatorLogs.SetParentComponent(Self);
    lcPaginatorLogs.Name := 'lcPaginatorLogs';
    lcPaginatorLogs.Left := 764;
    lcPaginatorLogs.Top := 564;
    lcPaginatorLogs.Width := 91;
    lcPaginatorLogs.Height := 13;
    lcPaginatorLogs.HeightPercent := 100.000000000000000000;
    lcPaginatorLogs.WidthPercent := 100.000000000000000000;
    lcPaginatorLogs.ChildOrder := 51;
    lcPaginatorLogs.DefaultItemClassName := 'page-item';
    lcPaginatorLogs.DefaultItemLinkClassName := 'page-link';
    lcPaginatorLogs.ElementListClassName := 'pagination';
    lcPaginatorLogs.Items.Clear;
    with lcPaginatorLogs.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with lcPaginatorLogs.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with lcPaginatorLogs.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    lcPaginatorLogs.Style := lsPagination;
    btnLogsTab.SetParentComponent(Self);
    btnLogsTab.Name := 'btnLogsTab';
    btnLogsTab.Left := 768;
    btnLogsTab.Top := 583;
    btnLogsTab.Width := 96;
    btnLogsTab.Height := 25;
    btnLogsTab.Caption := 'Logs';
    btnLogsTab.ChildOrder := 16;
    btnLogsTab.HeightPercent := 100.000000000000000000;
    btnLogsTab.TabStop := False;
    btnLogsTab.WidthPercent := 100.000000000000000000;
    SetEvent(btnLogsTab, Self, 'OnClick', 'btnLogsTabClick');
    div_checkbox_rotas.SetParentComponent(Self);
    div_checkbox_rotas.Name := 'div_checkbox_rotas';
    div_checkbox_rotas.Left := 8;
    div_checkbox_rotas.Top := 694;
    div_checkbox_rotas.Width := 100;
    div_checkbox_rotas.Height := 41;
    div_checkbox_rotas.ChildOrder := 7;
    div_checkbox_rotas.Role := '';
    div_checkbox_rotas.Visible := False;
    btnDadosTab.SetParentComponent(Self);
    btnDadosTab.Name := 'btnDadosTab';
    btnDadosTab.Left := 602;
    btnDadosTab.Top := 314;
    btnDadosTab.Width := 96;
    btnDadosTab.Height := 25;
    btnDadosTab.Caption := 'Dados';
    btnDadosTab.ChildOrder := 16;
    btnDadosTab.HeightPercent := 100.000000000000000000;
    btnDadosTab.WidthPercent := 100.000000000000000000;
    btnSincronizacaoTab.SetParentComponent(Self);
    btnSincronizacaoTab.Name := 'btnSincronizacaoTab';
    btnSincronizacaoTab.Left := 114;
    btnSincronizacaoTab.Top := 725;
    btnSincronizacaoTab.Width := 96;
    btnSincronizacaoTab.Height := 25;
    btnSincronizacaoTab.Caption := 'Sincroniza'#231#227'o';
    btnSincronizacaoTab.ChildOrder := 16;
    btnSincronizacaoTab.HeightPercent := 100.000000000000000000;
    btnSincronizacaoTab.TabStop := False;
    btnSincronizacaoTab.WidthPercent := 100.000000000000000000;
    SetEvent(btnSincronizacaoTab, Self, 'OnClick', 'btnSincronizacaoTabClick');
    btnSalvarSincronizacao.SetParentComponent(Self);
    btnSalvarSincronizacao.Name := 'btnSalvarSincronizacao';
    btnSalvarSincronizacao.Left := 114;
    btnSalvarSincronizacao.Top := 694;
    btnSalvarSincronizacao.Width := 96;
    btnSalvarSincronizacao.Height := 25;
    btnSalvarSincronizacao.Caption := 'Salvar';
    btnSalvarSincronizacao.ChildOrder := 16;
    btnSalvarSincronizacao.HeightPercent := 100.000000000000000000;
    btnSalvarSincronizacao.Visible := False;
    btnSalvarSincronizacao.WidthPercent := 100.000000000000000000;
    SetEvent(btnSalvarSincronizacao, Self, 'OnClick', 'btnSalvarSincronizacaoClick');
    edtSincronizacaoErro.SetParentComponent(Self);
    edtSincronizacaoErro.Name := 'edtSincronizacaoErro';
    edtSincronizacaoErro.Left := 662;
    edtSincronizacaoErro.Top := 584;
    edtSincronizacaoErro.Width := 100;
    edtSincronizacaoErro.Height := 22;
    edtSincronizacaoErro.ChildOrder := 31;
    edtSincronizacaoErro.Enabled := False;
    edtSincronizacaoErro.HeightPercent := 100.000000000000000000;
    edtSincronizacaoErro.Text := 'edtSincronizacaoErro';
    edtSincronizacaoErro.WidthPercent := 100.000000000000000000;
    pnlOutros.SetParentComponent(Self);
    pnlOutros.Name := 'pnlOutros';
    pnlOutros.Left := 8;
    pnlOutros.Top := 671;
    pnlOutros.Width := 243;
    pnlOutros.Height := 17;
    pnlOutros.Caption := 'Espa'#231'o Outros';
    pnlOutros.ChildOrder := 23;
    pnlOutros.Color := clInfoText;
    pnlOutros.Font.Charset := DEFAULT_CHARSET;
    pnlOutros.Font.Color := clWhite;
    pnlOutros.Font.Height := -11;
    pnlOutros.Font.Name := 'Tahoma';
    pnlOutros.Font.Style := [fsBold];
    pnlOutros.ParentFont := False;
    pnlOutros.TabOrder := 31;
    pnlOutros.Visible := False;
    pnlCertificado.SetParentComponent(Self);
    pnlCertificado.Name := 'pnlCertificado';
    pnlCertificado.Left := 717;
    pnlCertificado.Top := 0;
    pnlCertificado.Width := 362;
    pnlCertificado.Height := 17;
    pnlCertificado.Caption := 'Espa'#231'o Form Cerificado';
    pnlCertificado.ChildOrder := 23;
    pnlCertificado.Color := clInfoText;
    pnlCertificado.Font.Charset := DEFAULT_CHARSET;
    pnlCertificado.Font.Color := clWhite;
    pnlCertificado.Font.Height := -11;
    pnlCertificado.Font.Name := 'Tahoma';
    pnlCertificado.Font.Style := [fsBold];
    pnlCertificado.ParentFont := False;
    pnlCertificado.TabOrder := 32;
    pnlCertificado.Visible := False;
    btnCertificado.SetParentComponent(Self);
    btnCertificado.Name := 'btnCertificado';
    btnCertificado.Left := 717;
    btnCertificado.Top := 144;
    btnCertificado.Width := 96;
    btnCertificado.Height := 25;
    btnCertificado.Caption := 'Certificado';
    btnCertificado.ChildOrder := 16;
    btnCertificado.HeightPercent := 100.000000000000000000;
    btnCertificado.TabStop := False;
    btnCertificado.WidthPercent := 100.000000000000000000;
    SetEvent(btnCertificado, Self, 'OnClick', 'btnCertificadoClick');
    edcertificado_id.SetParentComponent(Self);
    edcertificado_id.Name := 'edcertificado_id';
    edcertificado_id.Left := 808;
    edcertificado_id.Top := 21;
    edcertificado_id.Width := 87;
    edcertificado_id.Height := 21;
    edcertificado_id.ChildOrder := 63;
    edcertificado_id.Enabled := False;
    edcertificado_id.HeightPercent := 100.000000000000000000;
    edcertificado_id.TabOrder := 6;
    edcertificado_id.Text := 'edid';
    edcertificado_id.WidthPercent := 100.000000000000000000;
    edcertificado_id.DataField := 'id';
    edcertificado_id.DataSource := dtsCertificado;
    ednumero_serie.SetParentComponent(Self);
    ednumero_serie.Name := 'ednumero_serie';
    ednumero_serie.Left := 808;
    ednumero_serie.Top := 49;
    ednumero_serie.Width := 87;
    ednumero_serie.Height := 21;
    ednumero_serie.ChildOrder := 67;
    ednumero_serie.Enabled := False;
    ednumero_serie.HeightPercent := 100.000000000000000000;
    ednumero_serie.TabOrder := 8;
    ednumero_serie.Text := 'ednumero_serie';
    ednumero_serie.WidthPercent := 100.000000000000000000;
    ednumero_serie.DataField := 'numero_serie';
    ednumero_serie.DataSource := dtsCertificado;
    eddata_vencimento.SetParentComponent(Self);
    eddata_vencimento.Name := 'eddata_vencimento';
    eddata_vencimento.Left := 808;
    eddata_vencimento.Top := 76;
    eddata_vencimento.Width := 87;
    eddata_vencimento.Height := 21;
    eddata_vencimento.ChildOrder := 69;
    eddata_vencimento.Enabled := False;
    eddata_vencimento.HeightPercent := 100.000000000000000000;
    eddata_vencimento.TabOrder := 9;
    eddata_vencimento.Text := 'eddata_vencimento';
    eddata_vencimento.WidthPercent := 100.000000000000000000;
    eddata_vencimento.DataField := 'data_vencimento';
    eddata_vencimento.DataSource := dtsCertificado;
    edsenha.SetParentComponent(Self);
    edsenha.Name := 'edsenha';
    edsenha.Left := 808;
    edsenha.Top := 103;
    edsenha.Width := 87;
    edsenha.Height := 21;
    edsenha.ChildOrder := 71;
    edsenha.Enabled := False;
    edsenha.HeightPercent := 100.000000000000000000;
    edsenha.TabOrder := 10;
    edsenha.Text := 'edsenha';
    edsenha.WidthPercent := 100.000000000000000000;
    edsenha.DataField := 'senha';
    edsenha.DataSource := dtsCertificado;
    edcertificado_s3.SetParentComponent(Self);
    edcertificado_s3.Name := 'edcertificado_s3';
    edcertificado_s3.Left := 992;
    edcertificado_s3.Top := 21;
    edcertificado_s3.Width := 87;
    edcertificado_s3.Height := 21;
    edcertificado_s3.ChildOrder := 73;
    edcertificado_s3.Enabled := False;
    edcertificado_s3.HeightPercent := 100.000000000000000000;
    edcertificado_s3.TabOrder := 11;
    edcertificado_s3.Text := 'edcertificado_s3';
    edcertificado_s3.WidthPercent := 100.000000000000000000;
    edcertificado_s3.DataField := 'certificado_s3';
    edcertificado_s3.DataSource := dtsCertificado;
    edcertificado_inclusao.SetParentComponent(Self);
    edcertificado_inclusao.Name := 'edcertificado_inclusao';
    edcertificado_inclusao.Left := 992;
    edcertificado_inclusao.Top := 48;
    edcertificado_inclusao.Width := 87;
    edcertificado_inclusao.Height := 21;
    edcertificado_inclusao.ChildOrder := 75;
    edcertificado_inclusao.Enabled := False;
    edcertificado_inclusao.HeightPercent := 100.000000000000000000;
    edcertificado_inclusao.TabOrder := 12;
    edcertificado_inclusao.Text := 'edinclusao';
    edcertificado_inclusao.WidthPercent := 100.000000000000000000;
    edcertificado_inclusao.DataField := 'inclusao';
    edcertificado_inclusao.DataSource := dtsCertificado;
    edcertificado_alteracao.SetParentComponent(Self);
    edcertificado_alteracao.Name := 'edcertificado_alteracao';
    edcertificado_alteracao.Left := 992;
    edcertificado_alteracao.Top := 75;
    edcertificado_alteracao.Width := 87;
    edcertificado_alteracao.Height := 21;
    edcertificado_alteracao.ChildOrder := 77;
    edcertificado_alteracao.Enabled := False;
    edcertificado_alteracao.HeightPercent := 100.000000000000000000;
    edcertificado_alteracao.TabOrder := 13;
    edcertificado_alteracao.Text := 'edalteracao';
    edcertificado_alteracao.WidthPercent := 100.000000000000000000;
    edcertificado_alteracao.DataField := 'alteracao';
    edcertificado_alteracao.DataSource := dtsCertificado;
    pnlTabelaDataBase.SetParentComponent(Self);
    pnlTabelaDataBase.Name := 'pnlTabelaDataBase';
    pnlTabelaDataBase.Left := 9;
    pnlTabelaDataBase.Top := 344;
    pnlTabelaDataBase.Width := 242;
    pnlTabelaDataBase.Height := 17;
    pnlTabelaDataBase.Caption := 'Espa'#231'o Data Base';
    pnlTabelaDataBase.ChildOrder := 23;
    pnlTabelaDataBase.Color := clInfoText;
    pnlTabelaDataBase.Font.Charset := DEFAULT_CHARSET;
    pnlTabelaDataBase.Font.Color := clWhite;
    pnlTabelaDataBase.Font.Height := -11;
    pnlTabelaDataBase.Font.Name := 'Tahoma';
    pnlTabelaDataBase.Font.Style := [fsBold];
    pnlTabelaDataBase.ParentFont := False;
    pnlTabelaDataBase.TabOrder := 41;
    pnlTabelaDataBase.Visible := False;
    cbPageSizeDataBase.SetParentComponent(Self);
    cbPageSizeDataBase.Name := 'cbPageSizeDataBase';
    cbPageSizeDataBase.Left := 9;
    cbPageSizeDataBase.Top := 365;
    cbPageSizeDataBase.Width := 81;
    cbPageSizeDataBase.Height := 21;
    cbPageSizeDataBase.HeightPercent := 100.000000000000000000;
    cbPageSizeDataBase.TabOrder := 2;
    cbPageSizeDataBase.Text := '10';
    cbPageSizeDataBase.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSizeDataBase, Self, 'OnChange', 'cbPageSizeDataBaseChange');
    cbPageSizeDataBase.ItemIndex := 0;
    cbPageSizeDataBase.Items.BeginUpdate;
    try
      cbPageSizeDataBase.Items.Clear;
      cbPageSizeDataBase.Items.Add('10');
      cbPageSizeDataBase.Items.Add('25');
      cbPageSizeDataBase.Items.Add('50');
      cbPageSizeDataBase.Items.Add('100');
    finally
      cbPageSizeDataBase.Items.EndUpdate;
    end;
    edSearchDataBase.SetParentComponent(Self);
    edSearchDataBase.Name := 'edSearchDataBase';
    edSearchDataBase.Left := 163;
    edSearchDataBase.Top := 365;
    edSearchDataBase.Width := 88;
    edSearchDataBase.Height := 21;
    edSearchDataBase.ChildOrder := 78;
    edSearchDataBase.HeightPercent := 100.000000000000000000;
    edSearchDataBase.TabOrder := 3;
    edSearchDataBase.WidthPercent := 100.000000000000000000;
    SetEvent(edSearchDataBase, Self, 'OnKeyDown', 'edSearchDataBaseKeyDown');
    SetEvent(edSearchDataBase, Self, 'OnKeyUp', 'edSearchDataBaseKeyUp');
    lcPaginatorDataBase.SetParentComponent(Self);
    lcPaginatorDataBase.Name := 'lcPaginatorDataBase';
    lcPaginatorDataBase.Left := 155;
    lcPaginatorDataBase.Top := 540;
    lcPaginatorDataBase.Width := 96;
    lcPaginatorDataBase.Height := 13;
    lcPaginatorDataBase.HeightPercent := 100.000000000000000000;
    lcPaginatorDataBase.WidthPercent := 100.000000000000000000;
    lcPaginatorDataBase.ChildOrder := 81;
    lcPaginatorDataBase.DefaultItemClassName := 'page-item';
    lcPaginatorDataBase.DefaultItemLinkClassName := 'page-link';
    lcPaginatorDataBase.ElementListClassName := 'pagination';
    lcPaginatorDataBase.Items.Clear;
    with lcPaginatorDataBase.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with lcPaginatorDataBase.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with lcPaginatorDataBase.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    lcPaginatorDataBase.Style := lsPagination;
    btnDataBaseTab.SetParentComponent(Self);
    btnDataBaseTab.Name := 'btnDataBaseTab';
    btnDataBaseTab.Left := 155;
    btnDataBaseTab.Top := 559;
    btnDataBaseTab.Width := 96;
    btnDataBaseTab.Height := 25;
    btnDataBaseTab.Caption := 'Data Base';
    btnDataBaseTab.ChildOrder := 16;
    btnDataBaseTab.HeightPercent := 100.000000000000000000;
    btnDataBaseTab.TabStop := False;
    btnDataBaseTab.WidthPercent := 100.000000000000000000;
    SetEvent(btnDataBaseTab, Self, 'OnClick', 'btnDataBaseTabClick');
    tblDataBase.SetParentComponent(Self);
    tblDataBase.Name := 'tblDataBase';
    tblDataBase.Left := 9;
    tblDataBase.Top := 392;
    tblDataBase.Width := 242;
    tblDataBase.Height := 142;
    tblDataBase.ElementClassName := 'table-responsive';
    tblDataBase.BorderColor := clSilver;
    tblDataBase.ChildOrder := 82;
    tblDataBase.ColHeader := False;
    tblDataBase.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblDataBase, Self, 'OnGetCellData', 'tblDataBaseGetCellData');
    SetEvent(tblDataBase, Self, 'OnGetCellChildren', 'tblDataBaseGetCellChildren');
    SetEvent(tblDataBase, Self, 'OnGetCellClass', 'tblDataBaseGetCellClass');
    tblDataBase.Columns.Clear;
    with tblDataBase.Columns.Add do
    begin
      Title := 'A'#231#245'es';
    end;
    with tblDataBase.Columns.Add do
    begin
      DataField := 'id';
      Title := 'C'#243'd.';
    end;
    with tblDataBase.Columns.Add do
    begin
      DataField := 'nome_fantasia';
      Title := 'Nome';
    end;
    with tblDataBase.Columns.Add do
    begin
      DataField := 'fiscal';
      Title := 'fiscal';
    end;
    with tblDataBase.Columns.Add do
    begin
      DataField := 'divulgar_promocoes';
      Title := 'Ofertas';
    end;
    with tblDataBase.Columns.Add do
    begin
      DataField := 'associar_produtos';
      Title := 'Associar Prod.';
    end;
    with tblDataBase.Columns.Add do
    begin
      DataField := 'versao_atual';
      Title := 'Vers'#227'o';
    end;
    with tblDataBase.Columns.Add do
    begin
      DataField := 'token';
      Title := 'token';
    end;
    with tblDataBase.Columns.Add do
    begin
      DataField := 'host';
      Title := 'host';
    end;
    with tblDataBase.Columns.Add do
    begin
      DataField := 'path';
      Title := 'Caminho Banco';
    end;
    with tblDataBase.Columns.Add do
    begin
      DataField := 'data_base_multiempresa';
      Title := 'Multiempresa';
    end;
    with tblDataBase.Columns.Add do
    begin
      DataField := 'data_base_empresa_destino';
      Title := 'Empresa Destino';
    end;
    with tblDataBase.Columns.Add do
    begin
      DataField := 'versao_pendente';
      Title := 'Vers'#227'o Pendente';
    end;
    with tblDataBase.Columns.Add do
    begin
      DataField := 'regime_contabil';
      Title := 'regime cont'#225'bil';
    end;
    with tblDataBase.Columns.Add do
    begin
      DataField := 'crt';
      Title := 'crt';
    end;
    with tblDataBase.Columns.Add do
    begin
      DataField := 'contador.nome';
      Title := 'Contador';
    end;
    with tblDataBase.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'Exclu'#237'do';
    end;
    with tblDataBase.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with tblDataBase.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    with tblDataBase.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'Exclus'#227'o';
    end;
    tblDataBase.DataSource := dtsDataBase;
    edtSincronizacaoObservacao.SetParentComponent(Self);
    edtSincronizacaoObservacao.Name := 'edtSincronizacaoObservacao';
    edtSincronizacaoObservacao.Left := 662;
    edtSincronizacaoObservacao.Top := 612;
    edtSincronizacaoObservacao.Width := 100;
    edtSincronizacaoObservacao.Height := 22;
    edtSincronizacaoObservacao.ChildOrder := 31;
    edtSincronizacaoObservacao.Enabled := False;
    edtSincronizacaoObservacao.HeightPercent := 100.000000000000000000;
    edtSincronizacaoObservacao.Text := 'edtSincronizacaoObservacao';
    edtSincronizacaoObservacao.WidthPercent := 100.000000000000000000;
    div_checkbox_modulos.SetParentComponent(Self);
    div_checkbox_modulos.Name := 'div_checkbox_modulos';
    div_checkbox_modulos.Left := 8;
    div_checkbox_modulos.Top := 559;
    div_checkbox_modulos.Width := 127;
    div_checkbox_modulos.Height := 19;
    div_checkbox_modulos.ChildOrder := 7;
    div_checkbox_modulos.Role := '';
    btnImportarCertificado.SetParentComponent(Self);
    btnImportarCertificado.Name := 'btnImportarCertificado';
    btnImportarCertificado.Left := 819;
    btnImportarCertificado.Top := 144;
    btnImportarCertificado.Width := 96;
    btnImportarCertificado.Height := 25;
    btnImportarCertificado.Caption := 'Importar Certificado';
    btnImportarCertificado.ChildOrder := 24;
    btnImportarCertificado.HeightPercent := 100.000000000000000000;
    btnImportarCertificado.WidthPercent := 100.000000000000000000;
    SetEvent(btnImportarCertificado, Self, 'OnClick', 'btnImportarCertificadoClick');
    wfpCertificado.SetParentComponent(Self);
    wfpCertificado.Name := 'wfpCertificado';
    wfpCertificado.Left := 717;
    wfpCertificado.Top := 184;
    wfpCertificado.Width := 78;
    wfpCertificado.Height := 19;
    wfpCertificado.Accept := '.pfx';
    wfpCertificado.ChildOrder := 1;
    SetEvent(wfpCertificado, Self, 'OnChange', 'wfpCertificadoChange');
    SetEvent(wfpCertificado, Self, 'OnGetFileAsBase64', 'wfpCertificadoGetFileAsBase64');
    btnUploadCertificado.SetParentComponent(Self);
    btnUploadCertificado.Name := 'btnUploadCertificado';
    btnUploadCertificado.Left := 921;
    btnUploadCertificado.Top := 144;
    btnUploadCertificado.Width := 96;
    btnUploadCertificado.Height := 25;
    btnUploadCertificado.Caption := 'Importar';
    btnUploadCertificado.ChildOrder := 24;
    btnUploadCertificado.HeightPercent := 100.000000000000000000;
    btnUploadCertificado.WidthPercent := 100.000000000000000000;
    SetEvent(btnUploadCertificado, Self, 'OnClick', 'btnUploadCertificadoClick');
    edtCertificadoSenha.SetParentComponent(Self);
    edtCertificadoSenha.Name := 'edtCertificadoSenha';
    edtCertificadoSenha.Left := 1023;
    edtCertificadoSenha.Top := 146;
    edtCertificadoSenha.Width := 56;
    edtCertificadoSenha.Height := 22;
    edtCertificadoSenha.ChildOrder := 89;
    edtCertificadoSenha.HeightPercent := 100.000000000000000000;
    edtCertificadoSenha.WidthPercent := 100.000000000000000000;
    pnlRecursos.SetParentComponent(Self);
    pnlRecursos.Name := 'pnlRecursos';
    pnlRecursos.Left := 448;
    pnlRecursos.Top := 0;
    pnlRecursos.Width := 250;
    pnlRecursos.Height := 17;
    pnlRecursos.Caption := 'Espa'#231'o Recursos';
    pnlRecursos.ChildOrder := 23;
    pnlRecursos.Color := clInfoText;
    pnlRecursos.Font.Charset := DEFAULT_CHARSET;
    pnlRecursos.Font.Color := clWhite;
    pnlRecursos.Font.Height := -11;
    pnlRecursos.Font.Name := 'Tahoma';
    pnlRecursos.Font.Style := [fsBold];
    pnlRecursos.ParentFont := False;
    pnlRecursos.TabOrder := 53;
    pnlRecursos.Visible := False;
    btnRecursosTab.SetParentComponent(Self);
    btnRecursosTab.Name := 'btnRecursosTab';
    btnRecursosTab.Left := 452;
    btnRecursosTab.Top := 221;
    btnRecursosTab.Width := 96;
    btnRecursosTab.Height := 25;
    btnRecursosTab.Caption := 'Recursos';
    btnRecursosTab.ChildOrder := 16;
    btnRecursosTab.HeightPercent := 100.000000000000000000;
    btnRecursosTab.TabStop := False;
    btnRecursosTab.WidthPercent := 100.000000000000000000;
    SetEvent(btnRecursosTab, Self, 'OnClick', 'btnRecursosTabClick');
    div_checkbox_recursos.SetParentComponent(Self);
    div_checkbox_recursos.Name := 'div_checkbox_recursos';
    div_checkbox_recursos.Left := 448;
    div_checkbox_recursos.Top := 23;
    div_checkbox_recursos.Width := 100;
    div_checkbox_recursos.Height := 41;
    div_checkbox_recursos.ChildOrder := 7;
    div_checkbox_recursos.Role := '';
    cbxSincronizarDados.SetParentComponent(Self);
    cbxSincronizarDados.Name := 'cbxSincronizarDados';
    cbxSincronizarDados.Left := 448;
    cbxSincronizarDados.Top := 85;
    cbxSincronizarDados.Width := 121;
    cbxSincronizarDados.Height := 22;
    cbxSincronizarDados.Caption := 'Sincronizar Dados?';
    cbxSincronizarDados.ChildOrder := 9;
    cbxSincronizarDados.HeightPercent := 100.000000000000000000;
    cbxSincronizarDados.WidthPercent := 100.000000000000000000;
    btnSalvarRecursos.SetParentComponent(Self);
    btnSalvarRecursos.Name := 'btnSalvarRecursos';
    btnSalvarRecursos.Left := 452;
    btnSalvarRecursos.Top := 159;
    btnSalvarRecursos.Width := 96;
    btnSalvarRecursos.Height := 25;
    btnSalvarRecursos.Caption := 'Salvar';
    btnSalvarRecursos.ChildOrder := 8;
    btnSalvarRecursos.HeightPercent := 100.000000000000000000;
    btnSalvarRecursos.WidthPercent := 100.000000000000000000;
    SetEvent(btnSalvarRecursos, Self, 'OnClick', 'btnSalvarRecursosClick');
    edtObservacaoEdit.SetParentComponent(Self);
    edtObservacaoEdit.Name := 'edtObservacaoEdit';
    edtObservacaoEdit.Left := 575;
    edtObservacaoEdit.Top := 104;
    edtObservacaoEdit.Width := 123;
    edtObservacaoEdit.Height := 22;
    edtObservacaoEdit.ChildOrder := 89;
    edtObservacaoEdit.HeightPercent := 100.000000000000000000;
    edtObservacaoEdit.Text := 'edtObservacaoEdit';
    edtObservacaoEdit.WidthPercent := 100.000000000000000000;
    wfpLogomarca.SetParentComponent(Self);
    wfpLogomarca.Name := 'wfpLogomarca';
    wfpLogomarca.Left := 575;
    wfpLogomarca.Top := 132;
    wfpLogomarca.Width := 78;
    wfpLogomarca.Height := 19;
    wfpLogomarca.Accept := '.png';
    wfpLogomarca.ChildOrder := 1;
    SetEvent(wfpLogomarca, Self, 'OnChange', 'wfpLogomarcaChange');
    SetEvent(wfpLogomarca, Self, 'OnGetFileAsBase64', 'wfpLogomarcaGetFileAsBase64');
    divRemoverImagem.SetParentComponent(Self);
    divRemoverImagem.Name := 'divRemoverImagem';
    divRemoverImagem.Left := 575;
    divRemoverImagem.Top := 157;
    divRemoverImagem.Width := 123;
    divRemoverImagem.Height := 20;
    divRemoverImagem.ChildOrder := 92;
    divRemoverImagem.Role := '';
    SetEvent(divRemoverImagem, Self, 'OnClick', 'divRemoverImagemClick');
    edtParceiroNome.SetParentComponent(Self);
    edtParceiroNome.Name := 'edtParceiroNome';
    edtParceiroNome.Left := 575;
    edtParceiroNome.Top := 182;
    edtParceiroNome.Width := 86;
    edtParceiroNome.Height := 22;
    edtParceiroNome.ChildOrder := 21;
    edtParceiroNome.Enabled := False;
    edtParceiroNome.HeightPercent := 100.000000000000000000;
    edtParceiroNome.WidthPercent := 100.000000000000000000;
    btnPesquisarParceiro.SetParentComponent(Self);
    btnPesquisarParceiro.Name := 'btnPesquisarParceiro';
    btnPesquisarParceiro.Left := 667;
    btnPesquisarParceiro.Top := 183;
    btnPesquisarParceiro.Width := 31;
    btnPesquisarParceiro.Height := 21;
    btnPesquisarParceiro.ChildOrder := 22;
    btnPesquisarParceiro.HeightPercent := 100.000000000000000000;
    btnPesquisarParceiro.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarParceiro, Self, 'OnClick', 'btnPesquisarParceiroClick');
    edtTelefoneWhatsappEdit.SetParentComponent(Self);
    edtTelefoneWhatsappEdit.Name := 'edtTelefoneWhatsappEdit';
    edtTelefoneWhatsappEdit.Left := 575;
    edtTelefoneWhatsappEdit.Top := 76;
    edtTelefoneWhatsappEdit.Width := 123;
    edtTelefoneWhatsappEdit.Height := 22;
    edtTelefoneWhatsappEdit.ChildOrder := 95;
    edtTelefoneWhatsappEdit.HeightPercent := 100.000000000000000000;
    edtTelefoneWhatsappEdit.MaxLength := 15;
    edtTelefoneWhatsappEdit.WidthPercent := 100.000000000000000000;
    pnlFaturamento.SetParentComponent(Self);
    pnlFaturamento.Name := 'pnlFaturamento';
    pnlFaturamento.Left := 274;
    pnlFaturamento.Top := 344;
    pnlFaturamento.Width := 372;
    pnlFaturamento.Height := 17;
    pnlFaturamento.Caption := 'Espa'#231'o Faturamento';
    pnlFaturamento.ChildOrder := 23;
    pnlFaturamento.Color := clInfoText;
    pnlFaturamento.Font.Charset := DEFAULT_CHARSET;
    pnlFaturamento.Font.Color := clWhite;
    pnlFaturamento.Font.Height := -11;
    pnlFaturamento.Font.Name := 'Tahoma';
    pnlFaturamento.Font.Style := [fsBold];
    pnlFaturamento.ParentFont := False;
    pnlFaturamento.TabOrder := 64;
    pnlFaturamento.Visible := False;
    tblFaturamento.SetParentComponent(Self);
    tblFaturamento.Name := 'tblFaturamento';
    tblFaturamento.Left := 274;
    tblFaturamento.Top := 367;
    tblFaturamento.Width := 372;
    tblFaturamento.Height := 150;
    tblFaturamento.ElementClassName := 'table-responsive';
    tblFaturamento.BorderColor := clSilver;
    tblFaturamento.ChildOrder := 82;
    tblFaturamento.ColHeader := False;
    tblFaturamento.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblFaturamento, Self, 'OnGetCellClass', 'tblFaturamentoGetCellClass');
    tblFaturamento.Columns.Clear;
    with tblFaturamento.Columns.Add do
    begin
      DataField := 'id';
      Title := 'C'#243'd. Aliado';
    end;
    with tblFaturamento.Columns.Add do
    begin
      DataField := 'nome_fantasia';
      Title := 'Nome';
    end;
    with tblFaturamento.Columns.Add do
    begin
      DataField := 'cnpj';
      Title := 'Cnpj';
    end;
    with tblFaturamento.Columns.Add do
    begin
      DataField := 'banco_fiscal';
      Title := 'DB Fiscal';
    end;
    with tblFaturamento.Columns.Add do
    begin
      DataField := 'mes_ano';
      Title := 'M'#234's/Ano';
    end;
    with tblFaturamento.Columns.Add do
    begin
      DataField := 'valor_total_faturamento';
      Title := 'Valor';
    end;
    with tblFaturamento.Columns.Add do
    begin
      DataField := 'quantidade';
      Title := 'quantidade';
    end;
    with tblFaturamento.Columns.Add do
    begin
      DataField := 'ticket_medio';
      Title := 'Ticket M'#233'dio';
    end;
    with tblFaturamento.Columns.Add do
    begin
      DataField := 'tipo_movimento';
      Title := 'Tipo Mov.';
    end;
    with tblFaturamento.Columns.Add do
    begin
      DataField := 'ultima_atualizacao';
      Title := #218'lt. Atualiza'#231#227'o';
    end;
    with tblFaturamento.Columns.Add do
    begin
      DataField := 'caminho_data_base';
      Title := 'Caminho DB';
    end;
    tblFaturamento.DataSource := dtsFaturamento;
    btnFaturamentoTab.SetParentComponent(Self);
    btnFaturamentoTab.Name := 'btnFaturamentoTab';
    btnFaturamentoTab.Left := 280;
    btnFaturamentoTab.Top := 635;
    btnFaturamentoTab.Width := 110;
    btnFaturamentoTab.Height := 25;
    btnFaturamentoTab.Caption := 'Faturamento';
    btnFaturamentoTab.ChildOrder := 16;
    btnFaturamentoTab.HeightPercent := 100.000000000000000000;
    btnFaturamentoTab.TabStop := False;
    btnFaturamentoTab.WidthPercent := 100.000000000000000000;
    SetEvent(btnFaturamentoTab, Self, 'OnClick', 'btnFaturamentoTabClick');
    btnConsultarFaturamento.SetParentComponent(Self);
    btnConsultarFaturamento.Name := 'btnConsultarFaturamento';
    btnConsultarFaturamento.Left := 278;
    btnConsultarFaturamento.Top := 604;
    btnConsultarFaturamento.Width := 112;
    btnConsultarFaturamento.Height := 25;
    btnConsultarFaturamento.Caption := 'Consultar Faturamento';
    btnConsultarFaturamento.ChildOrder := 99;
    btnConsultarFaturamento.HeightPercent := 100.000000000000000000;
    btnConsultarFaturamento.WidthPercent := 100.000000000000000000;
    SetEvent(btnConsultarFaturamento, Self, 'OnClick', 'btnConsultarFaturamentoClick');
    cbbDataBase.SetParentComponent(Self);
    cbbDataBase.Name := 'cbbDataBase';
    cbbDataBase.Left := 404;
    cbbDataBase.Top := 523;
    cbbDataBase.Width := 113;
    cbbDataBase.Height := 21;
    cbbDataBase.HeightPercent := 100.000000000000000000;
    cbbDataBase.WidthPercent := 100.000000000000000000;
    cbbDataBase.ItemIndex := -1;
    cbxMovimentaEstoque.SetParentComponent(Self);
    cbxMovimentaEstoque.Name := 'cbxMovimentaEstoque';
    cbxMovimentaEstoque.Left := 404;
    cbxMovimentaEstoque.Top := 550;
    cbxMovimentaEstoque.Width := 113;
    cbxMovimentaEstoque.Height := 22;
    cbxMovimentaEstoque.Caption := 'cbxMovimentaEstoque';
    cbxMovimentaEstoque.Checked := True;
    cbxMovimentaEstoque.ChildOrder := 101;
    cbxMovimentaEstoque.HeightPercent := 100.000000000000000000;
    cbxMovimentaEstoque.State := cbChecked;
    cbxMovimentaEstoque.WidthPercent := 100.000000000000000000;
    cbxGeraFinanceiro.SetParentComponent(Self);
    cbxGeraFinanceiro.Name := 'cbxGeraFinanceiro';
    cbxGeraFinanceiro.Left := 535;
    cbxGeraFinanceiro.Top := 523;
    cbxGeraFinanceiro.Width := 113;
    cbxGeraFinanceiro.Height := 22;
    cbxGeraFinanceiro.Caption := 'cbxGeraFinanceiro';
    cbxGeraFinanceiro.Checked := True;
    cbxGeraFinanceiro.ChildOrder := 101;
    cbxGeraFinanceiro.HeightPercent := 100.000000000000000000;
    cbxGeraFinanceiro.State := cbChecked;
    cbxGeraFinanceiro.WidthPercent := 100.000000000000000000;
    cbxSimplesFaturamento.SetParentComponent(Self);
    cbxSimplesFaturamento.Name := 'cbxSimplesFaturamento';
    cbxSimplesFaturamento.Left := 535;
    cbxSimplesFaturamento.Top := 551;
    cbxSimplesFaturamento.Width := 113;
    cbxSimplesFaturamento.Height := 22;
    cbxSimplesFaturamento.Caption := 'cbxSimplesFaturamento';
    cbxSimplesFaturamento.ChildOrder := 101;
    cbxSimplesFaturamento.HeightPercent := 100.000000000000000000;
    cbxSimplesFaturamento.WidthPercent := 100.000000000000000000;
    cbxDevolucao.SetParentComponent(Self);
    cbxDevolucao.Name := 'cbxDevolucao';
    cbxDevolucao.Left := 404;
    cbxDevolucao.Top := 578;
    cbxDevolucao.Width := 113;
    cbxDevolucao.Height := 22;
    cbxDevolucao.Caption := 'cbxDevolucao';
    cbxDevolucao.ChildOrder := 101;
    cbxDevolucao.HeightPercent := 100.000000000000000000;
    cbxDevolucao.WidthPercent := 100.000000000000000000;
    cbxTransferencia.SetParentComponent(Self);
    cbxTransferencia.Name := 'cbxTransferencia';
    cbxTransferencia.Left := 535;
    cbxTransferencia.Top := 579;
    cbxTransferencia.Width := 113;
    cbxTransferencia.Height := 22;
    cbxTransferencia.Caption := 'cbxTransferencia';
    cbxTransferencia.ChildOrder := 101;
    cbxTransferencia.HeightPercent := 100.000000000000000000;
    cbxTransferencia.WidthPercent := 100.000000000000000000;
    cbxConciliacaoCupons.SetParentComponent(Self);
    cbxConciliacaoCupons.Name := 'cbxConciliacaoCupons';
    cbxConciliacaoCupons.Left := 535;
    cbxConciliacaoCupons.Top := 604;
    cbxConciliacaoCupons.Width := 113;
    cbxConciliacaoCupons.Height := 22;
    cbxConciliacaoCupons.Caption := 'cbxConciliacaoCupons';
    cbxConciliacaoCupons.ChildOrder := 101;
    cbxConciliacaoCupons.HeightPercent := 100.000000000000000000;
    cbxConciliacaoCupons.WidthPercent := 100.000000000000000000;
    cbbPeriodoFaturamento.SetParentComponent(Self);
    cbbPeriodoFaturamento.Name := 'cbbPeriodoFaturamento';
    cbbPeriodoFaturamento.Left := 404;
    cbbPeriodoFaturamento.Top := 635;
    cbbPeriodoFaturamento.Width := 120;
    cbbPeriodoFaturamento.Height := 21;
    cbbPeriodoFaturamento.HeightPercent := 100.000000000000000000;
    cbbPeriodoFaturamento.WidthPercent := 100.000000000000000000;
    SetEvent(cbbPeriodoFaturamento, Self, 'OnChange', 'cbbPeriodoFaturamentoChange');
    cbbPeriodoFaturamento.ItemIndex := 0;
    cbbPeriodoFaturamento.Items.BeginUpdate;
    try
      cbbPeriodoFaturamento.Items.Clear;
      cbbPeriodoFaturamento.Items.Add('M'#234's Atual');
      cbbPeriodoFaturamento.Items.Add(#218'ltimos 3 Meses');
      cbbPeriodoFaturamento.Items.Add(#218'ltimos 6 Meses');
      cbbPeriodoFaturamento.Items.Add(#218'ltimos 12 Meses');
      cbbPeriodoFaturamento.Items.Add('Este Ano');
      cbbPeriodoFaturamento.Items.Add('Personalizado');
    finally
      cbbPeriodoFaturamento.Items.EndUpdate;
    end;
    edtDataInicial.SetParentComponent(Self);
    edtDataInicial.Name := 'edtDataInicial';
    edtDataInicial.Left := 278;
    edtDataInicial.Top := 523;
    edtDataInicial.Width := 120;
    edtDataInicial.Height := 22;
    edtDataInicial.BorderStyle := bsSingle;
    edtDataInicial.ChildOrder := 109;
    edtDataInicial.Color := clWhite;
    edtDataInicial.Date := 45980.718362395830000000;
    edtDataInicial.Role := '';
    edtDataInicial.Text := '';
    edtDataFinal.SetParentComponent(Self);
    edtDataFinal.Name := 'edtDataFinal';
    edtDataFinal.Left := 278;
    edtDataFinal.Top := 549;
    edtDataFinal.Width := 120;
    edtDataFinal.Height := 22;
    edtDataFinal.BorderStyle := bsSingle;
    edtDataFinal.ChildOrder := 109;
    edtDataFinal.Color := clWhite;
    edtDataFinal.Date := 45980.718362395830000000;
    edtDataFinal.Role := '';
    edtDataFinal.Text := '';
    btnExportarExcel.SetParentComponent(Self);
    btnExportarExcel.Name := 'btnExportarExcel';
    btnExportarExcel.Left := 396;
    btnExportarExcel.Top := 604;
    btnExportarExcel.Width := 112;
    btnExportarExcel.Height := 25;
    btnExportarExcel.Caption := 'Exportar Excel';
    btnExportarExcel.ChildOrder := 99;
    btnExportarExcel.HeightPercent := 100.000000000000000000;
    btnExportarExcel.WidthPercent := 100.000000000000000000;
    SetEvent(btnExportarExcel, Self, 'OnClick', 'btnExportarExcelClick');
    cbbTipoFaturamento.SetParentComponent(Self);
    cbbTipoFaturamento.Name := 'cbbTipoFaturamento';
    cbbTipoFaturamento.Left := 278;
    cbbTipoFaturamento.Top := 577;
    cbbTipoFaturamento.Width := 120;
    cbbTipoFaturamento.Height := 21;
    cbbTipoFaturamento.HeightPercent := 100.000000000000000000;
    cbbTipoFaturamento.Text := 'TODOS';
    cbbTipoFaturamento.WidthPercent := 100.000000000000000000;
    SetEvent(cbbTipoFaturamento, Self, 'OnChange', 'cbbTipoFaturamentoChange');
    cbbTipoFaturamento.ItemIndex := 0;
    cbbTipoFaturamento.Items.BeginUpdate;
    try
      cbbTipoFaturamento.Items.Clear;
      cbbTipoFaturamento.Items.Add('TODOS');
      cbbTipoFaturamento.Items.Add('VENDAS');
      cbbTipoFaturamento.Items.Add('CUPONS');
      cbbTipoFaturamento.Items.Add('VENDAS SERVI'#199'OS');
    finally
      cbbTipoFaturamento.Items.EndUpdate;
    end;
    edconfig_windows.SetParentComponent(Self);
    edconfig_windows.Name := 'edconfig_windows';
    edconfig_windows.Left := 316;
    edconfig_windows.Top := 180;
    edconfig_windows.Width := 100;
    edconfig_windows.Height := 21;
    edconfig_windows.ChildOrder := 112;
    edconfig_windows.Enabled := False;
    edconfig_windows.HeightPercent := 100.000000000000000000;
    edconfig_windows.TabOrder := 22;
    edconfig_windows.Text := 'config_windows';
    edconfig_windows.WidthPercent := 100.000000000000000000;
    edconfig_windows.DataField := 'config_windows';
    edconfig_windows.DataSource := DataSource;
    btnConectarAliado.SetParentComponent(Self);
    btnConectarAliado.Name := 'btnConectarAliado';
    btnConectarAliado.Left := 452;
    btnConectarAliado.Top := 190;
    btnConectarAliado.Width := 96;
    btnConectarAliado.Height := 25;
    btnConectarAliado.Caption := 'Conectar';
    btnConectarAliado.ChildOrder := 8;
    btnConectarAliado.HeightPercent := 100.000000000000000000;
    btnConectarAliado.WidthPercent := 100.000000000000000000;
    SetEvent(btnConectarAliado, Self, 'OnClick', 'btnConectarAliadoClick');
    pnlSincServRet.SetParentComponent(Self);
    pnlSincServRet.Name := 'pnlSincServRet';
    pnlSincServRet.Left := 881;
    pnlSincServRet.Top := 345;
    pnlSincServRet.Width := 193;
    pnlSincServRet.Height := 17;
    pnlSincServRet.Caption := 'Espa'#231'o Sinc. Serv. Ret';
    pnlSincServRet.ChildOrder := 23;
    pnlSincServRet.Color := clInfoText;
    pnlSincServRet.Font.Charset := DEFAULT_CHARSET;
    pnlSincServRet.Font.Color := clWhite;
    pnlSincServRet.Font.Height := -11;
    pnlSincServRet.Font.Name := 'Tahoma';
    pnlSincServRet.Font.Style := [fsBold];
    pnlSincServRet.ParentFont := False;
    pnlSincServRet.TabOrder := 81;
    pnlSincServRet.Visible := False;
    cbbSincServRet.SetParentComponent(Self);
    cbbSincServRet.Name := 'cbbSincServRet';
    cbbSincServRet.Left := 881;
    cbbSincServRet.Top := 368;
    cbbSincServRet.Width := 81;
    cbbSincServRet.Height := 21;
    cbbSincServRet.HeightPercent := 100.000000000000000000;
    cbbSincServRet.TabOrder := 2;
    cbbSincServRet.Text := '10';
    cbbSincServRet.WidthPercent := 100.000000000000000000;
    SetEvent(cbbSincServRet, Self, 'OnChange', 'cbbSincServRetChange');
    cbbSincServRet.ItemIndex := 0;
    cbbSincServRet.Items.BeginUpdate;
    try
      cbbSincServRet.Items.Clear;
      cbbSincServRet.Items.Add('10');
      cbbSincServRet.Items.Add('25');
      cbbSincServRet.Items.Add('50');
      cbbSincServRet.Items.Add('100');
    finally
      cbbSincServRet.Items.EndUpdate;
    end;
    edtSincServRet.SetParentComponent(Self);
    edtSincServRet.Name := 'edtSincServRet';
    edtSincServRet.Left := 1024;
    edtSincServRet.Top := 368;
    edtSincServRet.Width := 50;
    edtSincServRet.Height := 21;
    edtSincServRet.ChildOrder := 49;
    edtSincServRet.HeightPercent := 100.000000000000000000;
    edtSincServRet.TabOrder := 3;
    edtSincServRet.WidthPercent := 100.000000000000000000;
    SetEvent(edtSincServRet, Self, 'OnKeyDown', 'edtSincServRetKeyDown');
    SetEvent(edtSincServRet, Self, 'OnKeyUp', 'edtSincServRetKeyUp');
    tblSincServRet.SetParentComponent(Self);
    tblSincServRet.Name := 'tblSincServRet';
    tblSincServRet.Left := 881;
    tblSincServRet.Top := 395;
    tblSincServRet.Width := 193;
    tblSincServRet.Height := 163;
    tblSincServRet.ElementClassName := 'table-responsive';
    tblSincServRet.BorderColor := clSilver;
    tblSincServRet.ChildOrder := 47;
    tblSincServRet.ColHeader := False;
    tblSincServRet.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblSincServRet, Self, 'OnGetCellChildren', 'tblSincServRetGetCellChildren');
    SetEvent(tblSincServRet, Self, 'OnGetCellClass', 'tblSincServRetGetCellClass');
    tblSincServRet.Columns.Clear;
    with tblSincServRet.Columns.Add do
    begin
      Title := 'A'#231#227'o';
    end;
    with tblSincServRet.Columns.Add do
    begin
      DataField := 'data_base_id';
      Title := 'C'#243'd. Banco';
    end;
    with tblSincServRet.Columns.Add do
    begin
      DataField := 'sinc_serv.tabela_servidor';
      Title := 'Tabela';
    end;
    with tblSincServRet.Columns.Add do
    begin
      DataField := 'versao_client';
      Title := 'Vers'#227'o Utilit'#225'rios';
    end;
    with tblSincServRet.Columns.Add do
    begin
      DataField := 'ultima_verificacao_retaguarda';
      Title := 'Verifica'#231#227'o Retaguarda';
    end;
    with tblSincServRet.Columns.Add do
    begin
      DataField := 'ultima_sincronizacao';
      Title := #218'lt. Sincroniza'#231#227'o';
    end;
    with tblSincServRet.Columns.Add do
    begin
      DataField := 'sincronizacao_erro';
      Title := 'Erro';
    end;
    with tblSincServRet.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with tblSincServRet.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    tblSincServRet.DataSource := dtsSincServRet;
    lcPaginatorSincServRet.SetParentComponent(Self);
    lcPaginatorSincServRet.Name := 'lcPaginatorSincServRet';
    lcPaginatorSincServRet.Left := 983;
    lcPaginatorSincServRet.Top := 564;
    lcPaginatorSincServRet.Width := 91;
    lcPaginatorSincServRet.Height := 13;
    lcPaginatorSincServRet.HeightPercent := 100.000000000000000000;
    lcPaginatorSincServRet.WidthPercent := 100.000000000000000000;
    lcPaginatorSincServRet.ChildOrder := 51;
    lcPaginatorSincServRet.DefaultItemClassName := 'page-item';
    lcPaginatorSincServRet.DefaultItemLinkClassName := 'page-link';
    lcPaginatorSincServRet.ElementListClassName := 'pagination';
    lcPaginatorSincServRet.Items.Clear;
    with lcPaginatorSincServRet.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with lcPaginatorSincServRet.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with lcPaginatorSincServRet.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    lcPaginatorSincServRet.Style := lsPagination;
    btnSincRetServidor.SetParentComponent(Self);
    btnSincRetServidor.Name := 'btnSincRetServidor';
    btnSincRetServidor.Left := 768;
    btnSincRetServidor.Top := 614;
    btnSincRetServidor.Width := 96;
    btnSincRetServidor.Height := 25;
    btnSincRetServidor.Caption := 'Retaguarda Servidor';
    btnSincRetServidor.ChildOrder := 16;
    btnSincRetServidor.HeightPercent := 100.000000000000000000;
    btnSincRetServidor.TabStop := False;
    btnSincRetServidor.WidthPercent := 100.000000000000000000;
    SetEvent(btnSincRetServidor, Self, 'OnClick', 'btnSincRetServidorClick');
    btnSincServRetaguarda.SetParentComponent(Self);
    btnSincServRetaguarda.Name := 'btnSincServRetaguarda';
    btnSincServRetaguarda.Left := 881;
    btnSincServRetaguarda.Top := 584;
    btnSincServRetaguarda.Width := 96;
    btnSincServRetaguarda.Height := 25;
    btnSincServRetaguarda.Caption := 'Servidor Retaguarda';
    btnSincServRetaguarda.ChildOrder := 16;
    btnSincServRetaguarda.HeightPercent := 100.000000000000000000;
    btnSincServRetaguarda.TabStop := False;
    btnSincServRetaguarda.WidthPercent := 100.000000000000000000;
    SetEvent(btnSincServRetaguarda, Self, 'OnClick', 'btnSincServRetaguardaClick');
    eddata_cancelamento.SetParentComponent(Self);
    eddata_cancelamento.Name := 'eddata_cancelamento';
    eddata_cancelamento.Left := 85;
    eddata_cancelamento.Top := 289;
    eddata_cancelamento.Width := 100;
    eddata_cancelamento.Height := 21;
    eddata_cancelamento.ChildOrder := 127;
    eddata_cancelamento.Enabled := False;
    eddata_cancelamento.HeightPercent := 100.000000000000000000;
    eddata_cancelamento.TabOrder := 29;
    eddata_cancelamento.Text := 'eddata_cancelamento';
    eddata_cancelamento.WidthPercent := 100.000000000000000000;
    eddata_cancelamento.DataField := 'data_cancelamento';
    eddata_cancelamento.DataSource := DataSource;
    edtempo_contrato.SetParentComponent(Self);
    edtempo_contrato.Name := 'edtempo_contrato';
    edtempo_contrato.Left := 86;
    edtempo_contrato.Top := 313;
    edtempo_contrato.Width := 100;
    edtempo_contrato.Height := 21;
    edtempo_contrato.ChildOrder := 127;
    edtempo_contrato.Enabled := False;
    edtempo_contrato.HeightPercent := 100.000000000000000000;
    edtempo_contrato.TabOrder := 29;
    edtempo_contrato.Text := 'edtempo_contrato';
    edtempo_contrato.WidthPercent := 100.000000000000000000;
    edtempo_contrato.DataField := 'tempo_contrato';
    edtempo_contrato.DataSource := DataSource;
    pnlConfiguracoesRet.SetParentComponent(Self);
    pnlConfiguracoesRet.Name := 'pnlConfiguracoesRet';
    pnlConfiguracoesRet.Left := 662;
    pnlConfiguracoesRet.Top := 648;
    pnlConfiguracoesRet.Width := 202;
    pnlConfiguracoesRet.Height := 17;
    pnlConfiguracoesRet.Caption := 'Espa'#231'o Configura'#231#245'es Ret';
    pnlConfiguracoesRet.ChildOrder := 23;
    pnlConfiguracoesRet.Color := clInfoText;
    pnlConfiguracoesRet.Font.Charset := DEFAULT_CHARSET;
    pnlConfiguracoesRet.Font.Color := clWhite;
    pnlConfiguracoesRet.Font.Height := -11;
    pnlConfiguracoesRet.Font.Name := 'Tahoma';
    pnlConfiguracoesRet.Font.Style := [fsBold];
    pnlConfiguracoesRet.ParentFont := False;
    pnlConfiguracoesRet.TabOrder := 90;
    pnlConfiguracoesRet.Visible := False;
    btnConfigRetaguarda.SetParentComponent(Self);
    btnConfigRetaguarda.Name := 'btnConfigRetaguarda';
    btnConfigRetaguarda.Left := 662;
    btnConfigRetaguarda.Top := 671;
    btnConfigRetaguarda.Width := 110;
    btnConfigRetaguarda.Height := 25;
    btnConfigRetaguarda.Caption := 'Config. M'#243'dulos';
    btnConfigRetaguarda.ChildOrder := 16;
    btnConfigRetaguarda.HeightPercent := 100.000000000000000000;
    btnConfigRetaguarda.TabStop := False;
    btnConfigRetaguarda.WidthPercent := 100.000000000000000000;
    SetEvent(btnConfigRetaguarda, Self, 'OnClick', 'btnConfigRetaguardaClick');
    cbbDataBaseConfigRetaguarda.SetParentComponent(Self);
    cbbDataBaseConfigRetaguarda.Name := 'cbbDataBaseConfigRetaguarda';
    cbbDataBaseConfigRetaguarda.Left := 662;
    cbbDataBaseConfigRetaguarda.Top := 702;
    cbbDataBaseConfigRetaguarda.Width := 113;
    cbbDataBaseConfigRetaguarda.Height := 21;
    cbbDataBaseConfigRetaguarda.HeightPercent := 100.000000000000000000;
    cbbDataBaseConfigRetaguarda.WidthPercent := 100.000000000000000000;
    cbbDataBaseConfigRetaguarda.ItemIndex := -1;
    btnCarregarConfiguracoes.SetParentComponent(Self);
    btnCarregarConfiguracoes.Name := 'btnCarregarConfiguracoes';
    btnCarregarConfiguracoes.Left := 662;
    btnCarregarConfiguracoes.Top := 729;
    btnCarregarConfiguracoes.Width := 110;
    btnCarregarConfiguracoes.Height := 25;
    btnCarregarConfiguracoes.Caption := 'Carregar Config.';
    btnCarregarConfiguracoes.ChildOrder := 16;
    btnCarregarConfiguracoes.HeightPercent := 100.000000000000000000;
    btnCarregarConfiguracoes.TabStop := False;
    btnCarregarConfiguracoes.WidthPercent := 100.000000000000000000;
    SetEvent(btnCarregarConfiguracoes, Self, 'OnClick', 'btnCarregarConfiguracoesClick');
    btnExportarExcelConfigRetaguarda.SetParentComponent(Self);
    btnExportarExcelConfigRetaguarda.Name := 'btnExportarExcelConfigRetaguarda';
    btnExportarExcelConfigRetaguarda.Left := 781;
    btnExportarExcelConfigRetaguarda.Top := 729;
    btnExportarExcelConfigRetaguarda.Width := 83;
    btnExportarExcelConfigRetaguarda.Height := 25;
    btnExportarExcelConfigRetaguarda.Caption := 'Exportar Excel';
    btnExportarExcelConfigRetaguarda.ChildOrder := 16;
    btnExportarExcelConfigRetaguarda.Enabled := False;
    btnExportarExcelConfigRetaguarda.HeightPercent := 100.000000000000000000;
    btnExportarExcelConfigRetaguarda.TabStop := False;
    btnExportarExcelConfigRetaguarda.WidthPercent := 100.000000000000000000;
    SetEvent(btnExportarExcelConfigRetaguarda, Self, 'OnClick', 'btnExportarExcelConfigRetaguardaClick');
    searchConfig.SetParentComponent(Self);
    searchConfig.Name := 'searchConfig';
    searchConfig.Left := 781;
    searchConfig.Top := 671;
    searchConfig.Width := 83;
    searchConfig.Height := 22;
    searchConfig.ChildOrder := 134;
    searchConfig.Enabled := False;
    searchConfig.HeightPercent := 100.000000000000000000;
    searchConfig.WidthPercent := 100.000000000000000000;
    searchConfigNfce.SetParentComponent(Self);
    searchConfigNfce.Name := 'searchConfigNfce';
    searchConfigNfce.Left := 876;
    searchConfigNfce.Top := 670;
    searchConfigNfce.Width := 92;
    searchConfigNfce.Height := 22;
    searchConfigNfce.ChildOrder := 134;
    searchConfigNfce.Enabled := False;
    searchConfigNfce.HeightPercent := 100.000000000000000000;
    searchConfigNfce.WidthPercent := 100.000000000000000000;
    pnlConfiguracoesNfce.SetParentComponent(Self);
    pnlConfiguracoesNfce.Name := 'pnlConfiguracoesNfce';
    pnlConfiguracoesNfce.Left := 873;
    pnlConfiguracoesNfce.Top := 647;
    pnlConfiguracoesNfce.Width := 202;
    pnlConfiguracoesNfce.Height := 17;
    pnlConfiguracoesNfce.Caption := 'Espa'#231'o Configura'#231#245'es NFCe';
    pnlConfiguracoesNfce.ChildOrder := 23;
    pnlConfiguracoesNfce.Color := clInfoText;
    pnlConfiguracoesNfce.Font.Charset := DEFAULT_CHARSET;
    pnlConfiguracoesNfce.Font.Color := clWhite;
    pnlConfiguracoesNfce.Font.Height := -11;
    pnlConfiguracoesNfce.Font.Name := 'Tahoma';
    pnlConfiguracoesNfce.Font.Style := [fsBold];
    pnlConfiguracoesNfce.ParentFont := False;
    pnlConfiguracoesNfce.TabOrder := 98;
    pnlConfiguracoesNfce.Visible := False;
    cbbSerieCaixaNfce.SetParentComponent(Self);
    cbbSerieCaixaNfce.Name := 'cbbSerieCaixaNfce';
    cbbSerieCaixaNfce.Left := 878;
    cbbSerieCaixaNfce.Top := 698;
    cbbSerieCaixaNfce.Width := 90;
    cbbSerieCaixaNfce.Height := 21;
    cbbSerieCaixaNfce.HeightPercent := 100.000000000000000000;
    cbbSerieCaixaNfce.WidthPercent := 100.000000000000000000;
    cbbSerieCaixaNfce.ItemIndex := -1;
    btnCarregarConfiguracoesNfce.SetParentComponent(Self);
    btnCarregarConfiguracoesNfce.Name := 'btnCarregarConfiguracoesNfce';
    btnCarregarConfiguracoesNfce.Left := 878;
    btnCarregarConfiguracoesNfce.Top := 725;
    btnCarregarConfiguracoesNfce.Width := 110;
    btnCarregarConfiguracoesNfce.Height := 25;
    btnCarregarConfiguracoesNfce.Caption := 'Carregar Config.';
    btnCarregarConfiguracoesNfce.ChildOrder := 16;
    btnCarregarConfiguracoesNfce.HeightPercent := 100.000000000000000000;
    btnCarregarConfiguracoesNfce.TabStop := False;
    btnCarregarConfiguracoesNfce.WidthPercent := 100.000000000000000000;
    SetEvent(btnCarregarConfiguracoesNfce, Self, 'OnClick', 'btnCarregarConfiguracoesNfceClick');
    btnExportarExcelConfigNfce.SetParentComponent(Self);
    btnExportarExcelConfigNfce.Name := 'btnExportarExcelConfigNfce';
    btnExportarExcelConfigNfce.Left := 997;
    btnExportarExcelConfigNfce.Top := 725;
    btnExportarExcelConfigNfce.Width := 83;
    btnExportarExcelConfigNfce.Height := 25;
    btnExportarExcelConfigNfce.Caption := 'Exportar Excel';
    btnExportarExcelConfigNfce.ChildOrder := 16;
    btnExportarExcelConfigNfce.Enabled := False;
    btnExportarExcelConfigNfce.HeightPercent := 100.000000000000000000;
    btnExportarExcelConfigNfce.TabStop := False;
    btnExportarExcelConfigNfce.WidthPercent := 100.000000000000000000;
    SetEvent(btnExportarExcelConfigNfce, Self, 'OnClick', 'btnExportarExcelConfigNfceClick');
    btnConfigNfce.SetParentComponent(Self);
    btnConfigNfce.Name := 'btnConfigNfce';
    btnConfigNfce.Left := 992;
    btnConfigNfce.Top := 667;
    btnConfigNfce.Width := 82;
    btnConfigNfce.Height := 25;
    btnConfigNfce.Caption := 'NFCe';
    btnConfigNfce.ChildOrder := 16;
    btnConfigNfce.HeightPercent := 100.000000000000000000;
    btnConfigNfce.TabStop := False;
    btnConfigNfce.WidthPercent := 100.000000000000000000;
    SetEvent(btnConfigNfce, Self, 'OnClick', 'btnConfigNfceClick');
    eddata_ping_madrugada.SetParentComponent(Self);
    eddata_ping_madrugada.Name := 'eddata_ping_madrugada';
    eddata_ping_madrugada.Left := 316;
    eddata_ping_madrugada.Top := 101;
    eddata_ping_madrugada.Width := 100;
    eddata_ping_madrugada.Height := 21;
    eddata_ping_madrugada.ChildOrder := 142;
    eddata_ping_madrugada.Enabled := False;
    eddata_ping_madrugada.HeightPercent := 100.000000000000000000;
    eddata_ping_madrugada.TabOrder := 14;
    eddata_ping_madrugada.Text := 'eddata_ping_madrugada';
    eddata_ping_madrugada.WidthPercent := 100.000000000000000000;
    eddata_ping_madrugada.DataField := 'data_ping_madrugada';
    eddata_ping_madrugada.DataSource := DataSource;
    edqtde_dias_servidor_ligado.SetParentComponent(Self);
    edqtde_dias_servidor_ligado.Name := 'edqtde_dias_servidor_ligado';
    edqtde_dias_servidor_ligado.Left := 316;
    edqtde_dias_servidor_ligado.Top := 290;
    edqtde_dias_servidor_ligado.Width := 100;
    edqtde_dias_servidor_ligado.Height := 21;
    edqtde_dias_servidor_ligado.ChildOrder := 144;
    edqtde_dias_servidor_ligado.Enabled := False;
    edqtde_dias_servidor_ligado.HeightPercent := 100.000000000000000000;
    edqtde_dias_servidor_ligado.TabOrder := 14;
    edqtde_dias_servidor_ligado.Text := 'edqtde_dias_servidor_ligado';
    edqtde_dias_servidor_ligado.WidthPercent := 100.000000000000000000;
    edqtde_dias_servidor_ligado.DataField := 'qtde_dias_servidor_ligado';
    edqtde_dias_servidor_ligado.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := AliadoDataset;
    DataSource.Left := 536;
    DataSource.Top := 288;
    AliadoDataset.SetParentComponent(Self);
    AliadoDataset.Name := 'AliadoDataset';
    AliadoDataset.AfterApplyUpdates := AliadoDatasetAfterApplyUpdates;
    AliadoDataset.AfterOpen := AliadoDatasetAfterOpen;
    AliadoDataset.EntitySetName := 'Aliado';
    AliadoDataset.Connection := DMConnection.ApiConnection;
    AliadoDataset.Left := 392;
    AliadoDataset.Top := 288;
    AliadoDatasetId.SetParentComponent(AliadoDataset);
    AliadoDatasetId.Name := 'AliadoDatasetId';
    AliadoDatasetId.FieldName := 'Id';
    AliadoDatasetId.Required := True;
    AliadoDatasetRazao_Social.SetParentComponent(AliadoDataset);
    AliadoDatasetRazao_Social.Name := 'AliadoDatasetRazao_Social';
    AliadoDatasetRazao_Social.FieldName := 'Razao_Social';
    AliadoDatasetRazao_Social.Required := True;
    AliadoDatasetRazao_Social.Size := 255;
    AliadoDatasetNome_Fantasia.SetParentComponent(AliadoDataset);
    AliadoDatasetNome_Fantasia.Name := 'AliadoDatasetNome_Fantasia';
    AliadoDatasetNome_Fantasia.FieldName := 'Nome_Fantasia';
    AliadoDatasetNome_Fantasia.Required := True;
    AliadoDatasetNome_Fantasia.Size := 255;
    AliadoDatasetCNPJ.SetParentComponent(AliadoDataset);
    AliadoDatasetCNPJ.Name := 'AliadoDatasetCNPJ';
    AliadoDatasetCNPJ.FieldName := 'CNPJ';
    AliadoDatasetCNPJ.Required := True;
    SetEvent(AliadoDatasetCNPJ, Self, 'OnGetText', 'AliadoDatasetCNPJGetText');
    AliadoDatasetCNPJ.Size := 255;
    AliadoDatasetCodigo_Interno.SetParentComponent(AliadoDataset);
    AliadoDatasetCodigo_Interno.Name := 'AliadoDatasetCodigo_Interno';
    AliadoDatasetCodigo_Interno.FieldName := 'Codigo_Interno';
    AliadoDatasetStatus.SetParentComponent(AliadoDataset);
    AliadoDatasetStatus.Name := 'AliadoDatasetStatus';
    AliadoDatasetStatus.FieldName := 'Status';
    AliadoDatasetStatus.Required := True;
    SetEvent(AliadoDatasetStatus, Self, 'OnGetText', 'AliadoDatasetStatusGetText');
    AliadoDatasetSegmento_ID.SetParentComponent(AliadoDataset);
    AliadoDatasetSegmento_ID.Name := 'AliadoDatasetSegmento_ID';
    AliadoDatasetSegmento_ID.FieldName := 'Segmento_ID';
    AliadoDatasetTelefone_Principal.SetParentComponent(AliadoDataset);
    AliadoDatasetTelefone_Principal.Name := 'AliadoDatasetTelefone_Principal';
    AliadoDatasetTelefone_Principal.FieldName := 'Telefone_Principal';
    SetEvent(AliadoDatasetTelefone_Principal, Self, 'OnGetText', 'AliadoDatasetTelefone_PrincipalGetText');
    AliadoDatasetTelefone_Principal.Size := 255;
    AliadoDatasetCEP.SetParentComponent(AliadoDataset);
    AliadoDatasetCEP.Name := 'AliadoDatasetCEP';
    AliadoDatasetCEP.FieldName := 'CEP';
    SetEvent(AliadoDatasetCEP, Self, 'OnGetText', 'AliadoDatasetCEPGetText');
    AliadoDatasetCEP.Size := 255;
    AliadoDatasetEndereco.SetParentComponent(AliadoDataset);
    AliadoDatasetEndereco.Name := 'AliadoDatasetEndereco';
    AliadoDatasetEndereco.FieldName := 'Endereco';
    AliadoDatasetEndereco.Size := 255;
    AliadoDatasetEndereco_Numero.SetParentComponent(AliadoDataset);
    AliadoDatasetEndereco_Numero.Name := 'AliadoDatasetEndereco_Numero';
    AliadoDatasetEndereco_Numero.FieldName := 'Endereco_Numero';
    AliadoDatasetEndereco_Numero.Size := 255;
    AliadoDatasetBairro.SetParentComponent(AliadoDataset);
    AliadoDatasetBairro.Name := 'AliadoDatasetBairro';
    AliadoDatasetBairro.FieldName := 'Bairro';
    AliadoDatasetBairro.Size := 255;
    AliadoDatasetCidade_ID.SetParentComponent(AliadoDataset);
    AliadoDatasetCidade_ID.Name := 'AliadoDatasetCidade_ID';
    AliadoDatasetCidade_ID.FieldName := 'Cidade_ID';
    AliadoDatasetComplemento_Endereco.SetParentComponent(AliadoDataset);
    AliadoDatasetComplemento_Endereco.Name := 'AliadoDatasetComplemento_Endereco';
    AliadoDatasetComplemento_Endereco.FieldName := 'Complemento_Endereco';
    AliadoDatasetComplemento_Endereco.Size := 255;
    AliadoDatasetsincronizar_dados.SetParentComponent(AliadoDataset);
    AliadoDatasetsincronizar_dados.Name := 'AliadoDatasetsincronizar_dados';
    AliadoDatasetsincronizar_dados.FieldName := 'sincronizar_dados';
    AliadoDatasetparceiro_id.SetParentComponent(AliadoDataset);
    AliadoDatasetparceiro_id.Name := 'AliadoDatasetparceiro_id';
    AliadoDatasetparceiro_id.FieldName := 'parceiro_id';
    AliadoDatasetExcluido.SetParentComponent(AliadoDataset);
    AliadoDatasetExcluido.Name := 'AliadoDatasetExcluido';
    AliadoDatasetExcluido.FieldName := 'Excluido';
    AliadoDatasetExcluido.Required := True;
    AliadoDatasetInclusao.SetParentComponent(AliadoDataset);
    AliadoDatasetInclusao.Name := 'AliadoDatasetInclusao';
    AliadoDatasetInclusao.FieldName := 'Inclusao';
    AliadoDatasetInclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    AliadoDatasetAlteracao.SetParentComponent(AliadoDataset);
    AliadoDatasetAlteracao.Name := 'AliadoDatasetAlteracao';
    AliadoDatasetAlteracao.FieldName := 'Alteracao';
    AliadoDatasetAlteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    AliadoDatasetExclusao.SetParentComponent(AliadoDataset);
    AliadoDatasetExclusao.Name := 'AliadoDatasetExclusao';
    AliadoDatasetExclusao.FieldName := 'Exclusao';
    AliadoDatasetExclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    AliadoDatasetCadastro.SetParentComponent(AliadoDataset);
    AliadoDatasetCadastro.Name := 'AliadoDatasetCadastro';
    AliadoDatasetCadastro.FieldName := 'Cadastro';
    AliadoDatasetCadastro.DisplayFormat := 'dd/mm/yyyy';
    AliadoDatasetobservacoes.SetParentComponent(AliadoDataset);
    AliadoDatasetobservacoes.Name := 'AliadoDatasetobservacoes';
    AliadoDatasetobservacoes.FieldName := 'observacoes';
    AliadoDatasetobservacoes.Size := 255;
    AliadoDatasetcontrole_interno.SetParentComponent(AliadoDataset);
    AliadoDatasetcontrole_interno.Name := 'AliadoDatasetcontrole_interno';
    AliadoDatasetcontrole_interno.FieldName := 'controle_interno';
    AliadoDatasetcontrole_interno.Size := 255;
    AliadoDatasetMRR.SetParentComponent(AliadoDataset);
    AliadoDatasetMRR.Name := 'AliadoDatasetMRR';
    AliadoDatasetMRR.FieldName := 'MRR';
    AliadoDatasetemail_principal.SetParentComponent(AliadoDataset);
    AliadoDatasetemail_principal.Name := 'AliadoDatasetemail_principal';
    AliadoDatasetemail_principal.FieldName := 'email_principal';
    AliadoDatasetemail_principal.Size := 255;
    AliadoDatasetsegmentoNome.SetParentComponent(AliadoDataset);
    AliadoDatasetsegmentoNome.Name := 'AliadoDatasetsegmentoNome';
    AliadoDatasetsegmentoNome.FieldKind := fkCalculated;
    AliadoDatasetsegmentoNome.FieldName := 'segmento.Nome';
    SetEvent(AliadoDatasetsegmentoNome, Self, 'OnGetText', 'AliadoDatasetsegmentoNomeGetText');
    AliadoDatasetsegmentoNome.Calculated := True;
    AliadoDatasetcidadeNome.SetParentComponent(AliadoDataset);
    AliadoDatasetcidadeNome.Name := 'AliadoDatasetcidadeNome';
    AliadoDatasetcidadeNome.FieldKind := fkCalculated;
    AliadoDatasetcidadeNome.FieldName := 'cidade.Nome';
    SetEvent(AliadoDatasetcidadeNome, Self, 'OnGetText', 'AliadoDatasetcidadeNomeGetText');
    AliadoDatasetcidadeNome.Calculated := True;
    AliadoDatasetcidadeufSigla.SetParentComponent(AliadoDataset);
    AliadoDatasetcidadeufSigla.Name := 'AliadoDatasetcidadeufSigla';
    AliadoDatasetcidadeufSigla.FieldKind := fkCalculated;
    AliadoDatasetcidadeufSigla.FieldName := 'cidade.uf.Sigla';
    AliadoDatasetcidadeufSigla.Calculated := True;
    AliadoDatasetparceironome.SetParentComponent(AliadoDataset);
    AliadoDatasetparceironome.Name := 'AliadoDatasetparceironome';
    AliadoDatasetparceironome.FieldName := 'parceiro.nome';
    AliadoDatasetlogo_base64.SetParentComponent(AliadoDataset);
    AliadoDatasetlogo_base64.Name := 'AliadoDatasetlogo_base64';
    AliadoDatasetlogo_base64.FieldName := 'logo_base64';
    AliadoDatasetlogo_base64.Size := 255;
    AliadoDatasettelefone_whatsapp.SetParentComponent(AliadoDataset);
    AliadoDatasettelefone_whatsapp.Name := 'AliadoDatasettelefone_whatsapp';
    AliadoDatasettelefone_whatsapp.FieldName := 'telefone_whatsapp';
    AliadoDatasettelefone_whatsapp.Size := 255;
    AliadoDatasetconfig_windows.SetParentComponent(AliadoDataset);
    AliadoDatasetconfig_windows.Name := 'AliadoDatasetconfig_windows';
    AliadoDatasetconfig_windows.FieldName := 'config_windows';
    SetEvent(AliadoDatasetconfig_windows, Self, 'OnGetText', 'AliadoDatasetconfig_windowsGetText');
    AliadoDatasetconfig_windows.Size := 255;
    AliadoDatasetdata_cancelamento.SetParentComponent(AliadoDataset);
    AliadoDatasetdata_cancelamento.Name := 'AliadoDatasetdata_cancelamento';
    AliadoDatasetdata_cancelamento.FieldName := 'data_cancelamento';
    AliadoDatasetdata_cancelamento.DisplayFormat := 'dd/mm/yyyy';
    AliadoDatasettempo_contrato.SetParentComponent(AliadoDataset);
    AliadoDatasettempo_contrato.Name := 'AliadoDatasettempo_contrato';
    AliadoDatasettempo_contrato.FieldName := 'tempo_contrato';
    AliadoDatasettempo_contrato.Size := 255;
    AliadoDatasetdata_ping_madrugada.SetParentComponent(AliadoDataset);
    AliadoDatasetdata_ping_madrugada.Name := 'AliadoDatasetdata_ping_madrugada';
    AliadoDatasetdata_ping_madrugada.FieldName := 'data_ping_madrugada';
    AliadoDatasetdata_ping_madrugada.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    AliadoDatasetqtde_dias_servidor_ligado.SetParentComponent(AliadoDataset);
    AliadoDatasetqtde_dias_servidor_ligado.Name := 'AliadoDatasetqtde_dias_servidor_ligado';
    AliadoDatasetqtde_dias_servidor_ligado.FieldName := 'qtde_dias_servidor_ligado';
    XDataClientAliadoGet.SetParentComponent(Self);
    XDataClientAliadoGet.Name := 'XDataClientAliadoGet';
    XDataClientAliadoGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientAliadoGet, Self, 'OnLoad', 'XDataClientAliadoGetLoad');
    XDataClientAliadoGet.Left := 472;
    XDataClientAliadoGet.Top := 288;
    cdsLogs.SetParentComponent(Self);
    cdsLogs.Name := 'cdsLogs';
    cdsLogs.EntitySetName := 'Sincronizacao_Logs';
    cdsLogs.Connection := DMConnection.ApiConnection;
    cdsLogs.Left := 696;
    cdsLogs.Top := 436;
    cdsLogsid.SetParentComponent(cdsLogs);
    cdsLogsid.Name := 'cdsLogsid';
    cdsLogsid.FieldName := 'id';
    cdsLogsid.Required := True;
    cdsLogsaliado_id.SetParentComponent(cdsLogs);
    cdsLogsaliado_id.Name := 'cdsLogsaliado_id';
    cdsLogsaliado_id.FieldName := 'aliado_id';
    cdsLogsaliado_id.Required := True;
    cdsLogsdata_base_id.SetParentComponent(cdsLogs);
    cdsLogsdata_base_id.Name := 'cdsLogsdata_base_id';
    cdsLogsdata_base_id.FieldName := 'data_base_id';
    cdsLogsdata_base_id.Required := True;
    cdsLogssincronizacao_service_id.SetParentComponent(cdsLogs);
    cdsLogssincronizacao_service_id.Name := 'cdsLogssincronizacao_service_id';
    cdsLogssincronizacao_service_id.FieldName := 'sincronizacao_service_id';
    cdsLogssincronizacao_service_id.Required := True;
    cdsLogsultima_sincronizacao.SetParentComponent(cdsLogs);
    cdsLogsultima_sincronizacao.Name := 'cdsLogsultima_sincronizacao';
    cdsLogsultima_sincronizacao.FieldName := 'ultima_sincronizacao';
    cdsLogsultima_sincronizacao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    cdsLogsinicio_sincronizacao.SetParentComponent(cdsLogs);
    cdsLogsinicio_sincronizacao.Name := 'cdsLogsinicio_sincronizacao';
    cdsLogsinicio_sincronizacao.FieldName := 'inicio_sincronizacao';
    cdsLogsinicio_sincronizacao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    cdsLogsfim_sincronizacao.SetParentComponent(cdsLogs);
    cdsLogsfim_sincronizacao.Name := 'cdsLogsfim_sincronizacao';
    cdsLogsfim_sincronizacao.FieldName := 'fim_sincronizacao';
    cdsLogsfim_sincronizacao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    cdsLogssincronizacao_erro.SetParentComponent(cdsLogs);
    cdsLogssincronizacao_erro.Name := 'cdsLogssincronizacao_erro';
    cdsLogssincronizacao_erro.FieldName := 'sincronizacao_erro';
    cdsLogssincronizacao_erro.Size := 65536;
    cdsLogsinclusao.SetParentComponent(cdsLogs);
    cdsLogsinclusao.Name := 'cdsLogsinclusao';
    cdsLogsinclusao.FieldName := 'inclusao';
    cdsLogsinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    cdsLogsalteracao.SetParentComponent(cdsLogs);
    cdsLogsalteracao.Name := 'cdsLogsalteracao';
    cdsLogsalteracao.FieldName := 'alteracao';
    cdsLogsalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    cdsLogsultima_verificacao_retaguarda.SetParentComponent(cdsLogs);
    cdsLogsultima_verificacao_retaguarda.Name := 'cdsLogsultima_verificacao_retaguarda';
    cdsLogsultima_verificacao_retaguarda.FieldName := 'ultima_verificacao_retaguarda';
    cdsLogsultima_verificacao_retaguarda.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    cdsLogsversao_client.SetParentComponent(cdsLogs);
    cdsLogsversao_client.Name := 'cdsLogsversao_client';
    cdsLogsversao_client.FieldName := 'versao_client';
    cdsLogsversao_client.Size := 255;
    cdsLogssincronizacao_servicerota.SetParentComponent(cdsLogs);
    cdsLogssincronizacao_servicerota.Name := 'cdsLogssincronizacao_servicerota';
    cdsLogssincronizacao_servicerota.FieldKind := fkCalculated;
    cdsLogssincronizacao_servicerota.FieldName := 'sincronizacao_service.rota';
    cdsLogssincronizacao_servicerota.Calculated := True;
    dtsLogs.SetParentComponent(Self);
    dtsLogs.Name := 'dtsLogs';
    dtsLogs.DataSet := cdsLogs;
    dtsLogs.Left := 744;
    dtsLogs.Top := 444;
    tmrConsultaLogs.SetParentComponent(Self);
    tmrConsultaLogs.Name := 'tmrConsultaLogs';
    tmrConsultaLogs.Enabled := False;
    SetEvent(tmrConsultaLogs, Self, 'OnTimer', 'tmrConsultaLogsTimer');
    tmrConsultaLogs.Left := 766;
    tmrConsultaLogs.Top := 493;
    cdsSincronizacao.SetParentComponent(Self);
    cdsSincronizacao.Name := 'cdsSincronizacao';
    cdsSincronizacao.AfterApplyUpdates := cdsSincronizacaoAfterApplyUpdates;
    cdsSincronizacao.AfterOpen := cdsSincronizacaoAfterOpen;
    cdsSincronizacao.EntitySetName := 'Sincronizacao_Aliados';
    cdsSincronizacao.Connection := DMConnection.ApiConnection;
    cdsSincronizacao.QueryTop := 200;
    cdsSincronizacao.Left := 44;
    cdsSincronizacao.Top := 744;
    cdsSincronizacaoid.SetParentComponent(cdsSincronizacao);
    cdsSincronizacaoid.Name := 'cdsSincronizacaoid';
    cdsSincronizacaoid.FieldName := 'id';
    cdsSincronizacaoid.Required := True;
    cdsSincronizacaoaliado_id.SetParentComponent(cdsSincronizacao);
    cdsSincronizacaoaliado_id.Name := 'cdsSincronizacaoaliado_id';
    cdsSincronizacaoaliado_id.FieldName := 'aliado_id';
    cdsSincronizacaoaliado_id.Required := True;
    cdsSincronizacaosincronizacao_servicerota.SetParentComponent(cdsSincronizacao);
    cdsSincronizacaosincronizacao_servicerota.Name := 'cdsSincronizacaosincronizacao_servicerota';
    cdsSincronizacaosincronizacao_servicerota.FieldKind := fkCalculated;
    cdsSincronizacaosincronizacao_servicerota.FieldName := 'sincronizacao_service.rota';
    cdsSincronizacaosincronizacao_servicerota.Calculated := True;
    cdsSincronizacaosincronizar_dados.SetParentComponent(cdsSincronizacao);
    cdsSincronizacaosincronizar_dados.Name := 'cdsSincronizacaosincronizar_dados';
    cdsSincronizacaosincronizar_dados.FieldName := 'sincronizar_dados';
    cdsSincronizacaosincronizar_dados.Required := True;
    cdsCertificado.SetParentComponent(Self);
    cdsCertificado.Name := 'cdsCertificado';
    cdsCertificado.AfterApplyUpdates := cdsCertificadoAfterApplyUpdates;
    cdsCertificado.AfterOpen := cdsCertificadoAfterOpen;
    cdsCertificado.EntitySetName := 'Certificados';
    cdsCertificado.Connection := DMConnection.ApiConnection;
    cdsCertificado.Left := 864;
    cdsCertificado.Top := 184;
    cdsCertificadoid.SetParentComponent(cdsCertificado);
    cdsCertificadoid.Name := 'cdsCertificadoid';
    cdsCertificadoid.FieldName := 'id';
    cdsCertificadonumero_serie.SetParentComponent(cdsCertificado);
    cdsCertificadonumero_serie.Name := 'cdsCertificadonumero_serie';
    cdsCertificadonumero_serie.FieldName := 'numero_serie';
    cdsCertificadonumero_serie.Size := 255;
    cdsCertificadodata_vencimento.SetParentComponent(cdsCertificado);
    cdsCertificadodata_vencimento.Name := 'cdsCertificadodata_vencimento';
    cdsCertificadodata_vencimento.FieldName := 'data_vencimento';
    cdsCertificadodata_vencimento.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    cdsCertificadosenha.SetParentComponent(cdsCertificado);
    cdsCertificadosenha.Name := 'cdsCertificadosenha';
    cdsCertificadosenha.FieldName := 'senha';
    cdsCertificadosenha.Size := 255;
    cdsCertificadocertificado_s3.SetParentComponent(cdsCertificado);
    cdsCertificadocertificado_s3.Name := 'cdsCertificadocertificado_s3';
    cdsCertificadocertificado_s3.FieldName := 'certificado_s3';
    cdsCertificadocertificado_s3.Size := 65536;
    cdsCertificadoinclusao.SetParentComponent(cdsCertificado);
    cdsCertificadoinclusao.Name := 'cdsCertificadoinclusao';
    cdsCertificadoinclusao.FieldName := 'inclusao';
    cdsCertificadoinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    cdsCertificadoalteracao.SetParentComponent(cdsCertificado);
    cdsCertificadoalteracao.Name := 'cdsCertificadoalteracao';
    cdsCertificadoalteracao.FieldName := 'alteracao';
    cdsCertificadoalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    cdsCertificadoaliado_id.SetParentComponent(cdsCertificado);
    cdsCertificadoaliado_id.Name := 'cdsCertificadoaliado_id';
    cdsCertificadoaliado_id.FieldName := 'aliado_id';
    dtsCertificado.SetParentComponent(Self);
    dtsCertificado.Name := 'dtsCertificado';
    dtsCertificado.DataSet := cdsCertificado;
    dtsCertificado.Left := 936;
    dtsCertificado.Top := 184;
    tmrConsultaDataBase.SetParentComponent(Self);
    tmrConsultaDataBase.Name := 'tmrConsultaDataBase';
    tmrConsultaDataBase.Enabled := False;
    SetEvent(tmrConsultaDataBase, Self, 'OnTimer', 'tmrConsultaDataBaseTimer');
    tmrConsultaDataBase.Left := 184;
    tmrConsultaDataBase.Top := 456;
    cdsDataBase.SetParentComponent(Self);
    cdsDataBase.Name := 'cdsDataBase';
    cdsDataBase.EntitySetName := 'data_base';
    cdsDataBase.Connection := DMConnection.ApiConnection;
    cdsDataBase.Left := 25;
    cdsDataBase.Top := 468;
    cdsDataBaseid.SetParentComponent(cdsDataBase);
    cdsDataBaseid.Name := 'cdsDataBaseid';
    cdsDataBaseid.FieldName := 'id';
    cdsDataBaseid.Required := True;
    cdsDataBasetoken.SetParentComponent(cdsDataBase);
    cdsDataBasetoken.Name := 'cdsDataBasetoken';
    cdsDataBasetoken.FieldName := 'token';
    cdsDataBasetoken.Required := True;
    cdsDataBasetoken.Size := 256;
    cdsDataBasefiscal.SetParentComponent(cdsDataBase);
    cdsDataBasefiscal.Name := 'cdsDataBasefiscal';
    cdsDataBasefiscal.FieldName := 'fiscal';
    cdsDataBasefiscal.Required := True;
    cdsDataBaseexcluido.SetParentComponent(cdsDataBase);
    cdsDataBaseexcluido.Name := 'cdsDataBaseexcluido';
    cdsDataBaseexcluido.FieldName := 'excluido';
    cdsDataBaseinclusao.SetParentComponent(cdsDataBase);
    cdsDataBaseinclusao.Name := 'cdsDataBaseinclusao';
    cdsDataBaseinclusao.FieldName := 'inclusao';
    cdsDataBaseinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    cdsDataBasealteracao.SetParentComponent(cdsDataBase);
    cdsDataBasealteracao.Name := 'cdsDataBasealteracao';
    cdsDataBasealteracao.FieldName := 'alteracao';
    cdsDataBasealteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    cdsDataBaseexclusao.SetParentComponent(cdsDataBase);
    cdsDataBaseexclusao.Name := 'cdsDataBaseexclusao';
    cdsDataBaseexclusao.FieldName := 'exclusao';
    cdsDataBaseexclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    cdsDataBasenome_fantasia.SetParentComponent(cdsDataBase);
    cdsDataBasenome_fantasia.Name := 'cdsDataBasenome_fantasia';
    cdsDataBasenome_fantasia.FieldName := 'nome_fantasia';
    cdsDataBasenome_fantasia.Size := 255;
    cdsDataBasehost.SetParentComponent(cdsDataBase);
    cdsDataBasehost.Name := 'cdsDataBasehost';
    cdsDataBasehost.FieldName := 'host';
    cdsDataBasehost.Size := 255;
    cdsDataBasepath.SetParentComponent(cdsDataBase);
    cdsDataBasepath.Name := 'cdsDataBasepath';
    cdsDataBasepath.FieldName := 'path';
    cdsDataBasepath.Size := 255;
    cdsDataBasedata_base_multiempresa.SetParentComponent(cdsDataBase);
    cdsDataBasedata_base_multiempresa.Name := 'cdsDataBasedata_base_multiempresa';
    cdsDataBasedata_base_multiempresa.FieldName := 'data_base_multiempresa';
    cdsDataBasedata_base_empresa_destino.SetParentComponent(cdsDataBase);
    cdsDataBasedata_base_empresa_destino.Name := 'cdsDataBasedata_base_empresa_destino';
    cdsDataBasedata_base_empresa_destino.FieldName := 'data_base_empresa_destino';
    cdsDataBaseversao_atual.SetParentComponent(cdsDataBase);
    cdsDataBaseversao_atual.Name := 'cdsDataBaseversao_atual';
    cdsDataBaseversao_atual.FieldName := 'versao_atual';
    cdsDataBaseversao_atual.Size := 255;
    cdsDataBaseversao_pendente.SetParentComponent(cdsDataBase);
    cdsDataBaseversao_pendente.Name := 'cdsDataBaseversao_pendente';
    cdsDataBaseversao_pendente.FieldName := 'versao_pendente';
    cdsDataBaseversao_pendente.Size := 255;
    cdsDataBaseregime_contabil.SetParentComponent(cdsDataBase);
    cdsDataBaseregime_contabil.Name := 'cdsDataBaseregime_contabil';
    cdsDataBaseregime_contabil.FieldName := 'regime_contabil';
    cdsDataBaseregime_contabil.Size := 255;
    cdsDataBasedivulgar_promocoes.SetParentComponent(cdsDataBase);
    cdsDataBasedivulgar_promocoes.Name := 'cdsDataBasedivulgar_promocoes';
    cdsDataBasedivulgar_promocoes.FieldName := 'divulgar_promocoes';
    cdsDataBaseassociar_produtos.SetParentComponent(cdsDataBase);
    cdsDataBaseassociar_produtos.Name := 'cdsDataBaseassociar_produtos';
    cdsDataBaseassociar_produtos.FieldName := 'associar_produtos';
    cdsDataBasecrt.SetParentComponent(cdsDataBase);
    cdsDataBasecrt.Name := 'cdsDataBasecrt';
    cdsDataBasecrt.FieldName := 'crt';
    SetEvent(cdsDataBasecrt, Self, 'OnGetText', 'cdsDataBasecrtGetText');
    cdsDataBasecontadornome.SetParentComponent(cdsDataBase);
    cdsDataBasecontadornome.Name := 'cdsDataBasecontadornome';
    cdsDataBasecontadornome.FieldName := 'contador.nome';
    dtsDataBase.SetParentComponent(Self);
    dtsDataBase.Name := 'dtsDataBase';
    dtsDataBase.DataSet := cdsDataBase;
    dtsDataBase.Left := 89;
    dtsDataBase.Top := 468;
    cdsModulosAliado.SetParentComponent(Self);
    cdsModulosAliado.Name := 'cdsModulosAliado';
    cdsModulosAliado.AfterOpen := cdsModulosAliadoAfterOpen;
    cdsModulosAliado.EntitySetName := 'Modulos_Data_Base';
    cdsModulosAliado.Connection := DMConnection.ApiConnection;
    cdsModulosAliado.QueryTop := 200;
    cdsModulosAliado.Left := 152;
    cdsModulosAliado.Top := 472;
    cdsModulosAliadoid.SetParentComponent(cdsModulosAliado);
    cdsModulosAliadoid.Name := 'cdsModulosAliadoid';
    cdsModulosAliadoid.FieldName := 'id';
    cdsModulosAliadoid.Required := True;
    cdsModulosAliadodata_base_id.SetParentComponent(cdsModulosAliado);
    cdsModulosAliadodata_base_id.Name := 'cdsModulosAliadodata_base_id';
    cdsModulosAliadodata_base_id.FieldName := 'data_base_id';
    cdsModulosAliadodata_base_id.Required := True;
    cdsModulosAliadomodulo_id.SetParentComponent(cdsModulosAliado);
    cdsModulosAliadomodulo_id.Name := 'cdsModulosAliadomodulo_id';
    cdsModulosAliadomodulo_id.FieldName := 'modulo_id';
    cdsModulosAliadomodulo_id.Required := True;
    XDataClientRecursos.SetParentComponent(Self);
    XDataClientRecursos.Name := 'XDataClientRecursos';
    XDataClientRecursos.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientRecursos, Self, 'OnLoad', 'XDataClientRecursosLoad');
    SetEvent(XDataClientRecursos, Self, 'OnError', 'XDataClientRecursosError');
    XDataClientRecursos.Left := 608;
    XDataClientRecursos.Top := 16;
    XDataClientDataBase.SetParentComponent(Self);
    XDataClientDataBase.Name := 'XDataClientDataBase';
    XDataClientDataBase.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientDataBase, Self, 'OnLoad', 'XDataClientDataBaseLoad');
    SetEvent(XDataClientDataBase, Self, 'OnError', 'XDataClientDataBaseError');
    XDataClientDataBase.Left := 229;
    XDataClientDataBase.Top := 400;
    XDataWebClientModulosRetaguarda.SetParentComponent(Self);
    XDataWebClientModulosRetaguarda.Name := 'XDataWebClientModulosRetaguarda';
    XDataWebClientModulosRetaguarda.Connection := DMConnection.ApiConnection;
    SetEvent(XDataWebClientModulosRetaguarda, Self, 'OnLoad', 'XDataWebClientModulosRetaguardaLoad');
    SetEvent(XDataWebClientModulosRetaguarda, Self, 'OnError', 'XDataWebClientModulosRetaguardaError');
    XDataWebClientModulosRetaguarda.Left := 77;
    XDataWebClientModulosRetaguarda.Top := 400;
    cdsFaturamento.SetParentComponent(Self);
    cdsFaturamento.Name := 'cdsFaturamento';
    cdsFaturamento.Left := 398;
    cdsFaturamento.Top := 384;
    cdsFaturamentoid.SetParentComponent(cdsFaturamento);
    cdsFaturamentoid.Name := 'cdsFaturamentoid';
    cdsFaturamentoid.FieldKind := fkCalculated;
    cdsFaturamentoid.FieldName := 'id';
    SetEvent(cdsFaturamentoid, Self, 'OnGetText', 'cdsFaturamentoidGetText');
    cdsFaturamentoid.Calculated := True;
    cdsFaturamentonome_fantasia.SetParentComponent(cdsFaturamento);
    cdsFaturamentonome_fantasia.Name := 'cdsFaturamentonome_fantasia';
    cdsFaturamentonome_fantasia.FieldKind := fkCalculated;
    cdsFaturamentonome_fantasia.FieldName := 'nome_fantasia';
    cdsFaturamentonome_fantasia.Calculated := True;
    cdsFaturamentocnpj.SetParentComponent(cdsFaturamento);
    cdsFaturamentocnpj.Name := 'cdsFaturamentocnpj';
    cdsFaturamentocnpj.FieldKind := fkCalculated;
    cdsFaturamentocnpj.FieldName := 'cnpj';
    SetEvent(cdsFaturamentocnpj, Self, 'OnGetText', 'cdsFaturamentocnpjGetText');
    cdsFaturamentocnpj.Calculated := True;
    cdsFaturamentobanco_fiscal.SetParentComponent(cdsFaturamento);
    cdsFaturamentobanco_fiscal.Name := 'cdsFaturamentobanco_fiscal';
    cdsFaturamentobanco_fiscal.FieldKind := fkCalculated;
    cdsFaturamentobanco_fiscal.FieldName := 'banco_fiscal';
    SetEvent(cdsFaturamentobanco_fiscal, Self, 'OnGetText', 'cdsFaturamentobanco_fiscalGetText');
    cdsFaturamentobanco_fiscal.Calculated := True;
    cdsFaturamentomes_ano.SetParentComponent(cdsFaturamento);
    cdsFaturamentomes_ano.Name := 'cdsFaturamentomes_ano';
    cdsFaturamentomes_ano.FieldKind := fkCalculated;
    cdsFaturamentomes_ano.FieldName := 'mes_ano';
    SetEvent(cdsFaturamentomes_ano, Self, 'OnGetText', 'cdsFaturamentomes_anoGetText');
    cdsFaturamentomes_ano.Calculated := True;
    cdsFaturamentovalor_total_faturamento.SetParentComponent(cdsFaturamento);
    cdsFaturamentovalor_total_faturamento.Name := 'cdsFaturamentovalor_total_faturamento';
    cdsFaturamentovalor_total_faturamento.FieldKind := fkCalculated;
    cdsFaturamentovalor_total_faturamento.FieldName := 'valor_total_faturamento';
    cdsFaturamentovalor_total_faturamento.DisplayFormat := '#,##0.00';
    cdsFaturamentovalor_total_faturamento.Calculated := True;
    cdsFaturamentoquantidade.SetParentComponent(cdsFaturamento);
    cdsFaturamentoquantidade.Name := 'cdsFaturamentoquantidade';
    cdsFaturamentoquantidade.FieldKind := fkCalculated;
    cdsFaturamentoquantidade.FieldName := 'quantidade';
    SetEvent(cdsFaturamentoquantidade, Self, 'OnGetText', 'cdsFaturamentoquantidadeGetText');
    cdsFaturamentoquantidade.Calculated := True;
    cdsFaturamentoticket_medio.SetParentComponent(cdsFaturamento);
    cdsFaturamentoticket_medio.Name := 'cdsFaturamentoticket_medio';
    cdsFaturamentoticket_medio.FieldKind := fkCalculated;
    cdsFaturamentoticket_medio.FieldName := 'ticket_medio';
    cdsFaturamentoticket_medio.DisplayFormat := '#,##0.00';
    cdsFaturamentoticket_medio.Calculated := True;
    cdsFaturamentotipo_movimento.SetParentComponent(cdsFaturamento);
    cdsFaturamentotipo_movimento.Name := 'cdsFaturamentotipo_movimento';
    cdsFaturamentotipo_movimento.FieldKind := fkCalculated;
    cdsFaturamentotipo_movimento.FieldName := 'tipo_movimento';
    cdsFaturamentotipo_movimento.Calculated := True;
    cdsFaturamentoultima_atualizacao.SetParentComponent(cdsFaturamento);
    cdsFaturamentoultima_atualizacao.Name := 'cdsFaturamentoultima_atualizacao';
    cdsFaturamentoultima_atualizacao.FieldKind := fkCalculated;
    cdsFaturamentoultima_atualizacao.FieldName := 'ultima_atualizacao';
    cdsFaturamentoultima_atualizacao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    cdsFaturamentoultima_atualizacao.Calculated := True;
    cdsFaturamentocaminho_data_base.SetParentComponent(cdsFaturamento);
    cdsFaturamentocaminho_data_base.Name := 'cdsFaturamentocaminho_data_base';
    cdsFaturamentocaminho_data_base.FieldKind := fkCalculated;
    cdsFaturamentocaminho_data_base.FieldName := 'caminho_data_base';
    cdsFaturamentocaminho_data_base.Calculated := True;
    dtsFaturamento.SetParentComponent(Self);
    dtsFaturamento.Name := 'dtsFaturamento';
    dtsFaturamento.DataSet := cdsFaturamento;
    dtsFaturamento.Left := 326;
    dtsFaturamento.Top := 448;
    XDataWebClientFaturamento.SetParentComponent(Self);
    XDataWebClientFaturamento.Name := 'XDataWebClientFaturamento';
    XDataWebClientFaturamento.Connection := DMConnection.ApiConnection;
    SetEvent(XDataWebClientFaturamento, Self, 'OnLoad', 'XDataWebClientFaturamentoLoad');
    SetEvent(XDataWebClientFaturamento, Self, 'OnError', 'XDataWebClientFaturamentoError');
    XDataWebClientFaturamento.Left := 470;
    XDataWebClientFaturamento.Top := 392;
    cdsDataBaseFaturamento.SetParentComponent(Self);
    cdsDataBaseFaturamento.Name := 'cdsDataBaseFaturamento';
    cdsDataBaseFaturamento.AfterOpen := cdsDataBaseFaturamentoAfterOpen;
    cdsDataBaseFaturamento.EntitySetName := 'data_base';
    cdsDataBaseFaturamento.Connection := DMConnection.ApiConnection;
    cdsDataBaseFaturamento.Left := 310;
    cdsDataBaseFaturamento.Top := 384;
    cdsSincServRet.SetParentComponent(Self);
    cdsSincServRet.Name := 'cdsSincServRet';
    cdsSincServRet.EntitySetName := 'Sincronizacao_Servidor_Logs';
    cdsSincServRet.Connection := DMConnection.ApiConnection;
    cdsSincServRet.Left := 931;
    cdsSincServRet.Top := 420;
    cdsSincServRetaliado_id.SetParentComponent(cdsSincServRet);
    cdsSincServRetaliado_id.Name := 'cdsSincServRetaliado_id';
    cdsSincServRetaliado_id.FieldName := 'aliado_id';
    cdsSincServRetaliado_id.Required := True;
    cdsSincServRetdata_base_id.SetParentComponent(cdsSincServRet);
    cdsSincServRetdata_base_id.Name := 'cdsSincServRetdata_base_id';
    cdsSincServRetdata_base_id.FieldName := 'data_base_id';
    cdsSincServRetdata_base_id.Required := True;
    cdsSincServRetultima_sincronizacao.SetParentComponent(cdsSincServRet);
    cdsSincServRetultima_sincronizacao.Name := 'cdsSincServRetultima_sincronizacao';
    cdsSincServRetultima_sincronizacao.FieldName := 'ultima_sincronizacao';
    cdsSincServRetultima_sincronizacao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    cdsSincServRetultima_verificacao_retaguarda.SetParentComponent(cdsSincServRet);
    cdsSincServRetultima_verificacao_retaguarda.Name := 'cdsSincServRetultima_verificacao_retaguarda';
    cdsSincServRetultima_verificacao_retaguarda.FieldName := 'ultima_verificacao_retaguarda';
    cdsSincServRetultima_verificacao_retaguarda.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    cdsSincServRetversao_client.SetParentComponent(cdsSincServRet);
    cdsSincServRetversao_client.Name := 'cdsSincServRetversao_client';
    cdsSincServRetversao_client.FieldName := 'versao_client';
    cdsSincServRetversao_client.Size := 255;
    cdsSincServRetsincronizacao_erro.SetParentComponent(cdsSincServRet);
    cdsSincServRetsincronizacao_erro.Name := 'cdsSincServRetsincronizacao_erro';
    cdsSincServRetsincronizacao_erro.FieldName := 'sincronizacao_erro';
    SetEvent(cdsSincServRetsincronizacao_erro, Self, 'OnGetText', 'cdsSincServRetsincronizacao_erroGetText');
    cdsSincServRetsincronizacao_erro.BlobType := ftMemo;
    cdsSincServRetsincronizacao_erro.Size := 65536;
    cdsSincServRetinclusao.SetParentComponent(cdsSincServRet);
    cdsSincServRetinclusao.Name := 'cdsSincServRetinclusao';
    cdsSincServRetinclusao.FieldName := 'inclusao';
    cdsSincServRetinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    cdsSincServRetalteracao.SetParentComponent(cdsSincServRet);
    cdsSincServRetalteracao.Name := 'cdsSincServRetalteracao';
    cdsSincServRetalteracao.FieldName := 'alteracao';
    cdsSincServRetalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    cdsSincServRetsinc_servtabela_servidor.SetParentComponent(cdsSincServRet);
    cdsSincServRetsinc_servtabela_servidor.Name := 'cdsSincServRetsinc_servtabela_servidor';
    cdsSincServRetsinc_servtabela_servidor.FieldName := 'sinc_serv.tabela_servidor';
    dtsSincServRet.SetParentComponent(Self);
    dtsSincServRet.Name := 'dtsSincServRet';
    dtsSincServRet.DataSet := cdsSincServRet;
    dtsSincServRet.Left := 1019;
    dtsSincServRet.Top := 412;
    tmrSincServRet.SetParentComponent(Self);
    tmrSincServRet.Name := 'tmrSincServRet';
    tmrSincServRet.Enabled := False;
    SetEvent(tmrSincServRet, Self, 'OnTimer', 'tmrSincServRetTimer');
    tmrSincServRet.Left := 969;
    tmrSincServRet.Top := 485;
    cdsConfigRetaguarda.SetParentComponent(Self);
    cdsConfigRetaguarda.Name := 'cdsConfigRetaguarda';
    cdsConfigRetaguarda.AfterOpen := cdsConfigRetaguardaAfterOpen;
    cdsConfigRetaguarda.EntitySetName := 'Config_Retaguarda';
    cdsConfigRetaguarda.Connection := DMConnection.ApiConnection;
    cdsConfigRetaguarda.Left := 792;
    cdsConfigRetaguarda.Top := 732;
    cdsConfigRetaguardaconfiguracoes.SetParentComponent(cdsConfigRetaguarda);
    cdsConfigRetaguardaconfiguracoes.Name := 'cdsConfigRetaguardaconfiguracoes';
    cdsConfigRetaguardaconfiguracoes.FieldName := 'configuracoes';
    cdsConfigRetaguardaconfiguracoes.Size := 255;
    cdsConfigRetaguardaconfiguracao.SetParentComponent(cdsConfigRetaguarda);
    cdsConfigRetaguardaconfiguracao.Name := 'cdsConfigRetaguardaconfiguracao';
    cdsConfigRetaguardaconfiguracao.FieldName := 'configuracao';
    cdsConfigRetaguardaconfiguracao.Size := 255;
    cdsConfigNfce.SetParentComponent(Self);
    cdsConfigNfce.Name := 'cdsConfigNfce';
    cdsConfigNfce.AfterOpen := cdsConfigNfceAfterOpen;
    cdsConfigNfce.EntitySetName := 'Config_Pdvs';
    cdsConfigNfce.Connection := DMConnection.ApiConnection;
    cdsConfigNfce.Left := 968;
    cdsConfigNfce.Top := 732;
    cdsConfigNfceconfiguracoes.SetParentComponent(cdsConfigNfce);
    cdsConfigNfceconfiguracoes.Name := 'cdsConfigNfceconfiguracoes';
    cdsConfigNfceconfiguracoes.FieldName := 'configuracoes';
    cdsConfigNfceconfiguracoes.BlobType := ftMemo;
    cdsConfigNfceconfiguracoes.Size := 65536;
    cdsConfigNfcealiado_id.SetParentComponent(cdsConfigNfce);
    cdsConfigNfcealiado_id.Name := 'cdsConfigNfcealiado_id';
    cdsConfigNfcealiado_id.FieldName := 'aliado_id';
    cdsConfigNfcealiado_id.Required := True;
    cdsConfigNfceserie.SetParentComponent(cdsConfigNfce);
    cdsConfigNfceserie.Name := 'cdsConfigNfceserie';
    cdsConfigNfceserie.FieldName := 'serie';
    cdsConfigNfcecaixa.SetParentComponent(cdsConfigNfce);
    cdsConfigNfcecaixa.Name := 'cdsConfigNfcecaixa';
    cdsConfigNfcecaixa.FieldName := 'caixa';
  finally
    lbId.AfterLoadDFMValues;
    lbRazao_Social.AfterLoadDFMValues;
    lbNome_Fantasia.AfterLoadDFMValues;
    lbCNPJ.AfterLoadDFMValues;
    lbCodigo_Interno.AfterLoadDFMValues;
    lbStatus.AfterLoadDFMValues;
    lbsegmento_nome.AfterLoadDFMValues;
    lbTelefone_Principal.AfterLoadDFMValues;
    lbCEP.AfterLoadDFMValues;
    cidade_nome.AfterLoadDFMValues;
    lbparceiro_nome.AfterLoadDFMValues;
    lbExcluido.AfterLoadDFMValues;
    lbInclusao.AfterLoadDFMValues;
    lbAlteracao.AfterLoadDFMValues;
    lbExclusao.AfterLoadDFMValues;
    lbCadastro.AfterLoadDFMValues;
    lbObservacoes.AfterLoadDFMValues;
    lbEnderecoCompleto.AfterLoadDFMValues;
    lbPaginationInfoLogs.AfterLoadDFMValues;
    lbcertificado_id.AfterLoadDFMValues;
    lbnumero_serie.AfterLoadDFMValues;
    lbdata_vencimento.AfterLoadDFMValues;
    lbsenha.AfterLoadDFMValues;
    lbcertificado_s3.AfterLoadDFMValues;
    lbcertificado_inclusao.AfterLoadDFMValues;
    lbcertificado_alteracao.AfterLoadDFMValues;
    lbPaginationInfoDataBase.AfterLoadDFMValues;
    lblErroCertificado.AfterLoadDFMValues;
    imgLogoSelecionada.AfterLoadDFMValues;
    lbconfig_windows.AfterLoadDFMValues;
    lbPaginationInfoSincServRet.AfterLoadDFMValues;
    lblQuantidadeVendas.AfterLoadDFMValues;
    lblQuantidadeMeses.AfterLoadDFMValues;
    lblFaturamentoTotal.AfterLoadDFMValues;
    lblMediaFaturamento.AfterLoadDFMValues;
    lblMediaTicketMedio.AfterLoadDFMValues;
    lbdata_cancelamento.AfterLoadDFMValues;
    lbtempo_contrato.AfterLoadDFMValues;
    lbdata_ping_madrugada.AfterLoadDFMValues;
    lbqtde_dias_servidor_ligado.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    edId.AfterLoadDFMValues;
    edRazao_Social.AfterLoadDFMValues;
    edNome_Fantasia.AfterLoadDFMValues;
    edCNPJ.AfterLoadDFMValues;
    edCodigo_Interno.AfterLoadDFMValues;
    edStatus.AfterLoadDFMValues;
    edsegmento_nome.AfterLoadDFMValues;
    edTelefone_Principal.AfterLoadDFMValues;
    edCEP.AfterLoadDFMValues;
    edcidade_nome.AfterLoadDFMValues;
    edparceiro_nome.AfterLoadDFMValues;
    edInclusao.AfterLoadDFMValues;
    edAlteracao.AfterLoadDFMValues;
    edExclusao.AfterLoadDFMValues;
    edCadastro.AfterLoadDFMValues;
    edObservacoes.AfterLoadDFMValues;
    edEnderecoCompleto.AfterLoadDFMValues;
    cbxexcluido.AfterLoadDFMValues;
    pnlDadosAliado.AfterLoadDFMValues;
    pnlSincRetServ.AfterLoadDFMValues;
    tblLogs.AfterLoadDFMValues;
    cbPageSizeLogs.AfterLoadDFMValues;
    edSearchLogs.AfterLoadDFMValues;
    lcPaginatorLogs.AfterLoadDFMValues;
    btnLogsTab.AfterLoadDFMValues;
    div_checkbox_rotas.AfterLoadDFMValues;
    btnDadosTab.AfterLoadDFMValues;
    btnSincronizacaoTab.AfterLoadDFMValues;
    btnSalvarSincronizacao.AfterLoadDFMValues;
    edtSincronizacaoErro.AfterLoadDFMValues;
    pnlOutros.AfterLoadDFMValues;
    pnlCertificado.AfterLoadDFMValues;
    btnCertificado.AfterLoadDFMValues;
    edcertificado_id.AfterLoadDFMValues;
    ednumero_serie.AfterLoadDFMValues;
    eddata_vencimento.AfterLoadDFMValues;
    edsenha.AfterLoadDFMValues;
    edcertificado_s3.AfterLoadDFMValues;
    edcertificado_inclusao.AfterLoadDFMValues;
    edcertificado_alteracao.AfterLoadDFMValues;
    pnlTabelaDataBase.AfterLoadDFMValues;
    cbPageSizeDataBase.AfterLoadDFMValues;
    edSearchDataBase.AfterLoadDFMValues;
    lcPaginatorDataBase.AfterLoadDFMValues;
    btnDataBaseTab.AfterLoadDFMValues;
    tblDataBase.AfterLoadDFMValues;
    edtSincronizacaoObservacao.AfterLoadDFMValues;
    div_checkbox_modulos.AfterLoadDFMValues;
    btnImportarCertificado.AfterLoadDFMValues;
    wfpCertificado.AfterLoadDFMValues;
    btnUploadCertificado.AfterLoadDFMValues;
    edtCertificadoSenha.AfterLoadDFMValues;
    pnlRecursos.AfterLoadDFMValues;
    btnRecursosTab.AfterLoadDFMValues;
    div_checkbox_recursos.AfterLoadDFMValues;
    cbxSincronizarDados.AfterLoadDFMValues;
    btnSalvarRecursos.AfterLoadDFMValues;
    edtObservacaoEdit.AfterLoadDFMValues;
    wfpLogomarca.AfterLoadDFMValues;
    divRemoverImagem.AfterLoadDFMValues;
    edtParceiroNome.AfterLoadDFMValues;
    btnPesquisarParceiro.AfterLoadDFMValues;
    edtTelefoneWhatsappEdit.AfterLoadDFMValues;
    pnlFaturamento.AfterLoadDFMValues;
    tblFaturamento.AfterLoadDFMValues;
    btnFaturamentoTab.AfterLoadDFMValues;
    btnConsultarFaturamento.AfterLoadDFMValues;
    cbbDataBase.AfterLoadDFMValues;
    cbxMovimentaEstoque.AfterLoadDFMValues;
    cbxGeraFinanceiro.AfterLoadDFMValues;
    cbxSimplesFaturamento.AfterLoadDFMValues;
    cbxDevolucao.AfterLoadDFMValues;
    cbxTransferencia.AfterLoadDFMValues;
    cbxConciliacaoCupons.AfterLoadDFMValues;
    cbbPeriodoFaturamento.AfterLoadDFMValues;
    edtDataInicial.AfterLoadDFMValues;
    edtDataFinal.AfterLoadDFMValues;
    btnExportarExcel.AfterLoadDFMValues;
    cbbTipoFaturamento.AfterLoadDFMValues;
    edconfig_windows.AfterLoadDFMValues;
    btnConectarAliado.AfterLoadDFMValues;
    pnlSincServRet.AfterLoadDFMValues;
    cbbSincServRet.AfterLoadDFMValues;
    edtSincServRet.AfterLoadDFMValues;
    tblSincServRet.AfterLoadDFMValues;
    lcPaginatorSincServRet.AfterLoadDFMValues;
    btnSincRetServidor.AfterLoadDFMValues;
    btnSincServRetaguarda.AfterLoadDFMValues;
    eddata_cancelamento.AfterLoadDFMValues;
    edtempo_contrato.AfterLoadDFMValues;
    pnlConfiguracoesRet.AfterLoadDFMValues;
    btnConfigRetaguarda.AfterLoadDFMValues;
    cbbDataBaseConfigRetaguarda.AfterLoadDFMValues;
    btnCarregarConfiguracoes.AfterLoadDFMValues;
    btnExportarExcelConfigRetaguarda.AfterLoadDFMValues;
    searchConfig.AfterLoadDFMValues;
    searchConfigNfce.AfterLoadDFMValues;
    pnlConfiguracoesNfce.AfterLoadDFMValues;
    cbbSerieCaixaNfce.AfterLoadDFMValues;
    btnCarregarConfiguracoesNfce.AfterLoadDFMValues;
    btnExportarExcelConfigNfce.AfterLoadDFMValues;
    btnConfigNfce.AfterLoadDFMValues;
    eddata_ping_madrugada.AfterLoadDFMValues;
    edqtde_dias_servidor_ligado.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    AliadoDataset.AfterLoadDFMValues;
    AliadoDatasetId.AfterLoadDFMValues;
    AliadoDatasetRazao_Social.AfterLoadDFMValues;
    AliadoDatasetNome_Fantasia.AfterLoadDFMValues;
    AliadoDatasetCNPJ.AfterLoadDFMValues;
    AliadoDatasetCodigo_Interno.AfterLoadDFMValues;
    AliadoDatasetStatus.AfterLoadDFMValues;
    AliadoDatasetSegmento_ID.AfterLoadDFMValues;
    AliadoDatasetTelefone_Principal.AfterLoadDFMValues;
    AliadoDatasetCEP.AfterLoadDFMValues;
    AliadoDatasetEndereco.AfterLoadDFMValues;
    AliadoDatasetEndereco_Numero.AfterLoadDFMValues;
    AliadoDatasetBairro.AfterLoadDFMValues;
    AliadoDatasetCidade_ID.AfterLoadDFMValues;
    AliadoDatasetComplemento_Endereco.AfterLoadDFMValues;
    AliadoDatasetsincronizar_dados.AfterLoadDFMValues;
    AliadoDatasetparceiro_id.AfterLoadDFMValues;
    AliadoDatasetExcluido.AfterLoadDFMValues;
    AliadoDatasetInclusao.AfterLoadDFMValues;
    AliadoDatasetAlteracao.AfterLoadDFMValues;
    AliadoDatasetExclusao.AfterLoadDFMValues;
    AliadoDatasetCadastro.AfterLoadDFMValues;
    AliadoDatasetobservacoes.AfterLoadDFMValues;
    AliadoDatasetcontrole_interno.AfterLoadDFMValues;
    AliadoDatasetMRR.AfterLoadDFMValues;
    AliadoDatasetemail_principal.AfterLoadDFMValues;
    AliadoDatasetsegmentoNome.AfterLoadDFMValues;
    AliadoDatasetcidadeNome.AfterLoadDFMValues;
    AliadoDatasetcidadeufSigla.AfterLoadDFMValues;
    AliadoDatasetparceironome.AfterLoadDFMValues;
    AliadoDatasetlogo_base64.AfterLoadDFMValues;
    AliadoDatasettelefone_whatsapp.AfterLoadDFMValues;
    AliadoDatasetconfig_windows.AfterLoadDFMValues;
    AliadoDatasetdata_cancelamento.AfterLoadDFMValues;
    AliadoDatasettempo_contrato.AfterLoadDFMValues;
    AliadoDatasetdata_ping_madrugada.AfterLoadDFMValues;
    AliadoDatasetqtde_dias_servidor_ligado.AfterLoadDFMValues;
    XDataClientAliadoGet.AfterLoadDFMValues;
    cdsLogs.AfterLoadDFMValues;
    cdsLogsid.AfterLoadDFMValues;
    cdsLogsaliado_id.AfterLoadDFMValues;
    cdsLogsdata_base_id.AfterLoadDFMValues;
    cdsLogssincronizacao_service_id.AfterLoadDFMValues;
    cdsLogsultima_sincronizacao.AfterLoadDFMValues;
    cdsLogsinicio_sincronizacao.AfterLoadDFMValues;
    cdsLogsfim_sincronizacao.AfterLoadDFMValues;
    cdsLogssincronizacao_erro.AfterLoadDFMValues;
    cdsLogsinclusao.AfterLoadDFMValues;
    cdsLogsalteracao.AfterLoadDFMValues;
    cdsLogsultima_verificacao_retaguarda.AfterLoadDFMValues;
    cdsLogsversao_client.AfterLoadDFMValues;
    cdsLogssincronizacao_servicerota.AfterLoadDFMValues;
    dtsLogs.AfterLoadDFMValues;
    tmrConsultaLogs.AfterLoadDFMValues;
    cdsSincronizacao.AfterLoadDFMValues;
    cdsSincronizacaoid.AfterLoadDFMValues;
    cdsSincronizacaoaliado_id.AfterLoadDFMValues;
    cdsSincronizacaosincronizacao_servicerota.AfterLoadDFMValues;
    cdsSincronizacaosincronizar_dados.AfterLoadDFMValues;
    cdsCertificado.AfterLoadDFMValues;
    cdsCertificadoid.AfterLoadDFMValues;
    cdsCertificadonumero_serie.AfterLoadDFMValues;
    cdsCertificadodata_vencimento.AfterLoadDFMValues;
    cdsCertificadosenha.AfterLoadDFMValues;
    cdsCertificadocertificado_s3.AfterLoadDFMValues;
    cdsCertificadoinclusao.AfterLoadDFMValues;
    cdsCertificadoalteracao.AfterLoadDFMValues;
    cdsCertificadoaliado_id.AfterLoadDFMValues;
    dtsCertificado.AfterLoadDFMValues;
    tmrConsultaDataBase.AfterLoadDFMValues;
    cdsDataBase.AfterLoadDFMValues;
    cdsDataBaseid.AfterLoadDFMValues;
    cdsDataBasetoken.AfterLoadDFMValues;
    cdsDataBasefiscal.AfterLoadDFMValues;
    cdsDataBaseexcluido.AfterLoadDFMValues;
    cdsDataBaseinclusao.AfterLoadDFMValues;
    cdsDataBasealteracao.AfterLoadDFMValues;
    cdsDataBaseexclusao.AfterLoadDFMValues;
    cdsDataBasenome_fantasia.AfterLoadDFMValues;
    cdsDataBasehost.AfterLoadDFMValues;
    cdsDataBasepath.AfterLoadDFMValues;
    cdsDataBasedata_base_multiempresa.AfterLoadDFMValues;
    cdsDataBasedata_base_empresa_destino.AfterLoadDFMValues;
    cdsDataBaseversao_atual.AfterLoadDFMValues;
    cdsDataBaseversao_pendente.AfterLoadDFMValues;
    cdsDataBaseregime_contabil.AfterLoadDFMValues;
    cdsDataBasedivulgar_promocoes.AfterLoadDFMValues;
    cdsDataBaseassociar_produtos.AfterLoadDFMValues;
    cdsDataBasecrt.AfterLoadDFMValues;
    cdsDataBasecontadornome.AfterLoadDFMValues;
    dtsDataBase.AfterLoadDFMValues;
    cdsModulosAliado.AfterLoadDFMValues;
    cdsModulosAliadoid.AfterLoadDFMValues;
    cdsModulosAliadodata_base_id.AfterLoadDFMValues;
    cdsModulosAliadomodulo_id.AfterLoadDFMValues;
    XDataClientRecursos.AfterLoadDFMValues;
    XDataClientDataBase.AfterLoadDFMValues;
    XDataWebClientModulosRetaguarda.AfterLoadDFMValues;
    cdsFaturamento.AfterLoadDFMValues;
    cdsFaturamentoid.AfterLoadDFMValues;
    cdsFaturamentonome_fantasia.AfterLoadDFMValues;
    cdsFaturamentocnpj.AfterLoadDFMValues;
    cdsFaturamentobanco_fiscal.AfterLoadDFMValues;
    cdsFaturamentomes_ano.AfterLoadDFMValues;
    cdsFaturamentovalor_total_faturamento.AfterLoadDFMValues;
    cdsFaturamentoquantidade.AfterLoadDFMValues;
    cdsFaturamentoticket_medio.AfterLoadDFMValues;
    cdsFaturamentotipo_movimento.AfterLoadDFMValues;
    cdsFaturamentoultima_atualizacao.AfterLoadDFMValues;
    cdsFaturamentocaminho_data_base.AfterLoadDFMValues;
    dtsFaturamento.AfterLoadDFMValues;
    XDataWebClientFaturamento.AfterLoadDFMValues;
    cdsDataBaseFaturamento.AfterLoadDFMValues;
    cdsSincServRet.AfterLoadDFMValues;
    cdsSincServRetaliado_id.AfterLoadDFMValues;
    cdsSincServRetdata_base_id.AfterLoadDFMValues;
    cdsSincServRetultima_sincronizacao.AfterLoadDFMValues;
    cdsSincServRetultima_verificacao_retaguarda.AfterLoadDFMValues;
    cdsSincServRetversao_client.AfterLoadDFMValues;
    cdsSincServRetsincronizacao_erro.AfterLoadDFMValues;
    cdsSincServRetinclusao.AfterLoadDFMValues;
    cdsSincServRetalteracao.AfterLoadDFMValues;
    cdsSincServRetsinc_servtabela_servidor.AfterLoadDFMValues;
    dtsSincServRet.AfterLoadDFMValues;
    tmrSincServRet.AfterLoadDFMValues;
    cdsConfigRetaguarda.AfterLoadDFMValues;
    cdsConfigRetaguardaconfiguracoes.AfterLoadDFMValues;
    cdsConfigRetaguardaconfiguracao.AfterLoadDFMValues;
    cdsConfigNfce.AfterLoadDFMValues;
    cdsConfigNfceconfiguracoes.AfterLoadDFMValues;
    cdsConfigNfcealiado_id.AfterLoadDFMValues;
    cdsConfigNfceserie.AfterLoadDFMValues;
    cdsConfigNfcecaixa.AfterLoadDFMValues;
  end;
end;

end.
